<script setup>
import {nextTick, onBeforeMount, reactive, ref, computed} from "vue"
import YTCard from "@/components/YTCard/YTCard.vue";
import BoxUpload from "@/components/YTBoxUpload/index.vue"
import router from "@/router/index.js";
import {getRoute} from "@/hooks/getRoute.js";
import {
  addComboItem,
  addItem, addMallItem,
  editComboItem,
  editItem, editMallItem,
  itemDetail,
  listGoodsIgnoreTenant
} from "@/api/goods/goods.js";
import {categoryListAll} from "@/api/category/category.js";
import YTFormDialog from "@/components/YTFormDialog/index.vue"
import {goodsPropertyList, listPropertyGroup, propertyGroupItem} from "@/api/propertyGroup/propertyGroup.js";
import {addVirtualGoods, editVirtualGoods} from "@/api/virtualGoods/virtualGoods.js";
import YTAddress from "@/components/YTAddress/index.vue"
import YTEditor from "@/components/YTEditor/index.vue"
import YTCheckPanel from "@/components/YTCheckedPanel/index.vue";
import {addVoucher, editVoucher} from "@/api/voucher/voucher.js";
import {addCoupon, editCoupon} from "@/api/coupon/coupon.js";
import {storeAllList} from "@/api/post/post.js";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import {listMemberLevel} from "@/api/member/member.js";
import moment from "moment";
import {userInfoStore} from "@/store/store.js";
import {disabledEndDate} from "@/hooks/dateUtils.js";
import {listServiceItem} from "@/api/serviceItem/serviceItem.js";
import YTTagSelect from "@/components/YTTagSelect/index.vue";
import {tagGroupsListByUsageScenario} from "@/api/tagGroup/tagGroup.js";
import {listSaleChannelAll} from "@/api/saleChannel/saleChannel.js";
import {listTenant} from "@/api/user/user.js";
import {listTenantOrganizeIgnore} from "@/api/tenant/tenant.js";
import {listBizCategoryTree} from "@/api/bizCategory/bizCategory.js";
import {listInsurance} from "@/api/insurance/insurance.js";
import {insuranceDurationUnitEnum} from "@/enum/insuranceDurationUnitEnum";
import YTRadio from "@/components/YTRadio/index.vue";

/*获取路由信息，带参则为修改*/
const {route} = getRoute()
// 带参则为修改
const isEdit = ref(false)
// 缓存用户信息
const userInfo = ref(userInfoStore().info)
onBeforeMount(async () => {
  await getPropList()
  await getMemberLevelList()
  await handleGetChannel()
  await handleGetItemCategory()
  await handleGetServiceItemList()
  await handleGetInsuranceList()
  if (ruleForm.bizType === 3) {
    await handleGetServiceItemList()
  }
  isEdit.value = Boolean(route.query.itemId)

  if (isEdit.value) {
    await getDetail(route.query.itemId)
  } else {
    loading.value = false
  }
  await getCategoryList()
})

/*获取会员等级列表*/
const getMemberLevelList = async () => {
  memberLevel.value = await listMemberLevel()
}
// 分类请求加载状态
const categoryLoading = ref(false)
/*获取分类列表信息*/
const getCategoryList = async () => {
  categoryLoading.value = true
  innerCategoryEnum.value = []
  innerCategoryEnum.value = await categoryListAll(ruleForm.bizType)
  categoryLoading.value = false
}

// 第三方保险列表
const insuranceLoading = ref(false)
const insuranceTotal = ref(0)
const insuranceTableData = ref([])
const insuranceTableRef = ref()
const getInsuranceId = (item) => item?.insuranceId || item?.id
const handleGetInsuranceList = async () => {
  try {
    const param = {
      page: 1,
      pageSize: 999
    }
    insuranceLoading.value = true
    const res = await listInsurance(param, {insuranceState: 'ON_SHELF'})
    insuranceTableData.value = res.list || []
    insuranceTotal.value = parseInt(res.total || 0)
    if (ruleForm.insuranceIdList?.length) {
      await handleReviewInsuranceSelection()
    }
    insuranceLoading.value = false
  } catch (e) {
    console.log(e)
    insuranceLoading.value = false
  }
}
const handleInsuranceSelectionChange = (list) => {
  ruleForm.insuranceList = list
  ruleForm.insuranceIdList = list.map(item => getInsuranceId(item)).filter(item => item)
  ruleFormRef.value?.validateField("hasInsurance")
}
const handleSetInsuranceList = () => {
  const insuranceIds = (ruleForm.insuranceList || []).map(item => item?.insuranceId).filter(item => item)
  ruleForm.requiredInsuranceIds = ruleForm.hasInsurance.includes('REQUIRED') ? insuranceIds : []
  ruleForm.optionalInsuranceIds = ruleForm.hasInsurance.includes('OPTIONAL') ? insuranceIds : []
}
const getVirtualGoodsSubmitData = () => {
  const submitData = JSON.parse(JSON.stringify(ruleForm))
  delete submitData.insuranceIdList
  delete submitData.insuranceList
  delete submitData.requiredInsuranceList
  delete submitData.optionalInsuranceList
  return submitData
}
const handleInsuranceTypeChange = (list) => {
  ruleForm.hasInsurance = list.slice(-1)
  ruleFormRef.value?.validateField("hasInsurance")
}
const normalizeInsuranceEcho = (res = {}) => {
  const insuranceInfo = {
    ...res,
    ...(res.serviceGoodsInfo || {})
  }
  const requiredInsuranceList = insuranceInfo.requiredInsuranceList || []
  const optionalInsuranceList = insuranceInfo.optionalInsuranceList || []
  const requiredInsuranceIds = insuranceInfo.requiredInsuranceIds || []
  const optionalInsuranceIds = insuranceInfo.optionalInsuranceIds || []
  const insuranceList = requiredInsuranceList.length
      ? requiredInsuranceList
      : optionalInsuranceList.length
          ? optionalInsuranceList
          : (insuranceInfo.insuranceList || [])
  const insuranceIdList = insuranceList.length
      ? insuranceList.map(item => getInsuranceId(item)).filter(item => item)
      : (requiredInsuranceIds.length ? requiredInsuranceIds : optionalInsuranceIds)
  const insuranceIdSet = new Set(insuranceIdList.map(item => String(item)))

  ruleForm.hasInsurance = requiredInsuranceList.length || requiredInsuranceIds.length
      ? ['REQUIRED']
      : optionalInsuranceList.length || optionalInsuranceIds.length
          ? ['OPTIONAL']
          : (Array.isArray(insuranceInfo.hasInsurance) ? insuranceInfo.hasInsurance.slice(-1) : (insuranceInfo.hasInsurance ? [insuranceInfo.hasInsurance] : []))
  ruleForm.insuranceIdList = insuranceIdList
  ruleForm.requiredInsuranceList = requiredInsuranceList
  ruleForm.optionalInsuranceList = optionalInsuranceList
  ruleForm.requiredInsuranceIds = requiredInsuranceIds
  ruleForm.optionalInsuranceIds = optionalInsuranceIds
  ruleForm.insurancePurchaseNotice = insuranceInfo.insurancePurchaseNotice ?? ruleForm.insurancePurchaseNotice
  ruleForm.insurancePurchaseNoticeEn = insuranceInfo.insurancePurchaseNoticeEn ?? ruleForm.insurancePurchaseNoticeEn
  ruleForm.insuranceList = insuranceList.length
      ? insuranceList
      : insuranceTableData.value.filter(item => insuranceIdSet.has(String(getInsuranceId(item))))
}
const handleReviewInsuranceSelection = async () => {
  await nextTick()
  insuranceTableRef.value?.clearSelection()
  if (!ruleForm.insuranceIdList?.length) return
  const insuranceIdSet = new Set(ruleForm.insuranceIdList.map(item => String(item)))
  insuranceTableData.value.forEach(item => {
    if (insuranceIdSet.has(String(getInsuranceId(item)))) {
      insuranceTableRef.value?.toggleRowSelection(item, true)
    }
  })
}
const handleInsurancePrice = (item) => {
  return item.price ?? item.insurancePrice ?? '-'
}
// 商品分类翻页
const handleChangeCategoryPage = () => {
  getCategoryList()
}

// 处理商品分类选择
const handleCategoryChange = async (e) => {
  console.log("e", e)
  const item = innerCategoryEnum.value.find((item) => item.key === e)
  console.log("item", item)
  // ruleForm.innerCategoryType = item.key
  ruleForm.innerCategoryName = item.description
  if (ruleForm.bizType === 5) {
    ruleForm.groups = []
  }
  // 切换分类清空商品类目
  ruleForm.bizCategoryId = null
  // 动态加载校验规则
  if (ruleForm.innerCategoryType === "COURSE") {
    rules.value = rulesTwoMod
  } else if (ruleForm.innerCategoryType === "COMPETITION") {
    if (ruleForm.bizType === 5) {
      rules.value = rulesFiveMod
      ruleForm.organizeIdSet = []
      cacheSalesChannelList.storeList = []
      cacheSalesChannelList.onlineStoreList = []
      cacheSalesChannelList.clubList = []
      cacheSalesChannelList.venueList = []
      cacheSalesChannelList.bikeStoreList = []
      cacheSalesChannelList.therapistStoreList = []
      cacheSalesChannelList.photographyStoreList = []
      cacheSalesChannelList.brandStoreList = []
      ruleForm.salesChannel = ruleForm.salesChannel.filter(i => {
        return i === "COMPETITION"
      })
    }
  } else if (ruleForm.innerCategoryType === "NUMBER") {
    rules.value = rulesFourMod
  } else if (ruleForm.innerCategoryType === "COMBO") {
    rules.value = rulesSixMod
  } else if (ruleForm.innerCategoryType === "VOUCHER") {
    rules.value = rulesSevenMod
    ruleForm.usageCount = 1
    ruleForm.pointsPrice = 0
  } else if (ruleForm.innerCategoryType === "COUPON") {
    rules.value = rulesEightMod
  } else if (ruleForm.innerCategoryType === "MALL") {
    ruleForm.propertyGroupList = []
    // 获取商城-商品类型标签
    // 获取商城服务信息
    // 获取商城退货须知
    await handleGetMALLTags()
    rules.value = rulesElevenMod
  } else {
    if (ruleForm.bizType === 1) {
      rules.value = rulesDefault
    } else if (ruleForm.bizType === 2 || ruleForm.bizType === 5) {
      if (ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
        console.log("赋值ruleForm.serviceDuration", ruleForm.serviceDuration)
        ruleForm.serviceDuration = servicesDurationEnum[0].value
      } else if (ruleForm.innerCategoryType === 'PHOTOGRAPHY') {
        ruleForm.serviceDuration = servicesDurationEnum[1].value
      }
      if (ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
        ruleForm.tagList = []
        await handleGetActivityTagsList('init');
      }
      if (ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
        rules.value = rulesNineMod
      } else if (ruleForm.innerCategoryType === "ENTRY_APPOINTMENT") {
        rules.value = rulesTenMod
      }  else {
        rules.value = rulesVirDefault
      }
    }
  }
}

// 是否修改课程商品
const isEditCourse = ref(false)

/*获取商品信息*/
const getDetail = async (itemId) => {
  loading.value = true
  try {
    const res = await itemDetail(itemId)
    if (!res) throw new Error("null")
    ruleForm.address = null;
    Object.assign(ruleForm, res);
    normalizeInsuranceEcho(res)
    await handleReviewInsuranceSelection()
    console.log("bizType", ruleForm.bizType)
    isRich.value = ruleForm.descriptionType === "RICH_TEXT"
    // 处理反显属性值，实物商品与虚拟商品内容不同
    if (ruleForm.bizType === 1) {
      itemProp.value = res.propertyGroupList
      rules.value = rulesDefault
    } else if (ruleForm.bizType === 2) {
      console.log("ruleForm", ruleForm)
      rules.value = rulesVirDefault
      // 虚拟商品反显
      if (ruleForm.innerCategoryType === "COURSE") {
        isEditCourse.value = true
        // 设置课程表单校验规则
        rules.value = rulesTwoMod
        ruleForm.usageCount = ruleForm.courseInfo.usageCount
        ruleForm.studentLimit = ruleForm.courseInfo.studentLimit
        ruleForm.courseDuration = ruleForm.courseInfo.courseDuration
        ruleForm.validityType = ruleForm.courseInfo.validityType
        ruleForm.validityValue = ruleForm.courseInfo.validityValue
        ruleForm.province = ruleForm.courseInfo.province
        ruleForm.provinceCode = ruleForm.courseInfo.provinceCode
        ruleForm.city = ruleForm.courseInfo.city
        ruleForm.cityCode = ruleForm.courseInfo.cityCode
        ruleForm.district = ruleForm.courseInfo.district
        ruleForm.districtCode = ruleForm.courseInfo.districtCode
        ruleForm.addressDetail = ruleForm.courseInfo.addressDetail
        ruleForm.addressDetailEn = ruleForm.courseInfo.addressDetailEn
        // 反显扩展信息
        if (ruleForm.validityType === "DAYS") {
          ruleForm.validityDeadlineDate = parseInt(ruleForm.courseInfo.validityValue)
        } else if (ruleForm.validityType === "END_DATE") {
          ruleForm.validityDeadlineTime = ruleForm.courseInfo.validityValue
        }
      }
      if (ruleForm.innerCategoryType !== "COURSE" && ruleForm.innerCategoryType !== "NUMBER") {
        // 非课程、非活动、非号码清空startTime、endTime、address、applyStartTime、applyEndTime
        ruleForm.startTime = null
        ruleForm.endTime = null
        ruleForm.address = null
        ruleForm.applyStartTime = null
        ruleForm.applyEndTime = null
      }
      if (ruleForm.innerCategoryType === "NUMBER") {
        // 设置课程表单校验规则
        rules.value = rulesFourMod
        ruleForm.numberPrefix = ruleForm.numberInfo.numberPrefix
        ruleForm.numberSuffix = ruleForm.numberInfo.numberSuffix
        ruleForm.startNumber = ruleForm.numberInfo.startNumber
        ruleForm.endNumber = ruleForm.numberInfo.endNumber
      }
      if (ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
        ruleForm.noticeContent = ruleForm.serviceGoodsInfo.noticeContent
        ruleForm.noticeContentEn = ruleForm.serviceGoodsInfo.noticeContentEn
        ruleForm.guaranteeContent = ruleForm.serviceGoodsInfo.guaranteeContent
        ruleForm.guaranteeContentEn = ruleForm.serviceGoodsInfo.guaranteeContentEn
        ruleForm.serviceDuration = ruleForm.serviceGoodsInfo.serviceDuration
        ruleForm.appointmentRequired = ruleForm.serviceGoodsInfo.appointmentRequired
        ruleForm.validityDays = ruleForm.serviceGoodsInfo.validityDays
        ruleForm.usageLimit = ruleForm.serviceGoodsInfo.usageLimit
        if (ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
          rules.value = rulesNineMod
        }
        await handleGetActivityTagsList('init');
      }
      if (ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT') {
        ruleForm.serviceGoodsInfo = {
          venueEntranceCalendarSetting: "OPERATING_HOURS",
          ...(ruleForm.serviceGoodsInfo || {})
        }
        ruleForm.maxAddQty = ruleForm.serviceGoodsInfo.maxAddQty
        ruleForm.purchaseRuleContent = ruleForm.serviceGoodsInfo.purchaseRuleContent
        ruleForm.purchaseRuleContentEn = ruleForm.serviceGoodsInfo.purchaseRuleContentEn
        if (ruleForm.groups.length > 0) {
          rules.value = rulesTenMod
        } else {
          rules.value = rulesVirDefault
        }
      }
      // 课程、活动反显城市
      let temp = [res.provinceCode, res.cityCode, res.districtCode]
      ruleForm.address = temp.filter(item => item !== undefined && item !== null && item !== "").join("/")
      console.log("ruleForm.address", ruleForm.address)

    } else if (ruleForm.bizType === 3) {
      // 反显使用次数
      ruleForm.usageCount = ruleForm.voucherInfo.usageCount
      // 设置电子卡券表单校验规则
      rules.value = rulesSevenMod
      // 反显电子卡券扩展信息：有效期
      if (ruleForm.voucherInfo.validityType === "DAYS") {
        ruleForm.voucherInfo.validityDeadlineDate = parseInt(ruleForm.voucherInfo.validityValue)
      } else if (ruleForm.voucherInfo.validityType === "END_DATE") {
        ruleForm.voucherInfo.validityDeadlineTime = ruleForm.voucherInfo.validityValue
      }
      // 反显关联驿站
      ruleForm.stores = ruleForm.voucherInfo.stores
      // 反显关联类型
      ruleForm.relationType = ruleForm.voucherInfo.relationType
      if (ruleForm.relationType === 'SERVICE_ITEM') {
        ruleForm.serviceItemId = ruleForm.voucherInfo.serviceItemId
        cacheService.serviceItemId = ruleForm.voucherInfo.serviceItemId
      }
      // 反显须知、保障、使用规则
      ruleForm.noticeContent = ruleForm.voucherInfo.noticeContent
      ruleForm.noticeContentEn = ruleForm.voucherInfo.noticeContentEn
      ruleForm.guaranteeContent = ruleForm.voucherInfo.guaranteeContent
      ruleForm.guaranteeContentEn = ruleForm.voucherInfo.guaranteeContentEn
      ruleForm.ruleDescription = ruleForm.voucherInfo.ruleDescription
      ruleForm.ruleDescriptionEn = ruleForm.voucherInfo.ruleDescriptionEn
    } else if (ruleForm.bizType === 4) {
      if (ruleForm.innerCategoryType === "COUPON") {
        // 反显优惠券扩展信息：有效期
        if (ruleForm.couponInfo.validityType === "DAYS") {
          ruleForm.couponInfo.validityDeadlineDate = parseInt(ruleForm.couponInfo.validityValue)
        } else if (ruleForm.couponInfo.validityType === "END_DATE") {
          ruleForm.couponInfo.validityDeadlineTime = ruleForm.couponInfo.validityValue
        }
        // 反显使用次数
        ruleForm.usageCount = ruleForm.couponInfo.usageCount
        // 反显积分价格
        ruleForm.pointsPrice = ruleForm.couponInfo.pointsPrice
        // 反显关联驿站
        ruleForm.stores = ruleForm.couponInfo.stores
        // 设置课程表单校验规则
        rules.value = rulesEightMod
      }
    } else if (ruleForm.bizType === 5) {
      if (ruleForm.innerCategoryType === "COMPETITION") {
        ruleForm.province = ruleForm.competitionInfo.province
        ruleForm.provinceCode = ruleForm.competitionInfo.provinceCode
        ruleForm.city = ruleForm.competitionInfo.city
        ruleForm.cityCode = ruleForm.competitionInfo.cityCode
        ruleForm.district = ruleForm.competitionInfo.district
        ruleForm.districtCode = ruleForm.competitionInfo.districtCode
        ruleForm.addressDetail = ruleForm.competitionInfo.addressDetail
        ruleForm.addressDetailEn = ruleForm.competitionInfo.addressDetailEn
        ruleForm.applyUrl = ruleForm.competitionInfo.applyUrl
        ruleForm.organizerName = ruleForm.competitionInfo.organizerName
        ruleForm.organizerNameEn = ruleForm.competitionInfo.organizerNameEn
        ruleForm.applyStartTime = ruleForm.competitionInfo.applyStartTime
        ruleForm.applyEndTime = ruleForm.competitionInfo.applyEndTime
        ruleForm.startTime = ruleForm.competitionInfo.startTime
        ruleForm.endTime = ruleForm.competitionInfo.endTime
        ruleForm.competitionDivisions = ruleForm.competitionInfo.competitionDivisions
        ruleForm.relatedGoodsList = ruleForm.competitionInfo.relatedGoodsList
        console.log("run in detail", ruleForm.groups)
        await nextTick(() => {
          // 反显组别图片
          handleReviewCompetitionDivisionsUploadPic(ruleForm.competitionDivisions)
          if (res.discoverCoverImage) handleReviewDiscoverCoverPic(res.discoverCoverImage)
        })
        // 设置赛事表单校验规则
        rules.value = rulesFiveMod
      }
      if (ruleForm.innerCategoryType === "COURSE") {
        isEditCourse.value = true
        // 设置课程表单校验规则
        rules.value = rulesTwoMod
        ruleForm.usageCount = ruleForm.courseInfo.usageCount
        ruleForm.studentLimit = ruleForm.courseInfo.studentLimit
        ruleForm.courseDuration = ruleForm.courseInfo.courseDuration
        ruleForm.validityType = ruleForm.courseInfo.validityType
        ruleForm.validityValue = ruleForm.courseInfo.validityValue
        ruleForm.province = ruleForm.courseInfo.province
        ruleForm.provinceCode = ruleForm.courseInfo.provinceCode
        ruleForm.city = ruleForm.courseInfo.city
        ruleForm.cityCode = ruleForm.courseInfo.cityCode
        ruleForm.district = ruleForm.courseInfo.district
        ruleForm.districtCode = ruleForm.courseInfo.districtCode
        ruleForm.addressDetail = ruleForm.courseInfo.addressDetail
        ruleForm.addressDetailEn = ruleForm.courseInfo.addressDetailEn
        // 反显扩展信息
        if (ruleForm.validityType === "DAYS") {
          ruleForm.validityDeadlineDate = parseInt(ruleForm.courseInfo.validityValue)
        } else if (ruleForm.validityType === "END_DATE") {
          ruleForm.validityDeadlineTime = ruleForm.courseInfo.validityValue
        }
      }
      if (ruleForm.innerCategoryType === "NUMBER") {
        // 设置课程表单校验规则
        rules.value = rulesFourMod
        ruleForm.numberPrefix = ruleForm.numberInfo.numberPrefix
        ruleForm.numberSuffix = ruleForm.numberInfo.numberSuffix
        ruleForm.startNumber = ruleForm.numberInfo.startNumber
        ruleForm.endNumber = ruleForm.numberInfo.endNumber
      }
      if (ruleForm.innerCategoryType !== "COURSE" && ruleForm.innerCategoryType !== "NUMBER" && ruleForm.innerCategoryType !== "COMPETITION") {
        // 非课程、非活动、非号码、非赛事清空startTime、endTime、address、applyStartTime、applyEndTime
        ruleForm.startTime = null
        ruleForm.endTime = null
        ruleForm.address = null
        ruleForm.applyStartTime = null
        ruleForm.applyEndTime = null
      }
    } else if (ruleForm.bizType === 6) {
      if (ruleForm.innerCategoryType === "MALL") {
        // 获取商城-商品类型标签
        // 获取商城服务信息
        // 获取商城退货须知
        await handleGetMALLTags()
        if (ruleForm.mallGoods.parentBizCategoryId) ruleForm.bizCategoryId.push(ruleForm.mallGoods.parentBizCategoryId)
        if (ruleForm.mallGoods.bizCategoryId) ruleForm.bizCategoryId.push(ruleForm.mallGoods.bizCategoryId)
        ruleForm.mallGoodsCategoryTagList = ruleForm.mallGoods.mallGoodsCategoryTagList
        ruleForm.mallServiceInfoTagList = ruleForm.mallGoods.mallServiceInfoTagList
        ruleForm.mallReturnPolicyTagList = ruleForm.mallGoods.mallReturnPolicyTagList
        nextTick(() => {
          handleReviewItemTypeTagList()
          handleReviewItemServiceTagList()
          handleReviewItemReturnTagList()
        })
        rules.value = rulesElevenMod
      }
    }
    // 课程、赛事、活动反显城市
    let temp = [ruleForm.provinceCode, ruleForm.cityCode, ruleForm.districtCode]
    ruleForm.addressCode = temp.filter(item => item !== undefined && item !== null && item !== "").join("/")
    handleReviewPic(res.images)
    nextTick(() => {
      // 处理活动标签反显
      YTTagSelectRef.value.handleYTCheckTagMultipleReview(ruleForm.tagList)
      // 处理销售渠道门店反显
      ruleForm.organizeList.map(i=> {
        if (i.salesChannel === 'STORE') {
          cacheSalesChannelList.storeList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'ONLINE_STORE') {
          cacheSalesChannelList.onlineStoreList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'CLUB') {
          cacheSalesChannelList.clubList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'VENUE') {
          cacheSalesChannelList.venueList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'BIKE_STORE') {
          cacheSalesChannelList.bikeStoreList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'THERAPIST_STORE') {
          cacheSalesChannelList.therapistStoreList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'PHOTOGRAPHY_STORE') {
          cacheSalesChannelList.photographyStoreList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        } else if (i.salesChannel === 'BRAND') {
          cacheSalesChannelList.brandStoreList.push({
            storeId: i.storeId,
            storeName: i.storeName
          })
        }
      })
    })
    loading.value = false
  } catch (e) {
    console.log(e)
    if (e.message === "null") {
      ElMessage({
        type: "warning",
        message: "暂无此商品数据",
        duration: 3000,
        onClose: () => {
          router.push("/listItem")
        }
      })
    }
  }
}
// 表单加载状态
const loading = ref(true);
const selectLoading = ref(false);
// 商品类型枚举
const itemTypeEnum = [
  {
    title: "实物商品",
    text: "物流/同城/自提",
    value: 1,
    code: "PHYSICAL_ITEM",
    disable: false
  },
  {
    title: "虚拟商品",
    text: "无需物流",
    value: 2,
    code: "VIRTUAL_ITEM",
    disable: false
  },
  {
    title: "电子卡券",
    text: "抵扣其他商品",
    value: 3,
    code: "VOUCHER",
    disable: false
  },
  {
    title: "付费优惠券",
    text: "无需物流",
    value: 4,
    code: "COUPON",
    disable: false
  },
  {
    title: "组合商品",
    text: "无需物流",
    value: 5,
    code: "COMBO",
    disable: false
  },
  {
    title: "商城商品",
    text: "    ",
    value: 6,
    code: "MALL",
    disable: false
  }
]
// 商品分类枚举
const innerCategoryEnum = ref([])
// 商品类目枚举
const bizTypeEnum = ref([])
// 用户等级枚举
const memberLevel = ref()

// 表单组件锚点
const ruleFormRef = ref()

// 表单信息
const ruleForm = reactive({
  // 商品类型
  bizType: 1,
  // 基本信息
  goodsName: null,
  goodsNameEn: "Coming Soon ...",
  barCode: null,
  innerCategoryName: null,
  innerCategoryType: null,
  taxClassificationCode: null,
  needLogistics: false,
  taxRate: 0,
  listingTime: null,
  delistingTime: null,
  tagList: [],
  noticeContent: null,
  noticeContentEn: "Coming Soon ...",
  guaranteeContent: null,
  guaranteeContentEn: "Coming Soon ...",
  ruleDescription: null,
  ruleDescriptionEn: "Coming Soon ...",
  bizCategoryId: [],
  unit: null,
  unitEn: null,
  summary: null,
  summaryEn: "Coming Soon ...",
  description: null,
  descriptionEn: "Coming Soon ...",
  descriptionType: "RICH_TEXT",
  descriptionImages: [],
  descriptionEnImages: [],
  images: [],
  memberLevelId: null,
  tenantId: null,
  salesChannel: [],
  organizeIdSet: [],
  // 扩展信息
  applyUrl: null,
  organizerName: null,
  organizerNameEn: "Coming Soon ...",
  relationType: null,
  serviceItemId: null,
  groups: [], // 分组商品|配套服务
  competitionDivisions: [],
  studentLimit: 0,
  courseDuration: 0,
  validityType: "PERMANENT",
  validityDeadlineTime: null,
  validityDeadlineDate: 0,
  validityValue: null,
  startNumber: null,
  endNumber: null,
  numberRange: null,
  stores: [],
  hasAlbum: false,
  albumUrl: null,
  isCustomizable: false,
  relatedGoodsList: [],
  serviceDuration: null,
  appointmentRequired: null,
  validityDays: 0,
  usageLimit: 0,
  // 添加第三方保险
  hasInsurance: [],
  insuranceIdList: [],
  insuranceList: [],
  requiredInsuranceList: [],
  optionalInsuranceList: [],
  requiredInsuranceIds: [],
  optionalInsuranceIds: [],
  insurancePurchaseNotice: null,
  insurancePurchaseNoticeEn: null,
  // 关联信息
  maxAddQty: 0,
  purchaseRuleContent: null,
  purchaseRuleContentEn: null,
  // 价格库存
  originalPrice: 0,
  retailPrice: 0,
  costDetails: [],
  usageCount: 0,
  pointsPrice: 0,
  vipPrice: 0,
  // 商品属性
  propertyGroupList: [],
  virTime: [],
  address: null,
  addressCode: null,
  province: null,
  provinceCode: null,
  city: null,
  cityCode: null,
  district: null,
  districtCode: null,
  addressDetail: null,
  addressDetailEn: "Coming Soon ...",
  goodsVirtualItemList: [],
  startTime: null,
  endTime: null,
  applyTime: [],
  applyStartTime: null,
  applyEndTime: null,
  numberPrefix: null,
  numberSuffix: null,
  // 提交给后端的组合信息
  competitionInfo: {},
  courseInfo: {},
  numberInfo: {},
  serviceGoodsInfo: {
    venueEntranceCalendarSetting: "OPERATING_HOURS"
  },
  voucherInfo: {
    ruleDescription: null,
    ruleDescriptionEn: "Coming Soon ...",
    pointsPrice: 0,
    usageCount: 0,
    validityType: "DAYS",
    validityValue: null,
    validityDeadlineTime: null,
    validityDeadlineDate: 0,
    relatedGoods: {
      goodsId: null,
      goodsProperties: [],
      relatedGoodsName: null
    }
  },
  couponInfo: {
    pointsPrice: 0,
    minimumOrderAmount: 0,
    discountAmount: 0,
    usageCount: 0,
    validityType: "DAYS",
    validityValue: null,
    validityDeadlineTime: null,
    validityDeadlineDate: 0,
  },
  mallGoodsCategoryTagList: [],
  mallServiceInfoTagList: [],
  mallReturnPolicyTagList: [],
  mallGoods: {
    shipWithinHours: null,
    expressPaymentType: null,
    refundSupported: false,
    bizCategoryId: null,
    bizCategoryName: null,
    bizCategoryNameEn: null,
    parentBizCategoryId: null,
    bizParentCategoryName: null,
    bizParentCategoryNameEn: null,
  }
})
const checkImagesList = (rule, value, callback) => {
  const listLength = boxUploadRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请至少上传一张商品图片'))
  }
  callback()
}
const checkDiscoverCoverImageList = (rule, value, callback) => {
  const listLength = boxUploadDiscoverCoverRef.value.fileList.length
  if (listLength < 1) {
    return callback(new Error('请至少上传一张赛事发现页推荐封面图'))
  }
  callback()
}
// 商品名称校验规则
const checkGoodsName = (rule, value, callback) => {
  if (!ruleForm.goodsName) {
    return callback(new Error("商品名称（中文）不能为空！"))
  }
  if (!ruleForm.goodsNameEn) {
    return callback(new Error("商品名称（English）不能为空！"))
  }
  return callback()
}
// 地点校验规则
const checkAddressDetail = (rule, value, callback) => {
  if (!ruleForm.addressDetail) {
    return callback(new Error("地点（中文）不能为空！"))
  }
  if (!ruleForm.addressDetailEn) {
    return callback(new Error("地点（English）不能为空！"))
  }
  return callback()
}
// 虚拟商品 - 商品上架时长校验
const checkListingTime = (rule, value, callback) => {
  if ((ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') && moment(ruleForm.listingTime).isAfter(ruleForm.delistingTime)) return callback(new Error("商品上架结束时间必须大于上架开始时间！"))
  return callback()
}
// 实物商品 - 默认校验规则
const rulesDefault = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 虚拟商品 - 销售渠道校验规则
const checkSalesChannel = (rule, value, callback) => {
  if ((ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') && ruleForm.salesChannel.length === 0) {
    return callback(new Error("请选择销售渠道"))
  }
  return callback()
}
// 虚拟商品默认
const checkInsuranceProduct = (rule, value, callback) => {
  if (ruleForm.bizType === 2 && ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT') {
    if (!ruleForm.hasInsurance?.length || !ruleForm.insuranceIdList?.length) {
      return callback(new Error("请选择保险产品"))
    }
  }
  return callback()
}
const rulesVirDefault = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  listingTime: [
    {validator: checkListingTime, trigger: "change"}
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  salesChannel: [
    {validator: checkSalesChannel, trigger: "change"},
  ],
  "serviceGoodsInfo.venueEntranceCalendarSetting": [
    {required: true, message: "请选择日历开放方式", trigger: "change"}
  ],
  hasInsurance: [
    {required: true, validator: checkInsuranceProduct, trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 城市校验规则
const checkAddress = (rule, value, callback) => {
  if (!ruleForm.provinceCode || !ruleForm.cityCode) {
    return new Error("请选择城市")
  }
  return callback()
}
// 活动时间|赛事报名时间校验规则
const checkActivityVirTime = (rule, value, callback) => {
  if (ruleForm.startTime || ruleForm.endTime) {
    if (!ruleForm.startTime) {
      return callback(new Error(`请选择活动开始时间`))
    } else if (!ruleForm.endTime) {
      return callback(new Error(`请选择活动结束时间`))
    }
    if (moment(ruleForm.startTime).isAfter(moment(ruleForm.endTime))) {
      return callback(new Error("活动结束时间不可小于活动开始时间"))
    }
  } else {
    return callback(new Error(`请选择活动时间`))
  }
  return callback()
}
// 活动|赛事报名时间校验规则
const checkActivityApplyTime = (rule, value, callback) => {
  if (ruleForm.applyStartTime || ruleForm.applyEndTime) {
    if (!ruleForm.applyStartTime) {
      return callback(new Error("请选择报名开始时间"))
    } else if (!ruleForm.applyEndTime) {
      return callback(new Error("请选择报名结束时间"))
    }
    if (moment(ruleForm.applyStartTime).isAfter(moment(ruleForm.applyEndTime))) {
      return callback(new Error("报名结束时间不可小于报名开始时间"))
    }
    if (moment(ruleForm.applyEndTime).isAfter(moment(ruleForm.endTime))) {
      // 报名结束时间必须小于比赛结束时间
      return callback(new Error("活动报名结束时间必须在活动结束时间之前，请重新选择"))
    }
  } else {
    return callback(new Error("请选择报名时间"))
  }
  return callback()
}
const checkValidityType = (rule, value, callback) => {
  if (ruleForm.validityType === "DAYS") {
    if (!ruleForm.validityDeadlineDate) {
      callback(new Error("请填写有效天数"))
    }
  } else if (ruleForm.validityType === "END_DATE") {
    if (!ruleForm.validityDeadlineTime) {
      callback(new Error("请选择截止日期"))
    }
  }
  callback()
}
// 虚拟商品/组合商品 - 课程 - 额外校验地址、有效期
const rulesTwoMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  studentLimit: [
    {required: true, message: "请输入课堂人数", trigger: "change"},
  ],
  courseDuration: [
    {required: true, message: "请输入课堂时长", trigger: "change"},
  ],
  validityType: [
    {required: true, validator: checkValidityType, trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  address: [
    { required: true, validator: checkAddress, trigger: 'change' }
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 比赛时间校验规则
const checkApplyTime = (rule, value, callback) => {
  if (ruleForm.startTime || ruleForm.endTime) {
    if (moment(ruleForm.applyEndTime).isAfter(moment(ruleForm.startTime))) {
      // 报名结束时间必须小于比赛开始时间
      return callback(new Error("比赛开始时间必须在报名结束时间之后，请重新选择"))
    }
    if (moment(ruleForm.startTime).isAfter(moment(ruleForm.endTime))) {
      return callback(new Error("比赛结束时间不可小于比赛开始时间"))
    }
  } else {
    return callback(new Error("请选择比赛时间"))
  }
  return callback()
}

// 校验规则：号码商品号码范围
const checkNumberRange = (rule, value, callback) => {
  if (ruleForm.startNumber < 0 || ruleForm.endNumber <0) {
    return callback(new Error("请填写号码范围，起始数字和终止数字不能为空"))
  } else if (ruleForm.endNumber === 0) {
    return callback(new Error("号码范围填写错误，终止数字不能为0"))
  } else if (ruleForm.startNumber > ruleForm.endNumber) {
    return callback(new Error("号码范围填写错误，终止数字不能大于起始数字"))
  } else if (ruleForm.startNumber === ruleForm.endNumber) {
    return callback(new Error("号码范围填写错误，终止数字不能等于起始数字"))
  } else {
    return callback()
  }
}
// 虚拟商品 - 号码 - 额外校验号码范围
const rulesFourMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  images: [
    { required: true, validator: checkImagesList }
  ],
  numberRange: [
    { required: true, validator: checkNumberRange, trigger: "change" }
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}

// 校验规则：组合商品组别设置
const checkCompetitionDivisions = (rule, value, callback) => {
  const hasEmpty = ruleForm.competitionDivisions.some(i => !i.divisionName)
  if (hasEmpty) {
    callback(new Error("组别设置中有组别名称未填写"))
  } else {
    callback()
  }
}
// 校验规则：组合商品 - 赛事 - 配套服务
const checkGroupGoods = (rule, value, callback) => {
  const hasEmptyName = ruleForm.groups.some(item => !item.groupName)
  console.log("ruleForm.groups", ruleForm.groups)
  const hasEmptyGoodsList = ruleForm.groups.some(item => {
    // 检查数组是否为空
    if (item.items.length === 0) return true
    // 检查数组中是否包含空字符串
    return item.items.some(id => id === "")
  })
  for (let i = 0; i < ruleForm.groups.length; i++) {
    for (let j = 0;  j < ruleForm.groups[i].items.length; j++) {
      console.log("ruleForm.innerCategoryType === \"COMPETITION\"", ruleForm.innerCategoryType === "COMPETITION")
      console.log("ruleForm.groups[i].items[j].isGift", ruleForm.groups[i].items[j].isGift)
      console.log("ruleForm.groups[i].items[j].giftCount", ruleForm.groups[i].items[j].giftCount)
      console.log("ruleForm.groups[i].items[j].giftCount === null", ruleForm.groups[i].items[j].giftCount === null)
      if (ruleForm.innerCategoryType === "COMPETITION" && ruleForm.groups[i].items[j].isGift && ruleForm.groups[i].items[j].giftCount === null) {
        return callback(new Error(`请填写第${i + 1}个配套服务第${j + 1}个关联商品的默认赠送数量`))
      }
    }
  }
  if (hasEmptyName) {
    callback(new Error("配套服务中有服务名称未填写"))
  } else if (hasEmptyGoodsList) {
    callback(new Error("配套服务中未选择关联商品"))
  } else {
    callback()
  }
}
// 校验规则：组合商品 - 赛事 - 主办方
const checkOrganizerName = (rule, value, callback) => {
  if (!ruleForm.organizerName) {
    return callback(new Error("主办方（中文）不能为空！"))
  }
  if (!ruleForm.organizerNameEn) {
    return callback(new Error("主办方（English）不能为空！"))
  }
  return callback()
}
// 组合商品 - 赛事 - 额外校验报名网址、组别信息、配套服务、报名开始时间（有效时间）、比赛开始时间、地址（赛事）
const rulesFiveMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  virTime: [
    { required: true, validator: checkApplyTime, trigger: "change" }
  ],
  applyTime: [
    { required: true, validator: checkActivityApplyTime, trigger: "change" }
  ],
  address: [
    { required: true, validator: checkAddress, trigger: 'change' }
  ],
  addressDetail: [
    { required: true, validator: checkAddressDetail, trigger: "change" },
  ],
  images: [
    { required: true, validator: checkImagesList }
  ],
  discoverCoverImage: [
    { required: true, validator: checkDiscoverCoverImageList }
  ],
  organizerName: [
    { required: true, validator: checkOrganizerName }
  ],
  competitionDivisions: [
    { validator: checkCompetitionDivisions }
  ],
  groups: [
    { validator: checkGroupGoods }
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 校验规则：组合商品 - 组合 - 分组商品
const checkGroupGoodsRule = (rule, value, callback) => {
  if (ruleForm.groups.length > 0) {
    for (let i = 0; i < ruleForm.groups.length; i++) {
      if (!ruleForm.groups[i].groupName) {
        return callback(new Error(`第${i + 1}项分组商品，分组名不能为空！`))
      }
      if (!ruleForm.groups[i].optionCount) {
        return callback(new Error(`第${i + 1}项分组商品，可选商品数量不能为空！`))
      }
    }
  }
  return callback()
}
// 组合商品 - 组合 - 额外校验分组商品
const rulesSixMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  images: [
    { required: true, validator: checkImagesList }
  ],
  groups: [
    { validator: checkGroupGoodsRule }
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 电子卡券有效期校验规则
const checkVoucherValidityType = (rule, value, callback) => {
  if (ruleForm.voucherInfo.validityType === "DAYS") {
    if (!ruleForm.voucherInfo.validityDeadlineDate) {
      return callback(new Error("请填写有效天数"))
    }
  } else if (ruleForm.voucherInfo.validityType === "END_DATE") {
    if (!ruleForm.voucherInfo.validityDeadlineTime) {
      return callback(new Error("请选择截止日期"))
    }
  }
  return callback()
}
// 电子卡券关联商品校验规则
const checkRelatedGoods = (rule, value, callback) => {
  // if (ruleForm.stores.length <= 0 && ruleForm.relationType === 'STORE') {
  //   return callback(new Error("请先关联至少一个驿站"))
  // }
  if (!ruleForm.voucherInfo.relatedGoods.relatedGoodsName) {
    return callback(new Error("请选择一个关联商品"))
  }
  return callback()
}
// 电子卡券/付费优惠券关联驿站校验规则
const checkStores = (rule, value, callback) => {
  if (ruleForm.stores.length <= 0) {
    return callback(new Error("请关联至少一个驿站"))
  }
  return callback()
}
// 电子卡券 - “关联服务” - 关联的项目服务校验规则
const checkServiceItemId = (rule, value, callback) => {
  if (ruleForm.relationType === "SERVICE_ITEM") {
    if (!ruleForm.serviceItemId) {
      return callback(new Error("请关联一个项目"))
    }
  }
  return callback()
}
// 电子卡券 - 电子卡券 - 额外处理关联商品、有效期
const rulesSevenMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  voucherInfo: {
    validityType: [
      {required: true, validator: checkVoucherValidityType, trigger: "change"},
    ],
  },
  relatedGoods: [
    { required: true, validator: checkRelatedGoods, trigger: "change" }
  ],
  // stores: [
  //   { required: true, validator: checkStores, trigger: "change" }
  // ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  // relationType: [
  //   {required: true, message: "请选择关联类型", trigger: "change"},
  // ],
  serviceItemId: [
    {validator: checkServiceItemId, trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 付费优惠券有效期校验规则
const checkCouponValidityType = (rule, value, callback) => {
  if (ruleForm.couponInfo.validityType === "DAYS") {
    if (!ruleForm.couponInfo.validityDeadlineDate) {
      return callback(new Error("请填写有效天数"))
    }
  } else if (ruleForm.couponInfo.validityType === "END_DATE") {
    if (!ruleForm.couponInfo.validityDeadlineTime) {
      return callback(new Error("请选择截止日期"))
    }
  }
  return callback()
}
// 付费优惠券 - 付费优惠券 - 额外处理订单金额、有效期
const rulesEightMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  couponInfo: {
    validityType: [
      {required: true, validator: checkCouponValidityType, trigger: "change"},
    ],
    minimumOrderAmount: [
      {required: true, message: "请输入订单金额", trigger: "change"}
    ],
    discountAmount: [
      {required: true, message: "请输入抵扣金额", trigger: "change"}
    ]
  },
  // stores: [
  //   { required: true, validator: checkStores, trigger: "change" }
  // ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ]
}
// 是否需要预约 - 校验规则
const checkAppointmentRequired = (rule, value, callback) => {
  if (value === null) return callback(new Error("请选择是否需要预约"))
  return callback()
}
// 购买后使用有效期 - 校验规则
const checkValidityDays = (rule, value, callback) => {
  if (value < 1) return callback(new Error("购买后使用有效期天数必须大于等于1"))
  return callback()
}
// 虚拟商品 - 服务- 校验规则
const rulesNineMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  listingTime: [
    {validator: checkListingTime, trigger: "change"}
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  usageCount: [
    { required: true, message: "请输入使用次数", trigger: "change" },
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  salesChannel: [
    {validator: checkSalesChannel, trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ],
  appointmentRequired: [
    {required: true, validator: checkAppointmentRequired, trigger: "change"}
  ],
  validityDays: [
    {required: true, validator: checkValidityDays, trigger: "change"}
  ]
}
// 关联商品加购上限 - 校验规则
const checkMaxAddQty = (rule, value, callback) => {
  if (value === null || value === "") return callback(new Error("请输入商品加购上限"))
  return callback()
}
// 虚拟商品 - 入场预约- 校验规则
const rulesTenMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  listingTime: [
    {validator: checkListingTime, trigger: "change"}
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  salesChannel: [
    {validator: checkSalesChannel, trigger: "change"},
  ],
  "serviceGoodsInfo.venueEntranceCalendarSetting": [
    {required: true, message: "请选择日历开放方式", trigger: "change"}
  ],
  hasInsurance: [
    {required: true, validator: checkInsuranceProduct, trigger: "change"},
  ],
  vipPrice: [
    {required: true, message: "请填写VIP价", trigger: "change"}
  ],
  maxAddQty: [
    {required: true, validator: checkMaxAddQty, trigger: "change"}
  ]
}
// 物流设置校验规则
const checkNeedLogistics = (rule, value, callback) => {
  if (ruleForm.needLogistics === null || ruleForm.needLogistics === undefined || ruleForm.needLogistics === '') return callback(new Error("请选择物流设置"))
  return callback()
}
// 处理物流设置改变
const handleNeedLogisticsChange = (type) => {
  ruleForm.needLogistics = type
  if (!type) {
    ruleForm.mallGoods.expressPaymentType = null
  }
}
// 发货时间校验规则
const checkShipWithinHours = (rule, value, callback) => {
  if (Number(ruleForm.mallGoods.shipWithinHours) <= 0) return callback(new Error("发货时间必须为正数"))
  return callback()
}
// 快递费校验规则
const checkExpressPaymentType = (rule, value, callback) => {
  if (ruleForm.needLogistics && !ruleForm.mallGoods.expressPaymentType) return callback(new Error("请选择快递费"))
  return callback()
}
// 商品服务信息校验规则
const checkMallServiceInfoTagList = (rule, value, callback) => {
  if (ruleForm.mallServiceInfoTagList.length <= 0) return callback(new Error("请选择商品服务信息"))
  return callback()
}
// 退货须知校验规则
const checkMallReturnPolicyTagList = (rule, value, callback) => {
  if (ruleForm.mallReturnPolicyTagList.length <= 0) return callback(new Error("请选择退货须知"))
  return callback()
}
// 商城商品 - 商城商品 - 校验规则
const rulesElevenMod = {
  goodsName: [
    {required: true, validator: checkGoodsName, trigger: "change"},
  ],
  innerCategoryType: [
    {required: true, message: "请选择商品分类", trigger: "change"},
  ],
  retailPrice: [
    {required: true, message: "请输入会员价", trigger: "change"},
  ],
  images: [
    {required: true, validator: checkImagesList}
  ],
  memberLevelId: [
    {required: true, message: "请选择用户等级", trigger: "change"},
  ],
  tenantId: [
    {required: true, message: "请选择所属商家", trigger: "change"},
  ],
  salesChannel: [
    {validator: checkSalesChannel, trigger: "change"},
  ],
  shipWithinHours: [
    {required: true, validator: checkShipWithinHours, trigger: "change"},
  ],
  needLogistics: [
    {required: true, validator: checkNeedLogistics, trigger: "change"},
  ],
  expressPaymentType: [
    {required: true, validator: checkExpressPaymentType, trigger: "change"},
  ],
  mallServiceInfoTagList: [
    {required: true, validator: checkMallServiceInfoTagList, trigger: "change"},
  ],
  mallReturnPolicyTagList: [
    {required: true, validator: checkMallReturnPolicyTagList, trigger: "change"},
  ]
}
// 表单校验规则
const rules = ref(rulesDefault)
// 取消新增
const cancelAdd = () => {
  router.back()
}
// 保存校验表单
const submit = async () => {
  loading.value = true
  await ruleFormRef.value.validate(async (valid, field) => {
    // 处理商品属性传值
    if (ruleForm.bizType !== 6) {
      if (isEdit) {
        ruleForm.propertyGroupList = itemProp.value.map(item => ({
          ...item,
          propertyGroupItemList: item.unDisabled ? item.propertyGroupItemList : item.propertyGroupItemList.map(el => el.propertyGroupItemId)
        }))
      } else {
        ruleForm.propertyGroupList = itemProp.value
      }
    }
    // 校验组别
    const isCompetitionDivisionsPass = handleCheckCompetitionDivisions()
    // 校验配套服务
    const isGroupsPass = handleCheckGroups()
    if (!isCompetitionDivisionsPass) {
      ElMessage.error("组别信息填写有误，请根据提示修改表单信息")
      loading.value = false
      return
    }
    if (!isGroupsPass && ruleForm.innerCategoryType !== 'ENTRY_APPOINTMENT') {
      console.log("ruleForm.groups", ruleForm.groups)
      ElMessage.error("配套服务信息填写有误，请根据提示修改表单信息")
      loading.value = false
      return
    }
    if (valid) {
      // 校验富文本内容，给商品详情方式赋值
      if (isRich.value) {
        if (ruleForm.bizType !== 4) {
          const res = await handleRich2Form()
          if (!res) throw new Errow("商品描述（中文）富文本描述过长")
          const res2 = await handleRich2FormEn()
          if (!res2) throw new Errow("商品描述（English）富文本描述过长")
          ruleForm.descriptionImages = YTEditorRef.value.getImagesUrlArr()
          ruleForm.descriptionEnImages = YTEditorEnRef.value.getImagesUrlArr()
        }
      } else {
        ruleForm.descriptionType = "WX"
      }
      // 实物商品时校验商品属性
      if(ruleForm.bizType === 1 && checkPropList()) {
        ElMessage.error("有商品属性未填写，请选择商品属性！")
        loading.value = false
        return
      }
      // 组合商品 - 赛事 - 组别设置富文本赋值处理
      if (ruleForm.bizType === 5 && ruleForm.innerCategoryType === "COMPETITION") {

        let competitionDivisionsRichPassCount = 0
        let competitionDivisionsRichEnPassCount = 0
        ruleForm.competitionDivisions.map((item, index) => {
          if (!handleCompetitionDivisionsRich2Form(index)) competitionDivisionsRichPassCount++
          if (!handleCompetitionDivisionsRich2FormEn(index)) competitionDivisionsRichEnPassCount++
        })
        if (competitionDivisionsRichPassCount > 0) throw new Errow("组别设置中组别描述（中文）有富文本描述过长")
        if (competitionDivisionsRichEnPassCount > 0) throw new Errow("组别设置中组别描述（English）有富文本描述过长")
      }
      // 处理销售渠道的驿站、网店、俱乐部、场地、车店、理疗服务、摄影服务商添加
      ruleForm.organizeIdSet = []
      if (ruleForm.salesChannel.includes("STORE")) {
        cacheSalesChannelList.storeList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("ONLINE_STORE")) {
        cacheSalesChannelList.onlineStoreList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("CLUB")) {
        cacheSalesChannelList.clubList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("VENUE")) {
        cacheSalesChannelList.venueList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("BIKE_STORE")) {
        cacheSalesChannelList.bikeStoreList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("THERAPIST_STORE")) {
        cacheSalesChannelList.therapistStoreList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("PHOTOGRAPHY_STORE")) {
        cacheSalesChannelList.photographyStoreList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      if (ruleForm.salesChannel.includes("BRAND")) {
        cacheSalesChannelList.brandStoreList.map(i => {
          ruleForm.organizeIdSet.push(i.storeId)
        })
      }
      // 根据商品类型处理表单
      await handleFormByInnerCategory()
      if (ruleForm.bizType === 1) {
        await createItem()
      } else if (ruleForm.bizType === 2) {
        await createVirGoods()
      } else if (ruleForm.bizType === 3) {
        await createVoucher()
      } else if (ruleForm.bizType === 4) {
        await createCoupon()
      } else if (ruleForm.bizType === 5) {
        await createCompetitionItem()
      } else if (ruleForm.bizType === 6) {
        await createMallItem()
      }
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}

// 根据商品类型处理表单数据
const handleFormByInnerCategory = async () => {
  if (ruleForm.innerCategoryType === "COMPETITION") {
    ruleForm.competitionInfo = {
      province: ruleForm.province,
      provinceCode: ruleForm.provinceCode,
      city: ruleForm.city,
      cityCode: ruleForm.cityCode,
      district: ruleForm.district,
      districtCode: ruleForm.districtCode,
      addressDetail: ruleForm.addressDetail,
      addressDetailEn: ruleForm.addressDetailEn,
      startTime: ruleForm.startTime, // 赋值比赛开始时间
      endTime: ruleForm.endTime, // 赋值比赛结束时间
      applyStartTime: ruleForm.applyStartTime, // 赋值报名开始时间
      applyEndTime: ruleForm.applyEndTime, // 赋值报名结束时间
      applyUrl: ruleForm.applyUrl,
      organizerName: ruleForm.organizerName,
      organizerNameEn: ruleForm.organizerNameEn,
      competitionDivisions: ruleForm.competitionDivisions,
      relatedGoodsList: ruleForm.relatedGoodsList,
    }
  } else if (ruleForm.innerCategoryType === "COURSE") {
    ruleForm.courseInfo = {
      usageCount: ruleForm.usageCount,
      studentLimit: ruleForm.studentLimit,
      courseDuration: ruleForm.courseDuration,
      validityType: ruleForm.validityType,
      validityValue: null,
      province: ruleForm.province,
      provinceCode: ruleForm.provinceCode,
      city: ruleForm.city,
      cityCode: ruleForm.cityCode,
      district: ruleForm.district,
      districtCode: ruleForm.districtCode,
      addressDetail: ruleForm.addressDetail,
      addressDetailEn: ruleForm.addressDetailEn
    }
    if (ruleForm.courseInfo.validityType === "DAYS") {
      ruleForm.courseInfo.validityValue = ruleForm.validityDeadlineDate
    } else if (ruleForm.courseInfo.validityType === "END_DATE") {
      ruleForm.courseInfo.validityValue = ruleForm.validityDeadlineTime
    }
  } else if (ruleForm.innerCategoryType === "NUMBER") {
    console.log("ruleForm", ruleForm)
    ruleForm.numberInfo = {
      numberPrefix: ruleForm.numberPrefix,
      numberSuffix: ruleForm.numberSuffix,
      startNumber: ruleForm.startNumber,
      endNumber: ruleForm.endNumber,

    }
  } else if (ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
    console.log("ruleForm.noticeContent", ruleForm.noticeContent)
    ruleForm.serviceGoodsInfo = {
      noticeContent: ruleForm.noticeContent,
      noticeContentEn: ruleForm.noticeContentEn,
      guaranteeContent: ruleForm.guaranteeContent,
      guaranteeContentEn:  ruleForm.guaranteeContentEn,
      serviceDuration: ruleForm.serviceDuration,
      appointmentRequired: ruleForm.appointmentRequired,
      validityDays: ruleForm.validityDays,
      usageLimit: ruleForm.usageLimit
    }
  } else if (ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT') {
    ruleForm.serviceGoodsInfo = {
      maxAddQty: ruleForm.maxAddQty,
      purchaseRuleContent: ruleForm.purchaseRuleContent,
      purchaseRuleContentEn: ruleForm.purchaseRuleContentEn,
      venueEntranceCalendarSetting: ruleForm.serviceGoodsInfo?.venueEntranceCalendarSetting || "OPERATING_HOURS"
    }
  } else if (ruleForm.innerCategoryType === 'MALL') {
    // 清空成本价、原价
    ruleForm.originalPrice = null
    ruleForm.costDetails = []
    // 处理商品类目
    let fatherNode = null
    let sonNode = null
    console.log("ruleForm.bizCategoryId", ruleForm.bizCategoryId)
    if (ruleForm.bizCategoryId?.length > 0) {
      bizTypeEnum.value?.map(i => {
        if (i.bizCategoryId === ruleForm.bizCategoryId[0]) {
          fatherNode = {
            parentBizCategoryId: i.bizCategoryId,
            bizParentCategoryName: i.bizCategoryName,
            bizParentCategoryNameEn: i.bizCategoryNameEn
          }
          if (i.children.length > 0) {
            i.children?.map(sI => {
              if (sI.bizCategoryId === ruleForm.bizCategoryId[1]) {
                sonNode = {
                  bizCategoryId: sI.bizCategoryId,
                  bizCategoryName: sI.bizCategoryName,
                  bizCategoryNameEn: sI.bizCategoryNameEn,
                }
              }
            })
          } else {
            sonNode = {
              bizCategoryId: null,
              bizCategoryName: null,
              bizCategoryNameEn: null,
            }
          }
        }
      })
      // 给商品类目赋值
      ruleForm.mallGoods.bizCategoryId = sonNode.bizCategoryId
      ruleForm.mallGoods.bizCategoryName = sonNode.bizCategoryName
      ruleForm.mallGoods.bizCategoryNameEn = sonNode.bizCategoryNameEn
      ruleForm.mallGoods.parentBizCategoryId = fatherNode.parentBizCategoryId
      ruleForm.mallGoods.bizParentCategoryName = fatherNode.bizParentCategoryName
      ruleForm.mallGoods.bizParentCategoryNameEn = fatherNode.bizParentCategoryNameEn
    }
  }
}

// 创建商品
const createItem = async () => {
  try {
    // 实物商品提交时清空goodsVirtualItemList、startTime、endTime、address
    await handleGoodsSubmitClear()
    if (isEdit.value) {
      await editItem(ruleForm)
    } else {
      await addItem(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    // 创建成功后清空富文本缓存
    if (isRich.value) {
      const id = isEdit.value ? ruleForm.goodsId : "0"
      YTEditorRef.value.removeCache(id)
    }
    loading.value = false
    router.push('/listItem')
  } catch (e) {
    console.log(e)
    loading.value = false
    console.log("实体商品创建错误")
  }
}

// 创建虚拟商品
const createVirGoods = async () => {
  try {
    // 虚拟商品提交时清空propertyGroupList
    await handleVirGoodsSubmitClear()
    handleSetInsuranceList()
    const submitData = getVirtualGoodsSubmitData()
    if (isEdit.value) {
      await editVirtualGoods(submitData)
    } else {
      await addVirtualGoods(submitData)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    // 创建成功后清空富文本缓存
    if (isRich.value) {
      const id = isEdit.value ? ruleForm.goodsId : "0"
      YTEditorRef.value.removeCache(id)
    }
    loading.value = false
    router.push('/listItem')
  } catch (e) {
    console.log(e)
    loading.value = false
    console.log("虚拟商品创建错误")
  }
}

// 创建电子卡券商品
const createVoucher = async () => {
  try {
    // 处理有效期
    if (ruleForm.voucherInfo.validityType === "DAYS") {
      ruleForm.voucherInfo.validityValue = ruleForm.voucherInfo.validityDeadlineDate
    } else if (ruleForm.voucherInfo.validityType === "END_DATE") {
      ruleForm.voucherInfo.validityValue = ruleForm.voucherInfo.validityDeadlineTime
    }
    // 处理使用次数
    ruleForm.voucherInfo.usageCount = ruleForm.usageCount
    // 处理积分价格
    ruleForm.voucherInfo.pointsPrice = ruleForm.pointsPrice
    // 处理关联驿站
    ruleForm.voucherInfo.stores = ruleForm.stores
    // 电子卡券提交时清空goodsVirtualItemList、startTime、endTime、address、groups、competitionDivisions、propertyGroupList
    // 处理关联类型
    ruleForm.voucherInfo.relationType = ruleForm.relationType
    ruleForm.voucherInfo.serviceItemId = ruleForm.serviceItemId
    // 选择关联项目，清空voucherInfo.relatedGoods
    if (ruleForm.relationType === 'SERVICE_ITEM') ruleForm.voucherInfo.relatedGoods = null
    // 处理须知、保障、使用规则
    ruleForm.voucherInfo.noticeContent = ruleForm.noticeContent
    ruleForm.voucherInfo.noticeContentEn = ruleForm.noticeContentEn
    ruleForm.voucherInfo.guaranteeContent = ruleForm.guaranteeContent
    ruleForm.voucherInfo.guaranteeContentEn = ruleForm.guaranteeContentEn
    ruleForm.voucherInfo.ruleDescription = ruleForm.ruleDescription
    ruleForm.voucherInfo.ruleDescriptionEn = ruleForm.ruleDescriptionEn
    await handleVoucherSubmitClear()
    if (isEdit.value) {
      await editVoucher(ruleForm)
    } else {
      await addVoucher(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listItem')
  } catch (e) {
    console.log(e)
    loading.value = false
    console.log("电子卡券创建错误")
  }
}

// 创建付费优惠券商品
const createCoupon = async () => {
  try {
    // 处理有效期
    if (ruleForm.couponInfo.validityType === "DAYS") {
      ruleForm.couponInfo.validityValue = ruleForm.couponInfo.validityDeadlineDate
    } else if (ruleForm.couponInfo.validityType === "END_DATE") {
      ruleForm.couponInfo.validityValue = ruleForm.couponInfo.validityDeadlineTime
    }
    // 处理使用次数
    ruleForm.couponInfo.usageCount = ruleForm.usageCount
    // 处理积分价格
    ruleForm.couponInfo.pointsPrice = ruleForm.pointsPrice
    // 处理关联驿站
    ruleForm.couponInfo.stores = ruleForm.stores
    // 付费优惠券提交时清空不相关数据
    await handleCouponSubmitClear()
    if (isEdit.value) {
      await editCoupon(ruleForm)
    } else {
      await addCoupon(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    loading.value = false
    router.push('/listItem')
  } catch (e) {
    console.log(e)
    loading.value = false
    console.log("付费优惠券创建错误")
  }
}

// 提交电子卡券清空其余数据
const handleVoucherSubmitClear = async () => {
  // 电子卡券提交时清空不相关属性
  ruleForm.goodsVirtualItemList = []
  ruleForm.startTime = null
  ruleForm.endTime = null
  ruleForm.address = null
  ruleForm.groups = []
  ruleForm.competitionDivisions = []
  ruleForm.propertyGroupList = []
}
// 提交付费优惠券清空其余数据
const handleCouponSubmitClear = async () => {
  // 付费优惠券提交时清空不相关属性
  ruleForm.goodsVirtualItemList = []
  ruleForm.startTime = null
  ruleForm.endTime = null
  ruleForm.address = null
  ruleForm.groups = []
  ruleForm.competitionDivisions = []
  ruleForm.propertyGroupList = []
}
// 提交组合商品清空其余数据
const handleComboGoodsSubmitClear = async () => {
  // 组合商品提交时清空不相关属性
  ruleForm.goodsVirtualItemList = []
  ruleForm.propertyGroupList = []
  ruleForm.voucherInfo = {}
}

// 选择了商品类型
const handleSelectType = async (value) => {
  ruleForm.bizType = value
  // 实物商品与虚拟商品的商品分类不同，切换时需要重新请求商品分类
  ruleForm.innerCategoryType = null
  rules.value = rulesVirDefault
  getCategoryList()
  console.log("value", value)
  if (value === 3 || value === 4) {
    ruleForm.salesChannel = []
    ruleForm.organizeIdSet = []
    cacheSalesChannelList.storeList = []
    cacheSalesChannelList.onlineStoreList = []
    cacheSalesChannelList.clubList = []
    cacheSalesChannelList.venueList = []
    cacheSalesChannelList.bikeStoreList = []
    cacheSalesChannelList.therapistStoreList = []
    cacheSalesChannelList.photographyStoreList = []
    cacheSalesChannelList.brandStoreList = []
    if (value === 3) {
      await handleGetServiceItemList()
    }
  }
}
// 添加商品属性
const handleAddProp = () => {
  if (ruleForm.bizType === 1) {
    if (itemProp.value.length === 0) {
      itemProp.value.push({
        groupName: null,
        propertyGroupId: null,
        propertyGroupItemList: [],
        unDisabled: true
      })
    } else {
      if (itemProp.value[itemProp.value.length - 1].groupName) {
        itemProp.value.push({
          groupName: null,
          propertyGroupId: null,
          propertyGroupItemList: [],
          unDisabled: true
        })
      } else {
        ElMessage.error("请先选择未填写的商品属性后再添加新的属性！")
      }
    }
  } else if (ruleForm.bizType === 2 || ruleForm.bizType === 5) {
    open.value = true
  }
}
// 检测是否有商品属性未填
const checkPropList = () => {
  return itemProp.value.some(res => res.groupName === null)
}

/*图片上传组件*/
// 商品图片上传组件锚点
const boxUploadRef = ref()
// 处理图片反显
const handleReviewPic = (reviewList) => {
  boxUploadRef.value.handleReview(reviewList)
}
// 处理组别图片反显
const handleReviewCompetitionDivisionsUploadPic = (reviewList) => {
  boxUploadCompetitionDivisionsRef.value.forEach((item, index) => {
    console.log("组别反显图片", [reviewList[index].routeMapUrl])
    if (reviewList[index].routeMapUrl) {
      item.handleReview([reviewList[index].routeMapUrl])
    }
  })
}
// 处理图片上传成功
const handlePicSuccess = (url) => {
  ruleForm.images = []
  ruleForm.images = url
  loading.value = false
  ruleFormRef.value.validateField("images")
}
// 处理图片列表改变
const handleImageRemove = (url) => {
  ruleForm.images = url
  ruleFormRef.value.validateField("images")
}
// 赛事发现页推荐封面图上传组件锚点
const boxUploadDiscoverCoverRef = ref()
// 处理 赛事发现页推荐封面图片上传成功
const handleDiscoverCoverPicSuccess = (url) => {
  ruleForm.discoverCoverImage = []
  ruleForm.discoverCoverImage = url
  loading.value = false
  ruleFormRef.value.validateField("discoverCoverImage")
}
// 处理赛事发现页推荐封面图片列表改变
const handleDiscoverCoverImageRemove = (url) => {
  ruleForm.discoverCoverImage = url
  ruleFormRef.value.validateField("discoverCoverImage")
}
// 处理赛事发现页推荐封面图片反显
const handleReviewDiscoverCoverPic = (reviewList) => {
  boxUploadDiscoverCoverRef.value.handleReview([reviewList])
}

/*商品属性功能*/
// 翻页信息：当前页数、当前页条目数、总条目数
const page = ref(1)
const pageSize = ref(20)
const total = ref(0)

// 获取商品属性列表
const getPropList = async () => {
  const param = ref({
    page: page.value,
    pageSize: pageSize.value
  })
  selectLoading.value = true
  const res = await goodsPropertyList(param.value)
  options.value = []
  options.value = res.list
  total.value = parseInt(res.total)
  selectLoading.value = false
}
// 商品属性列表翻页
const handleChangePage = () => {
  getPropList()
}
// 可选属性项列表
const options = ref([])
// 全选状态
const checkAll = ref(false)
// 处理全选
const handleCheckAllProp = () => {
  let all = []
  cacheProp.value.propertyGroupItemList.forEach(item => {
    all.push(item.propertyGroupItemId)
  })
  cacheSelect.value = checkAll.value ? all : []
}
// 实物商品属性列表
const itemProp = ref([])
// 删除虚拟商品属性项
const handleRemoveVirProp = (index) => {
  ruleForm.goodsVirtualItemList.splice(index, 1)
}
// 虚拟商品新增属性表单锚点
const virFormRef = ref()
// 虚拟商品新增属性表单
const virForm = reactive({
  name: null,
  content: null,
  sort: 0
})
// 虚拟商品新增属性表单校验规则
const virRules = reactive({
  name: [
    {required: true, message: "属性名称不能为空", trigger: "change"}
  ],
  content: [
    {required: true, message: "属性值不能为空", trigger: "change"}
  ]
})
// 确认添加虚拟商品属性项
const handleConfirmVir = () => {
  virFormRef.value.validate(async (valid) => {
    if (valid) {
      let param = {
        ...virForm,
        sort: ruleForm.goodsVirtualItemList.length + 1
      }
      ruleForm.goodsVirtualItemList.push(param)
    } else {
      ElMessage.error({
        message: "请根据提示修改表单信息",
        appendTo: "#YTFormDialog"
      })
      return
    }
    handleCancelVir()
  })
}
// 关闭/取消虚拟商品属性项
const handleCancelVir = () => {
  open.value = false
  virForm.name = null
  virForm.content = null
  virFormRef.value.clearValidate()
}
// 选中的属性值颜色区分
const handleTagType = (index) => {
  const enumList = ['primary', 'success', 'warning', 'danger']
  return enumList[index % 4]
}
// 删除属性项
const handleRemoveProp = (index) => {
  itemProp.value.splice(index, 1)
}
// 缓存属性选项
const cacheProp = ref()
// 缓存商品索引值
const cacheIndex = ref()
// 缓存对话框选择属性项
const cacheSelect = ref([])
// 下拉框选择商品属性
const handleSelectProp = (item, index) => {
  itemProp.value[index].propertyGroupItemList = []
  const el = options.value.find(res => res.propertyGroupId === item.propertyGroupId)
  cacheIndex.value = index
  cacheProp.value = el
  open.value = true
  item.groupName = el.groupName
}
// 选择商品属性对话框打开状态
const open = ref(false)
// 确认选择商品属性
const handleConfirmProp = () => {
  itemProp.value[cacheIndex.value].propertyGroupItemList = []
  // 过滤选项
  cacheSelect.value.forEach(item => {
    let param = cacheProp.value.propertyGroupItemList.find(res => res.propertyGroupItemId === item)
    itemProp.value[cacheIndex.value].propertyGroupItemList.push(param.propertyGroupItemId)
  })
  handleCancelProp()
}
// 取消/关闭选择商品属性对话框
const handleCancelProp = () => {
  if (!itemProp.value[cacheIndex.value].propertyGroupItemList.length) handleRemoveProp(cacheIndex.value)
  cacheProp.value = null
  cacheIndex.value = null
  cacheSelect.value = []
  open.value = false
  checkAll.value = false
}
// 处理多选改变
const handleCheckAll = () => {
  const checkedCount = cacheProp.value.propertyGroupItemList.length
  checkAll.value = checkedCount === cacheSelect.value.length
}
// 处理属性项中属性值label显示
const handleFindPropLabel = (value, group) => {
  const item = options.value.find(res => res.propertyGroupId === group)
  return item.propertyGroupItemList.find(res => res.propertyGroupItemId === value).propertyName
}

/*处理实体商品虚拟商品提交时无关值清空*/
// 处理实体商品提交，清空虚拟商品相关属性
const handleGoodsSubmitClear = async () => {
  // 实物商品提交时清空不相关属性
  ruleForm.goodsVirtualItemList = []
  ruleForm.virTime = []
  ruleForm.startTime = null
  ruleForm.endTime = null
  ruleForm.applyTime = []
  ruleForm.applyEndTime = null
  ruleForm.applyStartTime = null
  ruleForm.address = null
  ruleForm.usageCount = null
  ruleForm.applyUrl = null
  ruleForm.voucherInfo = {}
  ruleForm.competitionInfo = {}
  ruleForm.courseInfo = {}
  ruleForm.numberInfo = {}
  ruleForm.competitionDivisions = []
}
// 处理虚拟商品提交，清空实体商品相关属性
const handleVirGoodsSubmitClear = async () => {
  // 虚拟商品提交时清空propertyGroupList
  console.log("清空前ruleForm", ruleForm)
  ruleForm.propertyGroupList = []
  ruleForm.voucherInfo = {}
  ruleForm.competitionInfo = {}
  if (ruleForm.innerCategoryType === "COURSE") {
    // 课程不传virTime、startTime、endTime、applyTime、applyUrl
    if (ruleForm.innerCategoryType === "COURSE") {
      ruleForm.virTime = []
      ruleForm.startTime = null
      ruleForm.endTime = null
    }
    // 活动不传applyUrl
    ruleForm.applyUrl = null
    ruleForm.numberInfo = {}
  }
  if (ruleForm.innerCategoryType !== "COURSE" && ruleForm.innerCategoryType !== 'NUMBER') {
    // 非课程、非活动、非号码清空virTime、startTime、endTime、address、applyTime、applyUrl
    ruleForm.virTime = []
    ruleForm.startTime = null
    ruleForm.endTime = null
    ruleForm.address = null
    ruleForm.applyTime = []
    ruleForm.applyEndTime = null
    ruleForm.applyStartTime = null
    ruleForm.applyUrl = null
    ruleForm.courseInfo = {}
    ruleForm.numberInfo = {}
  }
  if (ruleForm.innerCategoryType !== 'THERAPY_SERVICE' && ruleForm.innerCategoryType !== 'PHOTOGRAPHY' && ruleForm.innerCategoryType !== 'BIKE_MAINTENANCE' && ruleForm.innerCategoryType !== 'VOUCHER' && ruleForm.innerCategoryType !== 'VENUE_COURSE' && ruleForm.innerCategoryType !== 'APPOINTMENT_SERVICE') {
    // 非理疗服务、摄影服务、整装保养、电子卡券、场地课程、场地服务清空listingTime、delistingTime、tagList、noticeContent、guaranteeContent
    ruleForm.listingTime = null
    ruleForm.delistingTime = null
    ruleForm.tagList = []
    ruleForm.noticeContent = null
    ruleForm.noticeContentEn = null
    ruleForm.guaranteeContent = null
    ruleForm.guaranteeContentEn = null
    ruleForm.ruleDescription = null
    ruleForm.ruleDescriptionEn = null
  }
}
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  ruleForm.address = data.label
  ruleForm.addressCode = data.value
  let dataInfo = data.label.split("/")
  let dataCodeInfo = data.value.split("/")
  console.log("dataInfo", dataInfo)
  ruleForm.province = dataInfo[0]
  ruleForm.provinceCode = dataCodeInfo[0]
  ruleForm.city = dataInfo[1]
  ruleForm.cityCode = dataCodeInfo[1]
  ruleForm.district = dataInfo[2]
  ruleForm.districtCode = dataCodeInfo[2]
  ruleFormRef.value.validateField("address")
  console.log("ruleForm: ", ruleForm)
}

/*商品描述富文本输入框相关*/
// 是否为富文本输入
const isRich = ref(true)
// 商品描述（中文）锚点
const YTEditorRef = ref()
// 商品描述（English）锚点
const YTEditorEnRef = ref()
// 处理商品描述（中文）富文本赋值给表单
const handleRich2Form = async () => {
  console.log("赋值结果", YTEditorRef.value.getTxtTooLongState())
  if (YTEditorRef.value.getTxtTooLongState()) {
    ElMessage.error("商品描述（中文）内容过长，描述内容请按规定照字数编写。")
    return false
  }
  ruleForm.description = YTEditorRef.value.getTxt()
  return true
}
// 处理商品描述（English）富文本赋值给表单
const handleRich2FormEn = async () => {
  console.log("赋值结果", YTEditorEnRef.value.getTxtTooLongState())
  if (YTEditorEnRef.value.getTxtTooLongState()) {
    ElMessage.error("商品描述（English）内容过长，描述内容请按规定照字数编写。")
    return false
  }
  ruleForm.descriptionEn = YTEditorEnRef.value.getTxt()
  return true
}

/*扩展信息相关*/
// 成本价弹窗状态
const openCostPrice = ref(false)
// 成本价弹窗表单锚点
const costPriceFormRef = ref()
// 成本价表单
const costPriceForm = reactive({
  costName: null,
  costPrice: 0
})
// 成本价表单校验规则
const costPriceRules = reactive({
  costName: [
    {required: true, message: "请输入成本名称", trigger: "change"}
  ],
  costPrice: [
    {required: true, message: "请输入成本价格", trigger: "change"}
  ]
})
// 处理添加成本价
const handleAddCostPrice = () => {
  openCostPrice.value = true
}
// 处理成本价弹窗关闭
const handleCancelCostPrice = () => {
  openCostPrice.value = false
  costPriceForm.costName = null
  costPriceForm.costPrice = 0
  costPriceFormRef.value.clearValidate()
}
// 处理成本价弹窗确认
const handleConfirmCostPrice = () => {
  costPriceFormRef.value.validate(async (valid) => {
    if (valid) {
      let param = {
        ...costPriceForm,
      }
      ruleForm.costDetails.push(param)
    } else {
      ElMessage.error({
        message: "请根据提示修改表单信息",
        appendTo: "#YTFormDialogCostPrice"
      })
      return
    }
    handleCancelCostPrice()
  })
}
// 删除成本价
const handleRemoveCostPrice = (index) => {
  ruleForm.costDetails.splice(index, 1)
}

// 添加组别
const handleAddCompetitionDivisions = () => {
  const isPass = handleCheckCompetitionDivisions()
  if (!isPass) {
    ElMessage.error("组别设置填写有误！组别设置中组别名称必填")
    return
  }
  ruleForm.competitionDivisions.push({
    divisionName: null,
    divisionNameEn: "Coming Soon ...",
    originalPrice: 0,
    entryFee: 0,
    vipEntryFee: 0,
    distance: null,
    elevationGain: null,
    quotaLimit: 0,
    routeMapUrl: null,
    description: null,
    descriptionEn: "Coming Soon ...",
    descriptionImages: [],
    descriptionImagesEn: []
  })
}
// 删除组别
const handleRemoveCompetitionDivisions = (index) => {
  ruleForm.competitionDivisions.splice(index, 1)
}
// 检查组别填写完整性
const handleCheckCompetitionDivisions = () => {
  let wrongCount = 0
  ruleForm.competitionDivisions.map(item => {
    if (item.divisionName === null) wrongCount++
  })
  return wrongCount === 0
}
// 组别设置上传组件锚点
const boxUploadCompetitionDivisionsRef = ref([])
// 组别描述（中文）富文本组件锚点
const YTEditorCompetitionDivisionsRef = ref()
// 组别描述（English）富文本组件锚点
const YTEditorCompetitionDivisionsEnRef = ref()
// 处理组别描述（中文）富文本赋值给表单
const handleCompetitionDivisionsRich2Form = async (index) => {
  console.log("赋值结果", YTEditorCompetitionDivisionsRef.value[index].getTxtTooLongState())
  if (YTEditorCompetitionDivisionsRef.value[index].getTxtTooLongState()) {
    ElMessage.error(`组别设置中第${index + 1}项组别描述（中文）内容过长，描述内容请按规定照字数编写。`)
    return false
  }
  ruleForm.competitionDivisions[index].description = YTEditorCompetitionDivisionsRef.value[index].getTxt()
  return true
}
// 处理组别描述（English）富文本赋值给表单
const handleCompetitionDivisionsRich2FormEn = async (index) => {
  console.log("赋值结果", YTEditorCompetitionDivisionsEnRef.value[index].getTxtTooLongState())
  if (YTEditorCompetitionDivisionsEnRef.value[index].getTxtTooLongState()) {
    ElMessage.error(`组别设置中第${index + 1}项组别描述（English）内容过长，描述内容请按规定照字数编写。`)
    return false
  }
  ruleForm.competitionDivisions[index].descriptionEn = YTEditorCompetitionDivisionsEnRef.value[index].getTxt()
  return true
}
// 处理组别设置图片上传成功
const handleCompetitionDivisionsPicSuccess = (url, index) => {
  console.log(`第${index + 1}个组别图片上传成功`)

  // 更新表单数据
  if (!ruleForm.competitionDivisions[index]) {
    ruleForm.competitionDivisions[index] = {}
  }
  ruleForm.competitionDivisions[index].routeMapUrl = url[0]
  loading.value = false
}
// 处理组别设置图片移除
const handleCompetitionDivisionsPicRemove = (url, index) => {
  console.log(`删除第${index + 1}个组别的图片`, url);

  // 确保组别对象存在
  if (!ruleForm.competitionDivisions[index]) {
    ruleForm.competitionDivisions[index] = {};
  }

  // 更新图片URL数据
  ruleForm.competitionDivisions[index].routeMapUrl = url.length > 0 ? url[0] : null

  console.log('删除后组别数据:', ruleForm.competitionDivisions[index]);
}

// 配套服务类型枚举值
const groupTypeEnum = [
  {
    label: "固定组",
    value: "FIXED"
  }, {
    label: "可选组",
    value: "OPTION"
  }
]
// 添加配套服务
const handleGroups = () => {
  const isPass = handleCheckGroups()
  if (!isPass) {
    ElMessage.error("配套服务填写有误！配套服务中服务名称必填，并且需要添加配套商品")
    return
  }
  ruleForm.groups.push({
    groupName: null,
    groupNameEn: "Coming Soon ...",
    groupType: "OPTION",
    items: [],
  })
}
// 删除配套服务
const handleRemoveGroups = (index) => {
  ruleForm.groups.splice(index, 1)
}
// 处理配套服务关联商品
const handleAddGroupsItem = (item, index) => {
  // 判断配套服务关联商品数量：赛事 - 只能关联一个
  // if (ruleForm.groups[index].items.length >= 1 && ruleForm.innerCategoryType === "COMPETITION") {
  //   ElMessage.error("赛事的每一个配套服务都只能关联一件商品！")
  //   return
  // }
  console.log("index", index)
  cachePanelItem.value = item
  cachePanelIndex.value = index
  console.log("cachePanelIndex.value", cachePanelIndex.value)
  console.log("cachePanelItem.value", cachePanelItem.value)
  cacheOpenType.value = 1
  openGroupGoodsList.value = true
  handleSearchGoods()
}
// 处理赛事添加周边商品
const handleAddRelatedGoodsList = () => {
  cacheOpenType.value = 3
  openGroupGoodsList.value = true
  handleSearchGoods()
}
// 处理组别设置（中文）富文本改变
const handleCompetitionDivisionsDesc = (index, txt, imgArr) => {
  ruleForm.competitionDivisions[index].descriptionImages = imgArr
}
// 处理组别设置（English）富文本改变
const handleCompetitionDivisionsDescEn = (index, txt, imgArr) => {
  ruleForm.competitionDivisions[index].descriptionImagesEn = imgArr
}
// 处理配套服务勾选“必选”
const handleGroupTypeChange = (e, index) => {
  ruleForm.groups[index].groupType = e ? "FIXED" : "OPTION"
  console.log("ruleForm.groups[index]", ruleForm.groups[index])
}

// 搜索商品加载状态
const goodsLoading = ref(false)
// 搜索出的商品列表
const goodsList = ref([])
// 商品列表页数、页长
const groupGoodsPage = ref(1)
const groupGoodsPageSize = ref(5)
// 商品总数
const totalGroupGoods = ref(0)
// 选择组合商品/配套服务关联商品弹窗状态
const openGroupGoodsList = ref(false)
// 关闭组合商品/配套服务关联商品/电子卡券弹窗
const handlePanelGroupGoodsListClose = () => {
  openGroupGoodsList.value = false
  // 清空缓存数据
  cachePanelItem.value = null
  cachePanelIndex.value = null
  cacheKeyword.value = null
  cacheOpenType.value = null
  cachePanelItemPropSelect.value = []
  goodsList.value = []
}
// 选择组合商品/配套服务关联点击确认/电子卡券关联商品/虚拟商品入场预约
const handlePanelGroupGoodsListConfirm = (item) => {
  const res = goodsList.value.find(i => i.value === item[0])
  console.log("res", res)
  if (ruleForm.bizType === 3) {
    console.log("cachePanelItem.value", cachePanelItem.value)
    console.log("cachePanelItemPropSelect", cachePanelItemPropSelect.value)
    // 遍历出所选商品的所有商品属性，压成一个数组，方便检索
    let targetArr = []
    // 需要给后端的数据格式
    let temp = []
    cachePanelItem.value.propertyGroupList.map(i => {
      console.log("i", i)
      i.propertyGroupItemList.map(sI => {
        targetArr.push(sI)
      })
    })
    console.log("targetArr", targetArr)
    let relatedGoodsName = cachePanelItem.value.goodsName
    // 遍历勾选的商品属性，从所有商品属性数组中进行检索，并且压成一个对象数组
    cachePanelItemPropSelect.value.map(i => {
      // 因为checkbox组件限制单个组只能选一个，所以这里固定写死i[0]
      const res = targetArr.find(target => target.propertyGroupItemId === i[0])
      relatedGoodsName += ` - ${res.propertyName}`
      temp.push({
        propertyGroupId: res.propertyGroupId,
        propertyGroupItemId: res.propertyGroupItemId,
      })
    })
    console.log("temp", temp)
    ruleForm.voucherInfo.relatedGoods = {
      goodsId: res.value,
      goodsProperties: temp,
      relatedGoodsName: relatedGoodsName
    }
    console.log("电子卡券关联ruleForm", ruleForm)
  } else if (cacheOpenType.value === 3) {
    let param = {
      goodsId: res.value,
      goodsName: res.name,
      deadlineTime: null,
      refundDeadlineTime: null,
      needLogistics: false,
      maxQuantityPerUser: null
    }
    ruleForm.relatedGoodsList.push(param)
    console.log("ruleForm.relatedGoodsList", ruleForm.relatedGoodsList)
  } else if (cacheOpenType.value === 4) {
    // 初始化groups
    if (ruleForm.groups.length <= 0) {
      ruleForm.groups = [{
        groupName: "默认",
        groupNameEn: "default",
        groupType: "OPTION",
        optionCount: 0,
        items: []
      }]
    }
    if (ruleForm.groups[0].items.length >= 20) {
      return ElMessage.error("关联商品最多添加20个")
    }
    let param = {
      goodsId: res.value,
      goodsName: res.name,
    }
    ruleForm.groups[cachePanelIndex.value].items.push(param)
    ruleForm.groups[cachePanelIndex.value].optionCount = ruleForm.maxAddQty
    if (ruleForm.groups[cachePanelIndex.value].items.length > 0) {
      rules.value = rulesTenMod
    } else {
      rules.value = rulesVirDefault
    }
    ruleFormRef.value.validateField("groups")
  } else {
    let param = {
      goodsId: res.value,
      goodsName: res.name,
      isGift: false,
      needLogistics: false,
      allowModifyGift: false,
      giftCount: 1,
      deadlineTime: null,
      refundDeadlineTime: null
    }
    if (ruleForm.innerCategoryType === "COMBO") {
      param.fixedCount = 1
      param.optionCount = 1
    }
    ruleForm.groups[cachePanelIndex.value].items.push(param)
    console.log("ruleForm.groups", ruleForm.groups)
    ruleFormRef.value.validateField("groups")
  }
}
// 组合商品/配套服务关联商品面板缓存信息
const cachePanelItem = ref()
// 组合商品/配套服务关联商品面板索引缓存
const cachePanelIndex = ref()
// 组合商品/配套服务关联商品面板搜索关键词
const cacheKeyword = ref()
// 组合商品/配套服务关联商品面板锚点
const YTCheckPanelRef = ref()
// 商品搜索面板类型：1：组合商品 - 赛事 - 配套服务 2：组合商品 - 组合 - 分组商品 3：组合商品 - 赛事 - 周边列表 4：虚拟商品 - 入场预约
const cacheOpenType = ref()
// 电子卡券商品面板商品属性缓存信息
const cachePanelItemPropSelect = ref([])

// 处理商品名称拼接绑定驿站
const handleGoodsNameBindStoresStr = (goodsName, stores = []) => {
  let storeArr = []
  stores.map(i => {
    storeArr.push(i.storeName)
  })
  return stores.length > 0 ? goodsName + "-" + storeArr.join("、") : goodsName
}
// 根据名称查询商品
const handleSearchGoods = async () => {
  try {
    goodsLoading.value = true
    let param = {
      page: groupGoodsPage.value,
      pageSize: groupGoodsPageSize.value
    }
    let data = {
      keyword: cacheKeyword.value,
      tenantId: cacheTenant.value.tenantId ?? null
    }
    goodsList.value = []
    const res = await listGoodsIgnoreTenant(param, data)
    res.list.forEach((item) => {
      console.log("item", item)
      let bindStoreName = ""
      if (item.innerCategoryType === "VOUCHER") {
        let storeArr = []
        if (ruleForm.innerCategoryType !== 'COMPETITION') {
          item.voucherInfo?.stores.map(i => {
            storeArr.push(i.storeName)
          })
          if (item.voucherInfo?.stores.length > 0) bindStoreName += "-" + storeArr.join("、")
        }
      } else if (item.innerCategoryType === "COUPON") {
        let storeArr = []
        item.couponInfo.stores.map(i => {
          storeArr.push(i.storeName)
        })
        if (item.couponInfo.stores.length > 0) bindStoreName += "-" + storeArr.join("、")
      }
      const param = {
        name: bindStoreName === "" ? item.goodsName : item.goodsName + bindStoreName,
        value: item.goodsId
      }
      goodsList.value.push(param)
    })
    totalGroupGoods.value = parseInt(res.total)
    goodsLoading.value = false
  } catch (e) {
    console.log(e)
    goodsLoading.value = false
  }
}

// 检查配套服务填写完整性
const handleCheckGroups = () => {
  let wrongCount = 0
  ruleForm.groups.map(item => {
    if (item.groupName === null || item.items.length <= 0) wrongCount++
  })
  return wrongCount === 0
}

// 关联商品翻页
const handleChangeGroupGoodsPage = () => {
  YTCheckPanelRef.value.handleClearCacheSelect()
  if (ruleForm.bizType === 3) {
    handleSearchGoodsByTenant()
  } else {
    handleSearchGoods()
  }

}
// 选择组合商品/配套服务面板点击搜索
const handlePanelSearchGoods = () => {
  groupGoodsPage.value = 1
  YTCheckPanelRef.value.handleClearCacheSelect()
  if (ruleForm.bizType === 3) {
    handleSearchGoodsByTenant()
  } else {
    handleSearchGoods()
  }
}

// 删除配套服务关联商品
const handleRemoveGroupsItems = (index, sonIndex) => {
  ruleForm.groups[index].items.splice(sonIndex, 1)
}

// 删除赛事周边商品商品
const handleRelatedGoodsListItems = (index, sonIndex) => {
  ruleForm.relatedGoodsList.splice(index, 1)
}

// 创建组合商品
const createCompetitionItem = async () => {
  console.log("组合商品提交的数据", ruleForm)
  try {
    loading.value = true
    // 组合商品提交时清空不相关数据
    await handleComboGoodsSubmitClear()
    if (isEdit.value) {
      await editComboItem(ruleForm)
    } else {
      await addComboItem(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    // 创建成功后清空富文本缓存
    if (isRich.value) {
      const id = isEdit.value ? ruleForm.goodsId : "0"
      YTEditorRef.value.removeCache(id)
    }
    loading.value = false
    router.push('/listItem')
  } catch (e) {
    console.log(e)
    loading.value = false
    console.log("组合商品创建错误")
  }
}

// 创建商城商品
const createMallItem = async () => {
  console.log("商城商品提交的数据", ruleForm)
  try {
    loading.value = true
    let temp1 = []
    ruleForm.mallGoodsCategoryTagList.map(item => {
      if (isEdit.value) {
        temp1.push(item.tagId ? item.tagId : item)
      } else {
        temp1.push(item)
      }
    })
    ruleForm.mallGoodsCategoryTagList =temp1
    let temp2 = []
    ruleForm.mallServiceInfoTagList.map(item => {
      if (isEdit.value) {
        temp2.push(item.tagId ? item.tagId : item)
      } else {
        temp2.push(item)
      }
    })
    ruleForm.mallServiceInfoTagList = temp2
    let temp3 = []
    ruleForm.mallReturnPolicyTagList.map(item => {
      if (isEdit.value) {
        temp3.push(item.tagId ? item.tagId : item)
      } else {
        temp3.push(item)
      }
    })
    ruleForm.mallReturnPolicyTagList = temp3

    if (isEdit.value) {
      await editMallItem(ruleForm)
    } else {
      await addMallItem(ruleForm)
    }
    ElMessage({
      type: "success",
      message: isEdit.value ? "修改成功" : "创建成功",
      duration: 3000
    })
    // 创建成功后清空富文本缓存
    if (isRich.value) {
      const id = isEdit.value ? ruleForm.goodsId : "0"
      YTEditorRef.value.removeCache(id)
    }
    loading.value = false
    router.push('/listItem')
  } catch (e) {
    console.log(e)
    loading.value = false
    console.log("商城商品创建错误")
  }
}

// 处理添加分组商品
const handleGroupsGoods = () => {
  ruleForm.groups.push(
      {
        groupName: null,
        optionCount: null,
        groupType: "OPTION",
        items: [],
        needReissue: false
      }
  )
}
// 处理删除分组商品中的关联商品
const handleRemoveGroupGoodsItems = (index, sonIndex) => {
  ruleForm.groups[index].items.splice(sonIndex, 1)
  try {
    ruleForm.groups[index].optionCount--
  } catch (e) {
    console.log(e)
  }
}
// 处理添加分组商品中的关联商品
const handleAddGroupGoods = (item, index) => {
  console.log("index", index)
  cachePanelItem.value = item
  cachePanelIndex.value = index
  console.log("cachePanelIndex.value", cachePanelIndex.value)
  cacheOpenType.value = 2
  openGroupGoodsList.value = true
  handleSearchGoods()
}
// 处理删除分组商品
const handleRemoveGroupGoods = (index) => {
  ruleForm.groups.splice(index, 1)
}
// 处理分组商品勾选“必选”
const handleComboGroupTypeChange = (e, index) => {
  ruleForm.groups[index].groupType = e ? "FIXED" : "OPTION"
  console.log("ruleForm.groups[index]", ruleForm.groups[index])
}
// 处理配套服务商品勾选“是否赠送”
const handleIsGiftChange = (e, index, sonIndex) => {
  ruleForm.groups[index].items[sonIndex].isGift = e
  console.log("ruleForm.groups[index]", ruleForm.groups[index])
}
// 处理组合商品勾选“是否需要补发”
const handleNeedReissueChange = (e, index, sonIndex) => {
  ruleForm.groups[index].items[sonIndex].needReissue = e
}
// 处理配套服务商品勾选需要物流
const handleNeedLogistics = (e, index, sonIndex) => {
  ruleForm.groups[index].items[sonIndex].needLogistics = e
}
// 处理周边商品勾选需要物流
const handleRelatedGoodsListNeedLogistics = (e, index) => {
  ruleForm.relatedGoodsList[index].needLogistics = e
}
// 处理配套服务商品勾选报名时会员可在赠送数量范围内更改数量
const handleAllowModifyGift = (e, index, sonIndex) => {
  ruleForm.groups[index].items[sonIndex].allowModifyGift = e
}
// 处理配套服务填写“默认赠送数量”重新校验配套服务规则
const handleGiftCountChange = () => {
  ruleFormRef.value.validateField("groups")
}

/*中英文切换输入框相关Tab*/
// 商品名称tab
const goodsNameTab = ref("zh")
// 商品单位tab
const goodsUnitTab = ref("zh")
// 商品简介tab
const summaryTab = ref("zh")
// 商品须知tab
const noticeContentTab = ref("zh")
// 商品保障tab
const guaranteeContentTab = ref("zh")
// 使用规则tab
const ruleDescriptionTab = ref("zh")
// 商品描述tab
const descTab = ref("zh")
// 主办方tab
const organizerNameTab = ref("zh")
// 组别名称tab
const divisionNameTab = ref("zh")
// 组别描述tab
const competitionDivisionsDescTab= ref("zh")
// 服务名称tab
const groupNameTab = ref("zh")
// 地点tab
const addressDetailTab = ref("zh")
// “入场预约”商品购买规则tab
const purchaseRuleContentTab = ref("zh")
// 保险购买注意事项tab
const insurancePurchaseNoticeTab = ref("zh")

// 处理电子卡券扩展信息关联商品
const handleAddVoucherItem = () => {
  // if (ruleForm.stores.length <= 0 && ruleForm.relationType === 'STORE') return ElMessage.error("请先关联至少一个驿站")
  if (ruleForm.voucherInfo.relatedGoods.goodsId !== null) return ElMessage.error("电子卡券只能关联一个商品")
  openGroupGoodsList.value = true
  // handleSearchGoods()
  handleSearchGoodsByTenant()
}
// 处理删除电子卡券扩展信息关联商品
const handleRemoveVoucherItem = () => {
  ruleForm.voucherInfo.relatedGoods = {
    goodsId: null,
    goodsProperties: [],
    relatedGoodsName: null
  }
}
// 处理通过租户搜索商品列表
const handleSearchGoodsByTenant = async () => {
  try {
    goodsLoading.value = true
    let param = {
      page: groupGoodsPage.value,
      pageSize: groupGoodsPageSize.value
    }
    let temp = []
    // ruleForm.stores.map(i => {
    //   temp.push(i.storeId)
    // })
    let data = {
      keyword: cacheKeyword.value,
      // storeIds: temp
    }
    goodsList.value = []
    const res = await listGoodsIgnoreTenant(param, data)
    res.list.forEach((item) => {
      const param = {
        name: item.goodsName,
        value: item.goodsId,
        pre: item.tenantName
      }
      goodsList.value.push(param)
    })
    totalGroupGoods.value = parseInt(res.total)
    goodsLoading.value = false
  } catch (e) {
    console.log(e)
    goodsLoading.value = false
  }
}
// 处理商品面板选择商品
const handlePanelSelectItem = async (goodsId) => {
  if (goodsId.length > 0) {
    try {
      goodsLoading.value = true
      cachePanelItem.value = await itemDetail(goodsId[0])
      console.log("cachePanelItem.value", cachePanelItem.value)
      goodsLoading.value = false
    } catch (e) {
      console.log(e)
      goodsLoading.value = false
    }
  }
}
// 商家列表
const tenantListArr = ref([])
// 商家总数条
const memberTotal = ref(0)
// 商家翻页锚点
const YTTablePaginationMemberRef = ref()
// 处理商家翻页
const handleChangeMemberPage = () => {
  handleGetTenant()
}
// 商家下拉搜索值
const tenantSelectKey = ref()
// 处理搜索条件列表：商家
const handleGetTenant = async (type) => {
  await nextTick(async () => {
    try {
      if (type === 'search') {
        YTTablePaginationMemberRef.value.resetPage()
      }
      let param = {
        page: type === 'init' ? 1 : YTTablePaginationMemberRef.value.getPage(),
        pageSize: type === 'init' ? 5 : YTTablePaginationMemberRef.value.getPageSize()
      }
      tenantLoading.value = true
      const res = await listTenant(param, {keyword: tenantSelectKey.value})
      tenantListArr.value = res.list
      memberTotal.value = parseInt(res.total)
      tenantLoading.value = false
    } catch (e) {
      console.log(e)
      tenantLoading.value = false
    }
  })
}
// 缓存选择的商家
const cacheTenant = ref({
  name: null,
  tenantId: null
})
// 处理选择器选择商家
const handleSelectTenant = (e) => {
  cacheTenant.value.tenantId = e
  cacheTenant.value = tenantListArr.value.find(i => i.tenantId === e)
  handlePanelSearchGoods()
}
// 处理点击商家下拉列表
const handleClickSelect = (e) => {
  // 下拉展示菜单时重新请求商家列表
  if (e) {
    handleGetTenant('search')
  }
}
/*关联驿站相关*/
// 关联驿站弹窗面板锚点
const YTCheckPanelStoreIdsRef = ref()
// 关联驿站弹窗面板打开状态
const openStoreIdsList = ref(false)
// 关联驿站弹窗面板驿站数据
const storeIdsList = ref([])
// 关联驿站弹窗面板加载状态
const storeIdsLoading = ref(false)
// 关联驿站弹窗面板表单
const dialogForm = reactive({
  storeIds: [],
  cacheStore: null
})
// 关联驿站弹窗面板校验规则
const dialogRules = {

}
// 处理电子卡券、优惠券关联驿站
const handleAddStores = () => {
  openStoreIdsList.value = true
  let temp = []
  ruleForm.stores.map(i => {
    temp.push({
      storeId: i.storeId,
      name: i.storeName
    })
  })
  dialogForm.storeIds = temp
  handleGetStoreList('', 'search')
}
// 处理关联驿站弹窗面板关闭
const handlePanelStoreIdsListClose = () => {
  openStoreIdsList.value = false
  dialogForm.storeIds = []
  dialogForm.cacheStore = null
}
// 处理关联驿站弹窗面板确认
const handlePanelStoreIdsListConfirm = () => {
  let temp = []
  dialogForm.storeIds.map(i => {
    temp.push({
      storeId: i.storeId,
      storeName: i.name
    })
  })
  ruleForm.stores = temp
  console.log("ruleForm.stores", ruleForm.stores)
  ruleFormRef.value.validateField("stores")
  handlePanelStoreIdsListClose()
}
// 处理关联驿站弹窗面板选择
const handlePanelSelectStoreIds = (e) => {
  console.log("e", e)
}
// 关联驿站弹窗面板驿站翻页锚点
const YTTablePaginationDialogStoreRef = ref()
// 关联驿站弹窗面板驿站总条数
const dialogStoreTotal = ref(0)
// 关联驿站弹窗面板驿站下拉加载状态
const storeIdsStoreLoading = ref(false)
// 处理获取关联驿站列表
const handleGetStoreList = async (keyword, type) => {
  try {
    if (type === 'search') {
      YTTablePaginationDialogStoreRef.value.resetPage()
    }
    console.log("keyword", keyword)
    let param = {
      page: YTTablePaginationDialogStoreRef.value.getPage(),
      pageSize: YTTablePaginationDialogStoreRef.value.getPageSize()
    }
    storeIdsStoreLoading.value = true
    const res = await storeAllList(param, {name: keyword})
    storeIdsList.value = []
    storeIdsList.value = res.list
    dialogStoreTotal.value = parseInt(res.total)
    storeIdsStoreLoading.value = false
  } catch (e) {
    console.log(e)
    storeIdsStoreLoading.value = false
  }
}
// 处理关联驿站弹窗面板驿站翻页
const handleChangeDialogStorePage = () => {
  handleGetStoreList()
}
// 处理搜索出的驿站添加到列表
const handleAddStore2List = () => {
  const res = storeIdsList.value.find(i => i.storeId === dialogForm.cacheStore)
  if (dialogForm.storeIds.some(i => i.storeId === res.storeId)) {
    return ElMessage.error("该驿站已存在，请勿重复添加")
  }
  dialogForm.storeIds.push(res)
  dialogForm.cacheStore = null
}
// 使用哈希函数对id编码
const simpleHash = (input) => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash += input.charCodeAt(i);  // 获取字符的 UTF-16 编码值并累加
  }
  return hash;
};
// 关闭扩展信息 - 关联驿站 - 驿站tabs
const handleCloseStoreTags = (index) => {
  ruleForm.stores.splice(index, 1)
}

// 报名开始时间变化时重置结束时间
const handleApplyStartTimeChange = (val, applyEndTime) => {
  if (applyEndTime && new Date(applyEndTime) < new Date(val)) {
    ruleForm.applyEndTime = null; // 如果结束时间早于新开始时间，清空
  }
  console.log("ruleForm.applyEndTime", ruleForm.applyEndTime)
};
// 比赛/活动开始时间变化时重置结束时间
const handleStartTimeChange = (val, endTime) => {
  if (endTime && new Date(endTime) < new Date(val)) {
    ruleForm.endTime = null; // 如果结束时间早于新开始时间，清空
  }
  console.log("ruleForm.endTime", ruleForm.endTime)
};
// 商品上架开始变化时重置结束时间
const handleListingTimeChange = (val, endTime) => {
  if (endTime && new Date(endTime) < new Date(val)) {
    ruleForm.delistingTime = null; // 如果结束时间早于新开始时间，清空
  }
};

// 处理专属相册勾选改变
const handleExclusiveAlbumChange = (e) => {
  ruleForm.hasAlbum = e
}

// 缓存服务项目信息
const cacheService = reactive({
  serviceItemId: null,
  name: null
})
// 服务项目列表加载状态
const serviceLoading = ref(false)
// 服务项目
const serviceItemList = ref([])
// 服务项目总数
const totalServiceItem = ref(0)
// 服务项目当前页数
const pageServiceItem = ref(1)
// 服务项目页长
const pageSizeServiceItem = ref(5)
// 处理获取服务项目ruleForm.relationType
const handleGetServiceItemList = async () => {
  try {
    serviceLoading.value = true
    let param = {
      page: pageServiceItem.value,
      pageSize: pageSizeServiceItem.value
    }
    const res = await listServiceItem(param, {name: null})
    serviceItemList.value = res.list
    totalServiceItem.value = Number(res.total)
    serviceLoading.value = false
  } catch (e) {
    console.log("e", e)
    serviceLoading.value = false
  }
}

// 处理选中关联类型
const handleRelationType = (type) => {
  if(type == ruleForm.relationType) {
    ruleForm.relationType = ''
  } else {
    ruleForm.relationType = type
  }
}

// 处理选择服务项目
const handleSelectServiceItem = (item) => {
  try {
    const target = serviceItemList.value.find(i => i.serviceItemId === item)

    ruleForm.serviceItemId = target.serviceItemId
  } catch (e) {
    console.log(e)
  }
}
// 处理服务项目更改
const handleChangeServiceItem = (e) => {
  handleGetServiceItemList()
}

/*活动标签组件相关*/
// 标签选择器组件锚点
const YTTagSelectRef = ref()
// 活动标签改变
const handleActivityTagChange = (list) => {
  console.log("handleActivityTagChange", list)
  ruleForm.tagList = list.flatMap(i => i.tagList.length > 0 ? i.tagList.filter(tag => tag.checked).map(item => ({ tagId: item.tagId, tagName: item.tagName })) : [])
  ruleFormRef.value.validateField("tagList");
}
// 处理点击活动标签输入框删除按钮
const handleTagListRemoveTag = (tagId) => {
  const resIndex = ruleForm.tagList.findIndex(i => i.tagId === tagId)
  ruleForm.tagList.splice(resIndex, 1)
  YTTagSelectRef.value.handleYTCheckTagMultipleRemove(tagId)
}
// 活动标签列表（现在“活动”标签上限10个）
const tagList = ref([])
// 获取活动标签列表
const handleGetActivityTagsList = async (type = 'init') =>  {
  try {
    loading.value = true
    let scenario = "GOODS_THERAPY_SERVICE"
    if (ruleForm.innerCategoryType === 'THERAPY_SERVICE') {
      scenario = "GOODS_THERAPY_SERVICE"
    } else if (ruleForm.innerCategoryType === 'PHOTOGRAPHY') {
      scenario = "GOODS_PHOTOGRAPHY"
    } else if (ruleForm.innerCategoryType === 'BIKE_MAINTENANCE') {
      scenario = "GOODS_BIKE_MAINTENANCE"
    } else if (ruleForm.innerCategoryType === 'VENUE_COURSE') {
      scenario = "GOODS_VENUE_COURSE"
    } else if (ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE') {
      scenario = "GOODS_APPOINTMENT_SERVICE"
    }
    const res = await tagGroupsListByUsageScenario({usageScenario: scenario})
    if (type === 'init') {
      tagList.value = res
    } else {
      res.map(item => {
        tagList.value.push(item)
      })
    }
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}

/*销售渠道相关*/
// 渠道枚举
const channelEnum = ref([])
// 处理获取渠道
const handleGetChannel = async () => {
  try {
    channelEnum.value = await listSaleChannelAll()
  } catch (e) {
    console.log(e)
  }
}
// 选中的渠道
const channelTypeForm = reactive({
  cacheChannelChecked: []
})
// 渠道信息缓存
const cacheSalesChannelList = reactive({
  storeList: [],
  onlineStoreList: [],
  clubList: [],
  venueList: [],
  bikeStoreList: [],
  therapistStoreList: [],
  photographyStoreList: [],
  brandStoreList: []
})
// 处理打开渠道添加俱乐部/门店/网店/场地/车店/理疗服务商/摄影服务商面板
const handleAddSalesChannel = (type) => {
  if (!ruleForm.tenantId) return ElMessage.error("请先选择所属商家")
  openSalesChannel.value = true
  let temp = []
  console.log("type", type)
  openSalesChannelType.value = type
  if (openSalesChannelType.value === 'CLUB') {
    cacheSalesChannelList.clubList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'STORE') {
    cacheSalesChannelList.storeList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'ONLINE_STORE') {
    cacheSalesChannelList.onlineStoreList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'VENUE') {
    cacheSalesChannelList.venueList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'BIKE_STORE') {
    cacheSalesChannelList.bikeStoreList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'THERAPIST_STORE') {
    cacheSalesChannelList.therapistStoreList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'PHOTOGRAPHY_STORE') {
    cacheSalesChannelList.photographyStoreList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  } else if (openSalesChannelType.value === 'BRAND') {
    cacheSalesChannelList.brandStoreList.map(i => {
      temp.push({
        storeId: i.storeId,
        name: i.storeName
      })
    })
  }
  channelDialogForm.cacheSalesChannelList = temp
  handleGetSalesChannel('', 'search')
}
// 处理删除俱乐部销售渠道tags
const handleCloseSalesChannelClubTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.clubList.splice(index, 1)
}
// 处理删除门店销售渠道tags
const handleCloseSalesChannelStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.storeList.splice(index, 1)
}
// 处理删除网店销售渠道tags
const handleCloseSalesChannelOnlineStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.onlineStoreList.splice(index, 1)
}
// 处理删除场地销售渠道tags
const handleCloseSalesChannelVenueTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.venueList.splice(index, 1)
}
// 处理删除车店销售渠道tags
const handleCloseSalesChannelBikeStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.bikeStoreList.splice(index, 1)
}
// 处理删除理疗服务商销售渠道tags
const handleCloseSalesChannelTherapistStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.therapistStoreList.splice(index, 1)
}
// 处理删除摄影服务商销售渠道Tags
const handleCloseSalesChannelPhotographyStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.photographyStoreList.splice(index, 1)
}
// 处理删除品牌方销售渠道Tags
const handleCloseSalesChannelBrandStoreTags = (index) => {
  console.log("index", index)
  cacheSalesChannelList.brandStoreList.splice(index, 1)
}

/*添加渠道相关弹窗*/
// 渠道弹窗锚点
const YTCheckPanelSalesChannelRef = ref()
// 渠道弹窗翻页锚点
const YTTablePaginationDialogSalesChannelRef = ref()
// 渠道弹窗加载状态
const salesChannelLoading = ref(false)
// 渠道弹窗打开状态
const openSalesChannel = ref(false)
// 渠道弹窗选择销售渠道类型
const openSalesChannelType = ref("ClUB")
// 渠道弹窗的渠道列表
const salesChannelList = ref([])
// 渠道弹窗的渠道列表总条数
const dialogSalesChannelTotal = ref(0)
// 渠道弹窗表单
const channelDialogForm = reactive({
  salesChannels: [],
  cacheSalesChannel: null,
  cacheSalesChannelList: []
})
// 渠道弹窗表单校验规则
const channelDialogRules = {

}
// 处理渠道弹窗关闭
const handleSalesChannelClose = () => {
  openSalesChannel.value = false
  salesChannelList.value = []
  dialogSalesChannelTotal.value = 0
  channelDialogForm.salesChannels = []
  channelDialogForm.cacheSalesChannel = null
  channelDialogForm.cacheSalesChannelList = []
}
// 处理选择销售渠道的门店/网店/俱乐部
const handleSalesChannel = (e) => {
  console.log("e", e)
}
// 处理获取销售渠道列表
const handleGetSalesChannel = async (keyword, type) => {
  try {
    if (type === 'search') {
      YTTablePaginationDialogSalesChannelRef.value.resetPage()
    }
    console.log("keyword", keyword)
    let param = {
      page: YTTablePaginationDialogSalesChannelRef.value.getPage(),
      pageSize: YTTablePaginationDialogSalesChannelRef.value.getPageSize()
    }
    let res = null
    if (openSalesChannelType.value === 'CLUB') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "CLUB", tenantId: ruleForm.tenantId})
    } else if (openSalesChannelType.value === 'STORE') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "STORE", tenantId: ruleForm.tenantId})
    } else if (openSalesChannelType.value === 'ONLINE_STORE') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "ONLINE_STORE", tenantId: ruleForm.tenantId});
    } else if (openSalesChannelType.value === 'VENUE') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "VENUE", tenantId: ruleForm.tenantId});
    } else if (openSalesChannelType.value === 'BIKE_STORE') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "BIKE_STORE", tenantId: ruleForm.tenantId});
    } else if (openSalesChannelType.value === 'THERAPIST_STORE') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "THERAPIST_STORE", tenantId: ruleForm.tenantId});
    } else if (openSalesChannelType.value === 'PHOTOGRAPHY_STORE') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "PHOTOGRAPHY_STORE", tenantId: ruleForm.tenantId});
    }else if (openSalesChannelType.value === 'BRAND') {
      res = await listTenantOrganizeIgnore(param, {keyword: keyword, type: "BRAND", tenantId: ruleForm.tenantId});
    }
    salesChannelList.value = []
    salesChannelList.value = res.list
    dialogSalesChannelTotal.value = parseInt(res.total)
  } catch (e) {
    console.log(e)
  }
}
// 处理渠道弹窗的俱乐部/门店/网店/场地/车店/理疗服务商/摄影服务商/品牌方展示
const handleSalesChannelShow = (type) => {
  let temp = new Set()
  for (let i = 0;i < ruleForm.salesChannel.length;i++) {
    const res = channelEnum.value.find(item => item.key === type)
    if (res?.key === ruleForm.salesChannel[i]) temp.add(res.key)
  }
  return temp.has(type)
}
// 处理渠道弹窗驿站翻页
const handleChangeDialogSalesChannelPage = () => {
  handleGetSalesChannel()
}
// 渠道弹窗删除渠道tags
const handleCloseDialogStoreTags = (index) => {
  channelDialogForm.cacheSalesChannelList.splice(index, 1)
}
// 处理驿站弹窗确认
const handlePanelSalesChannelConfirm = () => {
  let temp = []
  console.log("channelDialogForm.cacheSalesChannelList", channelDialogForm.cacheSalesChannelList)
  channelDialogForm.cacheSalesChannelList.map(i => {
    temp.push({
      storeId: i.storeId,
      storeName: i.name
    })
  })
  if (openSalesChannelType.value === 'CLUB') {
    cacheSalesChannelList.clubList = (temp)
  } else if (openSalesChannelType.value === 'STORE') {
    cacheSalesChannelList.storeList = (temp)
  } else if (openSalesChannelType.value === 'ONLINE_STORE') {
    cacheSalesChannelList.onlineStoreList = (temp)
  } else if (openSalesChannelType.value === 'VENUE') {
    cacheSalesChannelList.venueList = (temp)
  } else if (openSalesChannelType.value === 'BIKE_STORE') {
    cacheSalesChannelList.bikeStoreList = (temp)
  } else if (openSalesChannelType.value === 'THERAPIST_STORE') {
    cacheSalesChannelList.therapistStoreList = (temp)
  } else if (openSalesChannelType.value === 'PHOTOGRAPHY_STORE') {
    cacheSalesChannelList.photographyStoreList = (temp)
  } else if (openSalesChannelType.value === 'BRAND') {
    cacheSalesChannelList.brandStoreList = (temp)
  }
  handleSalesChannelClose()
}
// 处理渠道添加俱乐部/门店/网店/场地/车店/理疗服务商/摄影服务商
const handleAddSalesChannel2List = () => {
  const res = salesChannelList.value.find(i => i.storeId === channelDialogForm.cacheSalesChannel)
  if (channelDialogForm.cacheSalesChannelList.some(i => i.storeId === res.storeId)) {
    return ElMessage.error("已存在，请勿重复添加")
  }
  let openSalesChannelTypeLabel = ""
  if (openSalesChannelType.value === "CLUB") {
    openSalesChannelTypeLabel = "俱乐部"
  } else if (openSalesChannelType.value === "STORE") {
    openSalesChannelTypeLabel = "门店"
  } else if (openSalesChannelType.value === "ONLINE_STORE") {
    openSalesChannelTypeLabel = "网店"
  } else if (openSalesChannelType.value === "VENUE") {
    openSalesChannelTypeLabel = "场地"
  } else if (openSalesChannelType.value === "BIKE_STORE") {
    openSalesChannelTypeLabel = "车店"
  } else if (openSalesChannelType.value === "THERAPIST_STORE") {
    openSalesChannelTypeLabel = "理疗服务商"
  } else if (openSalesChannelType.value === "PHOTOGRAPHY_STORE") {
    openSalesChannelTypeLabel = "摄影服务商"
  }
  if (!res) return ElMessage.error(`请选择${openSalesChannelTypeLabel}`)
  channelDialogForm.cacheSalesChannelList.push(res)
  channelDialogForm.cacheSalesChannel = null
}
// 处理销售渠道改变
const handleSalesChannelChange = (e) => {
  console.log("销售渠道改变：======", e)
}

/*商家列表相关*/
// 商家列表
const tenantList = ref([])
// 商家列表加载状态
const tenantLoading = ref(false)
// 商家总数
const totalTenant = ref(0)
// 商家列表当前页数
const pageTenant = ref(1)
// 商家列表页长
const pageSizeTenant = ref(5)
// 处理选择商家改变
const handleTenantChange = (e) => {
  const tenant = tenantList.value.find(item => item.tenantId === e)
  ruleForm.tenantId = tenant.tenantId
  ruleForm.tenantName = tenant.name
  ruleForm.bikeStoreId = null
  ruleForm.certificationType = tenant.certificationType
  cacheSalesChannelList.storeList = []
  cacheSalesChannelList.onlineStoreList = []
  cacheSalesChannelList.clubList = []
  cacheSalesChannelList.venueList = []
  cacheSalesChannelList.bikeStoreList = []
  cacheSalesChannelList.therapistStoreList = []
  cacheSalesChannelList.photographyStoreList = []
  cacheSalesChannelList.brandStoreList = []
}
// 处理“入场预约”关联商家
const handleEntryAppointmentTenantChange = e => {

}
// 处理商家翻页
const handleChangeTenantPage = (e) => {
  pageTenant.value = e
  handleGetTenantList()
}
// 搜索关键字缓存
const keywordTenant = ref()
// 搜索触发函数
const handleRemoteSearch = (keyword) => {
  keywordTenant.value = keyword
  pageTenant.value = 1
  handleGetTenantList()
}
// 获取商家列表
const handleGetTenantList = async () => {
  tenantLoading.value = true
  const page = {
    page: pageTenant.value,
    pageSize: pageSizeTenant.value,
  }
  let param = {
    keyword: keywordTenant.value || null
  }
  const res = await listTenant(page, param)
  tenantList.value = res.list
  totalTenant.value = parseInt(res.total)
  console.log(res)
  tenantLoading.value = false
}

/*商品服务时长相关*/
const servicesDurationEnum = [
  {
    label: "1",
    value: 1
  },
  {
    label: "4",
    value: 4
  },
]

/*商品类目相关*/
// 商品类目配置项
const categoryProps = {
  value: "bizCategoryId",
  label: "bizCategoryName",
  children: "children"
}
// 处理获取商品类目树
const handleGetItemCategory = async () => {
  try {
    loading.value = true
    bizTypeEnum.value = await listBizCategoryTree();
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理商品类目选择改变
const handleBizCategoryChange = (e) => {
  console.log(e)
  ruleForm.bizCategoryId = e
}

/*配置商城商品信息-商品类型标签相关*/
// 商品类型标签
const itemTypeSkillTags = ref([])
// 处理商品类型标签改变
const handleItemTypeSkillTagsChange = (tag) => {
  console.log("tag", tag)
  tag.checked = !tag.checked
  let temp = []
  itemTypeSkillTags.value.map(i => {
    if (i.checked) temp.push(i.tagId)
  })
  ruleForm.mallGoodsCategoryTagList = temp
}
// 处理商品类型标签反显
const handleReviewItemTypeTagList = () => {
  itemTypeSkillTags.value.map(i => {
    console.log("i.tagId", i.tagId)
    console.log("ruleForm.mallGoodsCategoryTagList", ruleForm.mallGoodsCategoryTagList)
    console.log("ruleForm.mallGoodsCategoryTagList.includes(i.tagId)", ruleForm.mallGoodsCategoryTagList.includes(i.tagId))
    i.checked = ruleForm.mallGoodsCategoryTagList.some(
        item => item.tagId === i.tagId
    )
  })
}

/*配置商城商品信息-商品服务信息标签相关*/
// 商品服务信息标签
const itemServiceSkillTags = ref([])
// 处理商品服务信息标签改变
const handleItemServiceSkillTagsChange = (tag) => {
  console.log("tag", tag)
  tag.checked = !tag.checked
  let temp = []
  itemServiceSkillTags.value.map(i => {
    if (i.checked) temp.push(i.tagId)
  })
  ruleForm.mallServiceInfoTagList = temp
  ruleFormRef.value.validateField("mallServiceInfoTagList");
}
// 处理商品服务信息标签反显
const handleReviewItemServiceTagList = () => {
  itemServiceSkillTags.value.map(i => {
    // if (ruleForm.mallServiceInfoTagList.includes(i.tagId)) i.checked = true
    i.checked = ruleForm.mallServiceInfoTagList.some(
        item => item.tagId === i.tagId
    )
  })
}

/*配置商城商品信息-退货须知标签相关*/
// 退货须知信息标签
const itemReturnSkillTags = ref([])
// 处理退货须知信息标签改变
const handleItemReturnSkillTagsChange = (tag) => {
  console.log("tag", tag)
  tag.checked = !tag.checked
  let temp = []
  itemReturnSkillTags.value.map(i => {
    if (i.checked) temp.push(i.tagId)
  })
  ruleForm.mallReturnPolicyTagList = temp
  ruleFormRef.value.validateField("mallReturnPolicyTagList");
}
// 处理退货须知信息标签反显
const handleReviewItemReturnTagList = () => {
  itemReturnSkillTags.value.map(i => {
    // if (ruleForm.mallReturnPolicyTagList.includes(i.tagId)) i.checked = true
    i.checked = ruleForm.mallReturnPolicyTagList.some(
        item => item.tagId === i.tagId
    )
  })
}

/*新建商品属性相关*/
// 新建商品属性加载状态
const drawerLoading = ref(false)
// 新建商品属性弹窗打开状态
const drawer = ref(false)
// 处理新建商品属性弹窗关闭
const handleCloseDrawer = () => {
  drawer.value = false
}
// 新建商品属性表头
const drawerHeaders = ref([
  { title: '序号', key: 'sort', width: '100px', sortable: false },
  { title: '属性值', key: 'propertyName', sortable: false },
  { title: 'English', key: 'propertyNameEn', sortable: false },
  { title: '加价（元）', key: 'addPrice', width: '200px', sortable: false },
  { title: '商品属性图片', key: 'image', width: '200px', sortable: false },
  { title: '排序', key: 'orderBy', width: '100px', sortable: false },
  { title: '操作', key: 'controls', width: '100px', sortable: false },
])
// 新建商品属性储存值
const drawerTableData = ref([])
// 处理新增商品属性弹窗关闭
const handleDrawerClose = () => {
  drawer.value = false
  drawerTableData.value = []
  drawerRuleForm.propertyGroupId = null
  drawerRuleForm.groupName = null
  drawerRuleForm.groupNameEn = null
  drawerRuleForm.propertyGroupItemList = []
  drawerRuleForm.goodsCount = 0
  drawerRuleForm.isCommonProperty = false
  drawerRuleForm.useGroupImage = false
  drawerRuleForm.state = "ON_SHELF"
}
// 处理新增商品属性值提交
const handleDrawerSubmit = async () => {
  drawerRuleFormRef.value.validate(async (valid) => {
    if (valid) {
      drawerRuleForm.propertyGroupItemList = drawerTableData.value
      console.log("drawerRuleForm", drawerRuleForm)
      let temp = {}
      Object.assign(temp, drawerRuleForm)
      await ruleForm.propertyGroupList.push(temp)
      console.log("ruleForm.propertyGroupList", ruleForm.propertyGroupList)
      handleDrawerClose()
    } else {
      ElMessage.error("请根据提示修改表单信息")
      loading.value = false
    }
  })
}
// 新建商品属性表单锚点
const drawerRuleFormRef = ref()
// 新建商品属性表单
const drawerRuleForm = reactive({
  propertyGroupId: null,
  groupName: null,
  groupNameEn: null,
  propertyGroupItemList: [],
  goodsCount: 0,
  isCommonProperty: false,
  useGroupImage: false
})
// 校验商品属性项名称
const checkGroupName = (rule, value, callback) => {
  if (!drawerRuleForm.groupName) {
    return callback(new Error("属性项名称（中文）不能为空！"))
  }
  if (!drawerRuleForm.groupNameEn) {
    return callback(new Error("属性项名称（English）不能为空！"))
  }
  return callback()
}
// 新建商品属性校验规则
const drawerRules = {
  groupName: [
    {required: true, validator: checkGroupName, trigger: 'blur'},
  ]
}
// 编辑/编辑属性值打开状态
const drawerOpen = ref(false)
// 新建商品属性值弹窗表单锚点
const drawerDialogRuleFormRef = ref()
// 新建商品属性值弹窗表单
const drawerDialogRuleForm = reactive({
  propertyName: null,
  propertyNameEn: "Coming Soon ...",
  addPrice: 0,
  image: null,
  state: "ON_SHELF"
})
// 商品属值名称校验规则
const checkPropertyName = (rule, value, callback) => {
  if (!drawerDialogRuleForm.propertyName) {
    return callback(new Error("属性值名称（中文）不能为空！"))
  }
  if (!drawerDialogRuleForm.propertyNameEn) {
    return callback(new Error("属性值名称（English）不能为空！"))
  }
  return callback()
}
// 新建商品属性值校验规则
const drawerDialogRules = {
  propertyName: [
    {required: true, validator: checkPropertyName, trigger: 'blur'},
  ],
}
// 处理新增属性值
const handleDrawerDialogAddProp = () => {
  drawerOpen.value = true
  isShowUpload.value = true
}
// 新建商品属性名称tab
const propertyNameTab = ref('zh')
// 新建商品属性图片是否展示上传组件，用于清空上传完成的缓存
const isShowUpload = ref(false)
// 新建商品属性弹窗加载状态
const drawerDialogLoading = ref(false)
// 商品图片上传组件锚点
const drawerDialogBoxUploadRef = ref()
// 处理图片反显
const handleReviewDrawerDialog = (reviewList) => {
  drawerDialogBoxUploadRef.value.handleReview(reviewList)
}
// 处理图片上传成功
const handleDrawerDialogSuccess = (url) => {
  drawerDialogRuleForm.image = null
  drawerDialogRuleForm.image = url[0]
  drawerDialogRuleForm.value = false
}
// 处理图片列表改变
const handleDrawerDialogRemove = (url) => {
  drawerDialogRuleForm.image = url[0]
}
// 处理新增属性值列表
const handleAddPropList = async (item) => {
  drawerTableData.value.push(item)
}
// 当前增加商品属性值的属性项索引值
const currentAddPropertyGroupIndex = ref(null)
// 是否为增加/编辑属性值
const isEditPropertyGroupItem = ref(false)
// 提交新增属性值 1：确定 2：确定并继续新增
const submitDialog = (index) => {
  drawerDialogRuleFormRef.value.validate(async value => {
    if (value) {
      try {
        console.log("drawerDialogRuleForm", drawerDialogRuleForm)
        const pushParam = {
          propertyGroupItemId: null,
          ...drawerDialogRuleForm,
          sort: isEditPropertyGroupItem.value ? ruleForm.propertyGroupList[currentAddPropertyGroupIndex.value].propertyGroupItemList.length + 1 : drawerTableData.value.length + 1
        }
        console.log("isEditPropertyGroupItem.value", isEditPropertyGroupItem.value)
        if (isEditPropertyGroupItem.value) {
          ruleForm.propertyGroupList[currentAddPropertyGroupIndex.value].propertyGroupItemList.push(pushParam)
        } else {
          await handleAddPropList(pushParam)
        }
        if (index === 2) {
          console.log("drawerDialogRuleForm.image", drawerDialogRuleForm.image)
          await clearDialog()
          isShowUpload.value = true
          ElMessage({
            type: "success",
            message: "新增成功",
            appendTo: document.getElementsByClassName("v-overlay")[0],
          })
        } else {
          closeDialog()
        }
      } catch (e) {
        console.log(e)
      }
    } else {
      ElMessage({
        type: "error",
        message: "请根据提示修改表单信息",
        appendTo: document.getElementsByClassName("v-overlay")[0],
      })
    }
  })
}
// 关闭对话框
const closeDialog = () => {
  // 关闭对话框
  drawerOpen.value = false
  clearDialog()
  // 清空增加属性值缓存的值
  isEditPropertyGroupItem.value = false
  currentAddPropertyGroupIndex.value = null
  propertyNameTab.value = 'zh'
  // 清空表单校验
  drawerDialogRuleFormRef.value.clearValidate()
}
// 清空表单信息
const clearDialog = async () => {
  drawerDialogRuleForm.propertyName = null
  drawerDialogRuleForm.propertyNameEn = "Coming Soon ..."
  drawerDialogRuleForm.addPrice = 0
  drawerDialogRuleForm.propertyGroupId = null
  drawerDialogRuleForm.propertyGroupItemId = null
  drawerDialogRuleForm.sort = null
  drawerDialogRuleForm.image = null
  drawerDialogRuleForm.state = 'ON_SHELF'
  if (drawerRuleForm.isCommonProperty) {
    drawerRuleForm.propertyGroupId = null
    drawerRuleForm.groupName = null
    drawerRuleForm.groupNameEn = null
    drawerRuleForm.propertyGroupItemList = []
    drawerRuleForm.goodsCount = 0
    drawerRuleForm.isCommonProperty = false
    drawerRuleForm.useGroupImage = false
  }
  // 清空上传列表展示的文件
  isShowUpload.value = false
}
// 属性值上移
const handlePropUp = (index) => {
  // 判断传入的index是否在有效范围内
  if (index === 0) {
    ElMessage.warning("已经是第一啦~")
    return;
  }
  [drawerTableData.value[index].sort, drawerTableData.value[index - 1].sort] = [drawerTableData.value[index - 1].sort, drawerTableData.value[index].sort];
  [drawerTableData.value[index], drawerTableData.value[index - 1]] = [drawerTableData.value[index - 1], drawerTableData.value[index]];
}
// 属性值下移
const handlePropDown = (index) => {
  // 判断传入的index是否在有效范围内
  if (index === drawerTableData.value.length - 1) {
    ElMessage.warning("已经是最后啦~")
    return;
  }
  [drawerTableData.value[index].sort, drawerTableData.value[index + 1].sort] = [drawerTableData.value[index + 1].sort, drawerTableData.value[index].sort];
  [drawerTableData.value[index], drawerTableData.value[index + 1]] = [drawerTableData.value[index + 1], drawerTableData.value[index]];
}
// 移除属性值
const handleRemove = (index) => {
  drawerTableData.value.splice(index, 1)
}
// 处理移除“商城商品”商品属性
const handleDeletePropertyGroupList = (index) => {
  ruleForm.propertyGroupList.splice(index, 1)
}
// 处理属性值上下架状态
const handlePropertyStateChange = (type, fatherIndex, sonIndex) => {
  console.log("sonIndex", sonIndex)
  console.log("ruleForm.propertyGroupList[fatherIndex].propertyGroupItemList[sonIndex]", ruleForm.propertyGroupList[fatherIndex].propertyGroupItemList[sonIndex])
  if (type === 'OFF_SHELF') {
    // 下架
    ruleForm.propertyGroupList[fatherIndex].propertyGroupItemList[sonIndex].state = 'OFF_SHELF'
  } else if (type === 'ON_SHELF') {
    // 上架
    ruleForm.propertyGroupList[fatherIndex].propertyGroupItemList[sonIndex].state = 'ON_SHELF'
  }
}
// 处理新增属性值
const handleAddNewProperty = (item, index) => {
  drawerRuleForm.propertyGroupId = item.propertyGroupId
  drawerRuleForm.groupName = item.groupName
  drawerRuleForm.groupNameEn = item.groupNameEn
  drawerRuleForm.propertyGroupItemList = item.propertyGroupItemList
  drawerRuleForm.goodsCount = item.goodsCount
  drawerRuleForm.isCommonProperty = item.isCommonProperty
  drawerRuleForm.useGroupImage = item.useGroupImage
  drawerOpen.value = true
  isShowUpload.value = true
  isEditPropertyGroupItem.value = true
  currentAddPropertyGroupIndex.value = index
}
// 处理删除属性项属性值
const handleDeletePropertyGroupItemList = (fatherIndex, sonIndex) => {
  ruleForm.propertyGroupList[fatherIndex].propertyGroupItemList.splice(sonIndex, 1)
}

/*商品通用属性相关*/
// 选择商品属性面板锚点
const YTPropertyGroupItemCheckPanelRef = ref()
// 选择商品属性面板打开状态
const openPropertyGroupList = ref(false)
// 选择商品属性面板数据
const propertyGroupItemList = ref([])
// 处理选择商品属性面板关闭
const handlePanelPropertyGroupItemListClose = () => {
  openPropertyGroupList.value = false
  // 清空缓存数据
  propertyGroupItemPage.value = 1
  cacheKeyword.value = null
  propertyGroupItemList.value = []
  propertyGroupItemLoading.value = false
}
// 处理选择商品属性面板确认
const handlePanelPropertyGroupItemListConfirm = async (item) => {
  console.log("handlePanelPropertyGroupItemListConfirm item", item[0])
  await getPropertyGroupItemDetail(item[0])
  // 打开款式面板，重新设置drawerRuleForm.propertyGroupItemList
  console.log("drawerRuleForm.propertyGroupItemList", drawerRuleForm.propertyGroupItemList)
  cacheProp.value = drawerRuleForm
  openPropertyGroupItemList.value = true
}
// 处理选择商品属性面板勾选
const handlePanelPropertyGroupItemSelectItem = (goodsId) => {
  // if (goodsId.length > 0) {
  //   try {
  //     goodsLoading.value = true
  //     cachePanelItem.value = await itemDetail(goodsId[0])
  //     console.log("cachePanelItem.value", cachePanelItem.value)
  //     goodsLoading.value = false
  //   } catch (e) {
  //     console.log(e)
  //     goodsLoading.value = false
  //   }
  // }
}
// 选择商品属性面加载状态
const propertyGroupItemLoading = ref(false)
// 商品属性列表页数、页长
const propertyGroupItemPage = ref(1)
const propertyGroupItemPageSize = ref(5)
// 商品属性总数
const totalPropertyGroupItem = ref(0)
// 处理点击“选择通用属性”
const handleClickCommonProps = () => {
  openPropertyGroupList.value = true
  handleSearchPropertyGroup()
}
// 商品属性项翻页
const handleChangePropertyGroupItemPage = async () => {
  YTPropertyGroupItemCheckPanelRef.value.handleClearCacheSelect()
  await handleSearchPropertyGroup()
}
// 处理获取通用属性列表
const handleSearchPropertyGroup = async () => {
  try {
    const page = {
      page: propertyGroupItemPage.value,
      pageSize: propertyGroupItemPageSize.value
    }
    let param = {
      propertyGroupName: cacheKeyword.value
    }
    propertyGroupItemLoading.value = true;
    const res = await listPropertyGroup(page, param);
    propertyGroupItemList.value = []
    propertyGroupItemList.value = res.list
    totalPropertyGroupItem.value = parseInt(res.total)
    propertyGroupItemLoading.value = false
  } catch (e) {
    console.log(e)
    propertyGroupItemLoading.value = false
  }
}
// 获取商品属性信息
const getPropertyGroupItemDetail = async (itemId) => {
  propertyGroupItemLoading.value = true
  try {
    const res = await propertyGroupItem(itemId)
    drawerRuleForm.propertyGroupId = res.propertyGroupId
    drawerRuleForm.groupName = res.groupName
    drawerRuleForm.groupNameEn = res.groupNameEn
    drawerRuleForm.propertyGroupItemList = res.propertyGroupItemList
    drawerRuleForm.goodsCount = parseInt(res.goodsCount)
    drawerRuleForm.isCommonProperty = res.isCommonProperty
    drawerRuleForm.useGroupImage = res.useGroupImage
    propertyGroupItemLoading.value = false
  } catch (e) {
    console.log(e)
    propertyGroupItemLoading.value = false
  }
}
// 选择商品勾选后属性值弹窗打开状态
const openPropertyGroupItemList = ref(false)
// 处理商品勾选后属性值弹窗关闭
const handleCancelPropertyGroupItemList = () => {
  drawerRuleForm.propertyGroupId = null
  drawerRuleForm.groupName = null
  drawerRuleForm.groupNameEn = null
  drawerRuleForm.propertyGroupItemList = []
  drawerRuleForm.goodsCount = 0
  drawerRuleForm.isCommonProperty = false
  drawerRuleForm.useGroupImage = false
  cacheProp.value = null
  cacheIndex.value = null
  cacheSelect.value = []
  openPropertyGroupItemList.value = false
  checkAll.value = false
}
// 处理商品勾选后属性值弹窗确定
const handleConfirmPropertyGroupItemList = async () => {
  let temp = []
  // 过滤选项
  cacheSelect.value.forEach(item => {
    let param = cacheProp.value.propertyGroupItemList.find(res => res.propertyGroupItemId === item)
    console.log("param", param)
    console.log("cacheProp.value", cacheProp.value)
    temp.push(param)
    console.log("temp", temp)
  })
  temp.map(i => {
    i.state = "ON_SHELF"
  })
  drawerRuleForm.propertyGroupItemList = temp
  drawerRuleForm.isCommonProperty = true
  let pushTemp = {}
  Object.assign(pushTemp, drawerRuleForm)
  ruleForm.propertyGroupList.push(pushTemp)
  handleCancelPropertyGroupItemList()
}
// 处理获取商城商品“配置商城商品信息”标签
const handleGetMALLTags = async () => {
  try {
    loading.value = true
    // 获取商城-商品类型
    const res1 = await tagGroupsListByUsageScenario({usageScenario: "MALL_GOODS_CATEGORY"})
    console.log("res1", res1)
    if (res1?.length > 0) itemTypeSkillTags.value = res1[0].tagList
    // 获取商城服务信息
    const res2 = await tagGroupsListByUsageScenario({usageScenario: "MALL_SERVICE_INFO"})
    console.log("res2", res2)
    if (res2?.length > 0) itemServiceSkillTags.value = res2[0].tagList
    // 获取商城退货须知
    const res3 = await tagGroupsListByUsageScenario({usageScenario: "MALL_RETURN_POLICY"})
    console.log("res3", res3)
    if (res3?.length > 0) itemReturnSkillTags.value = res3[0].tagList
    loading.value = false
  } catch(e) {
    console.log(e)
    loading.value = false
  }
}
</script>

<template>
  <el-form
      ref="ruleFormRef"
      :model="ruleForm"
      :rules="rules"
      label-width="auto"
      class="demo-ruleForm container_form mg_b_3"
      :validate-on-rule-change="false"
      size="large">
    <YTCard :title="'商品类型'">
      <template #container>
        <v-skeleton-loader
            :loading="loading"
            type="list-item-three-line"
        >
          <v-container>
            <v-row align="start">
              <v-col cols="12">
                <v-row align="start">
                  <v-col cols="2" :key="`bizType${item.title}${index}`" align-self="start" v-for="(item, index) in itemTypeEnum" >
                    <div style="max-width: 160px;position: relative">
                        <v-card
                            class="txt_center cursor-pointer"
                            :elevation="ruleForm.bizType === item.value ? 24 : 2"
                            max-width="160"
                            :disabled="isEdit || item.disable"
                            @click="handleSelectType(item.value)"
                            style="min-height: 87.95px"
                        >
                          <v-card-item>
                            <v-card-title v-text="item.title"></v-card-title>
                          </v-card-item>
                          <v-card-text v-text="item.text"></v-card-text>
                        </v-card>
                        <div class="btn_check" v-if="ruleForm.bizType === item.value" style="">
                          <v-icon color="#fff" size="x-small" icon="mdi-check"></v-icon>
                        </div>
                    </div>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row align="start">
              <v-col>
                <span class="tips_default">不同的商品类型可编辑的字段内容不同，商品类型一旦发布后将不可更改。</span>
              </v-col>
            </v-row>
          </v-container>
        </v-skeleton-loader>
      </template>
    </YTCard>
    <YTCard :title="'所属商家'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="选择商家：" prop="tenantId" >
            <el-select
                v-model="ruleForm.tenantId"
                placeholder="所属商家"
                size="large"
                style="width: 240px;"
                :loading="tenantLoading"
                @change="handleEntryAppointmentTenantChange"
                filterable
                remote
                remote-show-suffix
                :remote-method="handleRemoteSearch"
            >
              <el-option
                  v-for="item in tenantList"
                  :key="`tenantId${item.tenantId}`"
                  :label="item.name"
                  :value="item.tenantId"
              />
              <template v-if="!loading && !tenantList.some(res => res.tenantId === ruleForm.tenantId) && ruleForm.tenantId" #header>
                当前已选：
                <el-option
                    :label="ruleForm.tenantName"
                    :value="ruleForm.tenantId"
                />
              </template>

              <template #footer>
                <div class="flex_center">
                  <el-pagination
                      size="small"
                      background
                      layout="prev, pager, next"
                      :total="totalTenant"
                      class="mt-4"
                      v-model:current-page="pageTenant"
                      v-model:page-size="pageSizeTenant"
                      @current-change="handleChangeTenantPage"
                  />
                </div>
              </template>
            </el-select>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'基本信息'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="商品名称：" prop="goodsName">
            <el-tabs
                v-model="goodsNameTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input style="width: 350px" v-model="ruleForm.goodsName" placeholder="例如：鲜榨果汁500ml" />
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input style="width: 350px" v-model="ruleForm.goodsNameEn" placeholder="For example: 500ml freshly squeezed juice" />
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="商品编码：" prop="barCode">
            <el-input :disabled="ruleForm.innerCategoryType === 'COURSE' && isEdit && isEditCourse" style="width: 350px" v-model="ruleForm.barCode" placeholder="无编码时系统将自动生成" />
            <span class="tips_default mg_l_1">用于商家内部管理所使用的自定义简易编码。示例A1001</span>
          </el-form-item>
          <el-form-item label="商品分类：" prop="innerCategoryType">
            <el-select
                v-model="ruleForm.innerCategoryType"
                placeholder="商品分类"
                size="large"
                style="width: 150px"
                :loading="categoryLoading"
                @change="handleCategoryChange"
                :disabled="ruleForm.innerCategoryType === 'COURSE' && isEdit && isEditCourse"
            >
              <el-option
                  v-for="item in innerCategoryEnum"
                  :key="`innerCategoryType${item.key}`"
                  :label="item.description"
                  :value="item.key"
              />
            </el-select>
            <span class="tips_default mg_l_1">商品分类用于店铺内部经营管理与财务利润核算。</span>
          </el-form-item>
          <el-form-item label="商品类目：" prop="bizCategoryId">
            <el-cascader :disabled="ruleForm.innerCategoryType !== 'MALL'" v-model="ruleForm.bizCategoryId" :props="categoryProps" :options="bizTypeEnum" @change="handleBizCategoryChange" />
            <span class="tips_default mg_l_1">准确选择商品类目有助于完善商品信息与数据分析。</span>
          </el-form-item>
          <el-form-item label="商品单位：">
            <el-tabs
                v-model="goodsUnitTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input style="width: 350px" show-word-limit maxlength="5" v-model="ruleForm.unit" placeholder="请输入商品单位，例如辆、份" />
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input style="width: 350px" show-word-limit maxlength="20" v-model="ruleForm.unitEn" placeholder="Please enter product unit" />
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="税收分类编码：" prop="taxClassificationCode">
            <el-input v-model="ruleForm.taxClassificationCode" style="width: 350px;" placeholder="请输入税收分类编码"></el-input>
          </el-form-item>
          <el-form-item label="是否需要物流：" prop="needLogistics" v-if="ruleForm.bizType !== 6">
            <el-checkbox v-model="ruleForm.needLogistics" label="是否需要物流" size="large" />
          </el-form-item>
          <el-form-item label="税率：" prop="taxRate">
            <el-input-number :max="1" :min="0" :precision="2" :step="0.01" v-model="ruleForm.taxRate" style="width: 150px;" placeholder="请输入税率">
              <template #suffix>
                <span>%</span>
              </template>
            </el-input-number>
          </el-form-item>
          <div v-show="(ruleForm.bizType === 2 || ruleForm.bizType === 3) && (ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VOUCHER' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE')">
            <div v-show="ruleForm.bizType === 2 && (ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE')">
              <el-form-item label="商品上架时长：" prop="listingTime">
                <el-date-picker
                    class="mg_r_1"
                    v-model="ruleForm.listingTime"
                    type="datetime"
                    placeholder="开始日期"
                    format="YYYY-MM-DD HH:mm"
                    @change="(val) => handleListingTimeChange(val, ruleForm.delistingTime)"
                />
                至
                <el-date-picker
                    class="mg_l_1"
                    v-model="ruleForm.delistingTime"
                    type="datetime"
                    placeholder="结束日期"
                    format="YYYY-MM-DD HH:mm"
                    :disabled-date="(time) => disabledEndDate(time, ruleForm.listingTime)"
                />
              </el-form-item>
              <el-form-item label="商品标签：" prop="tagList">
                <YTTagSelect ref="YTTagSelectRef" :selectedCount="ruleForm.tagList.length" :width="416" :tagList="tagList" @tagChange="handleActivityTagChange">
                  <template #trigger="{ toggle, visible }">
                    <div @click="toggle">
                      <div :class="['yt_tag_select_box', 'input-null']">
                        <div class="el-select__wrapper flex_left">
                          <div style="flex:1">
                            <div class="yt_tag_select_placeholder" v-if="ruleForm.tagList.length === 0">可选择1-2个标签</div>
                            <div v-else>
                            <span class="yt_tag_select_tag" v-for="(item, index) in ruleForm.tagList" :key="`tagListInput${index}`">
                              {{item.tagName}}
                              <img @click.stop="handleTagListRemoveTag(item.tagId)" style="width: 10px;height: 10px;margin-left: 5px;" src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/activity/activity/tag_remove.svg"/>
                            </span>
                            </div>
                          </div>
                          <div class="yt_tag_select_suffix">
                            <img class="yt_tag_select_suffix_icon" src="@/assets/images/filter/select-arrowDown.svg" :class="{reverse: visible}"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </YTTagSelect>
              </el-form-item>
            </div>
            <el-form-item label="须知：" prop="noticeContent">
              <el-tabs
                  v-model="noticeContentTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input style="width: 350px;" maxlength="50" show-word-limit v-model="ruleForm.noticeContent" placeholder="请输入须知"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input style="width: 350px;" maxlength="500" show-word-limit v-model="ruleForm.noticeContentEn" placeholder="Please enter notice content"></el-input>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="保障：" prop="guaranteeContent">
              <el-tabs
                  v-model="guaranteeContentTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input style="width: 350px;" maxlength="50" show-word-limit v-model="ruleForm.guaranteeContent" placeholder="请输入保障"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input style="width: 350px;" maxlength="500" show-word-limit v-model="ruleForm.guaranteeContentEn" placeholder="Please enter guarantee content"></el-input>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <div v-show="ruleForm.bizType === 3 && (ruleForm.innerCategoryType === 'VOUCHER')">
              <el-form-item label="使用规则：" prop="ruleDescription">
                <el-tabs
                    v-model="ruleDescriptionTab"
                    type="card"
                    class="demo-tabs"
                >
                  <el-tab-pane label="中文" name="zh">
                    <el-input type="textarea" :rows="5" resize="none" maxlength="1000" show-word-limit style="width:550px" placeholder="请输入使用规则" v-model="ruleForm.ruleDescription"></el-input>
                  </el-tab-pane>
                  <el-tab-pane label="English" name="en">
                    <el-input type="textarea" :rows="5" resize="none" style="width:550px" placeholder="Please enter the rule description" v-model="ruleForm.ruleDescriptionEn"></el-input>
                  </el-tab-pane>
                </el-tabs>
              </el-form-item>
            </div>
          </div>
          <el-form-item label="商品简介：" prop="summary">
            <el-tabs
                v-model="summaryTab"
                type="card"
                class="demo-tabs"
            >
              <el-tab-pane label="中文" name="zh">
                <el-input type="textarea" :rows="5" resize="none" maxlength="100" show-word-limit style="width:550px" placeholder="请输入商品简介" v-model="ruleForm.summary"></el-input>
              </el-tab-pane>
              <el-tab-pane label="English" name="en">
                <el-input type="textarea" :rows="5" resize="none" maxlength="300" show-word-limit style="width:550px" placeholder="Please enter the product description" v-model="ruleForm.summaryEn"></el-input>
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item label="商品描述：" prop="description">
            <div>
              <div>
                <el-radio-group v-model="isRich" :disabled="isEdit">
                  <el-radio :value="true" size="large">富文本编辑</el-radio>
                  <el-radio :value="false" size="large">导入公众号文章</el-radio>
                </el-radio-group>
              </div>
              <div v-show="isRich">
                <!-- 因为使用v-if会导致加载组件时出现错误，获取内容时ref无法正确获取节点，所以使用v-show -->
                <el-tabs
                    v-model="descTab"
                    type="card"
                    class="demo-tabs"
                >
                  <el-tab-pane label="中文" name="zh">
                    <el-input style="width: 800px" type="textarea" :rows="5" v-model="ruleForm.description" v-if="ruleForm.bizType === 4" placeholder="请输入商品描述"></el-input>
                    <YTEditor :ali-oss-path="'GOODS_DETAIL_PATH'" ref="YTEditorRef" v-else :maxPic="12" :max-pic-size="3" :cacheKey="'itemDesc'" :isCacheMode="isRich" :title="'商品描述（中文）'" :maxLength="6000" :reviewTxt="ruleForm.description" :cache-id="isEdit ? ruleForm.goodsId : '0'"></YTEditor>
                  </el-tab-pane>
                  <el-tab-pane label="English" name="en">
                    <el-input style="width: 800px" type="textarea" :rows="5" v-model="ruleForm.descriptionEn" v-if="ruleForm.bizType === 4" placeholder="Please enter description"></el-input>
                    <YTEditor :ali-oss-path="'GOODS_DETAIL_PATH'" ref="YTEditorEnRef" v-else :maxPic="12" :max-pic-size="3" :cacheKey="'itemDescEn'" :isCacheMode="isRich" :title="'商品描述（English）'" :maxLength="18000" :reviewTxt="ruleForm.descriptionEn" :cache-id="isEdit ? ruleForm.goodsId : '0'"></YTEditor>
                  </el-tab-pane>
                </el-tabs>
                <div><span class="tips_default">最多上传12张图片，单张图片不超过3MB</span></div>
              </div>
              <div v-show="!isRich">
                <div class="tips_default">
                  请输入微信公众号文章的网页地址，例如：https://mp.weixin.qq.com/s/4rJ35J1i50gsLx4NHAxPIg
                </div>
                <el-input style="width:550px" maxlength="1000" show-word-limit v-model="ruleForm.description" placeholder="请输入文章链接"></el-input>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="商品图片：" prop="images">
            <BoxUpload ref="boxUploadRef" :ali-oss-path="'GOODS_IMG_PATH'" :width="800" :height="800" :limit="4" :file-size="1" @progress="loading = true" @remove="handleImageRemove" @success="handlePicSuccess"></BoxUpload>
          </el-form-item>
          <el-form-item label="用户等级：" prop="memberLevelId">
            <el-select v-model="ruleForm.memberLevelId" placeholder="请选择用户等级" style="width: 240px">
              <el-option
                  v-for="item in memberLevel"
                  :key="item.memberLevelId"
                  :label="item.levelName"
                  :value="item.memberLevelId"
              />
            </el-select>
            <span class="tips_default mg_l_1">该等级及以上用户可以获得并使用此商品。</span>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'预约日历设置'" v-if="ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT'">
      <template #container>
        <el-form-item label="日历开放（二选一）：" prop="serviceGoodsInfo.venueEntranceCalendarSetting">
          <div>
            <el-radio-group v-model="ruleForm.serviceGoodsInfo.venueEntranceCalendarSetting">
              <el-radio :value="'OPERATING_HOURS'">场地根据营业时间预约日历</el-radio>
              <el-radio :value="'CUSTOM'">场地自定义预约日历</el-radio>
            </el-radio-group>
            <div style="line-height: 20px;" class="tips_default">备注：选择营业时间预约日历，入场预约日历默认根据营业时间显示，同时也可以手动开放/关闭时间段，没有手动设置的还是继续按照营业时间开放。
              <br>选择自定义预约日历，场地整个入场预约日历都是关闭状态，需要手动开放时间段
            </div>
          </div>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'扩展信息'" v-if="ruleForm.bizType === 3 ||
    ruleForm.bizType === 4 ||
    ruleForm.bizType === 5 ||
    (ruleForm.innerCategoryType === 'COMPETITION' ||
    ruleForm.innerCategoryType === 'COURSE' ||
    ruleForm.innerCategoryType === 'NUMBER' ||
    ruleForm.innerCategoryType === 'COMBO' ||
    ruleForm.innerCategoryType === 'COUPON' ||
    ruleForm.innerCategoryType === 'STICKER' ||
    ruleForm.innerCategoryType === 'THERAPY_SERVICE' ||
    ruleForm.innerCategoryType === 'VENUE_COURSE' ||
    ruleForm.innerCategoryType === 'PHOTOGRAPHY' ||
    ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' ||
    ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE')">
      <template #container>
        <div v-loading="loading">
          <div v-if="ruleForm.innerCategoryType === 'STICKER'">
            <el-form-item label="是否可定制：" prop="isCustomizable">
              <el-radio-group v-model="ruleForm.isCustomizable">
                <el-radio :value="true">是</el-radio>
                <el-radio :value="false">否</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if="ruleForm.innerCategoryType === 'COMPETITION'">
            <el-form-item label="赛事发现页推荐封面图:" prop="discoverCoverImage" v-if="ruleForm.bizType === 5">
                <BoxUpload ref="boxUploadDiscoverCoverRef" :ali-oss-path="'GOODS_DISCOVER_COVER_IMAGE'" :width="280" :height="280" :limit="1" :file-size="1" @progress="loading = true" @remove="handleDiscoverCoverImageRemove" @success="handleDiscoverCoverPicSuccess"></BoxUpload>
            </el-form-item>
            <el-form-item label="主办方:" prop="organizerName" v-if="ruleForm.bizType === 5">
              <el-tabs
                  v-model="organizerNameTab"
                  type="card"
                  class="demo-tabs"
              >
                <el-tab-pane label="中文" name="zh">
                  <el-input class="mg_r_1" style="width: 550px" placeholder="主办方名称" v-model="ruleForm.organizerName"></el-input>
                </el-tab-pane>
                <el-tab-pane label="English" name="en">
                  <el-input class="mg_r_1" style="width: 550px" placeholder="organizer Name" v-model="ruleForm.organizerNameEn"></el-input>
                </el-tab-pane>
              </el-tabs>
            </el-form-item>
            <el-form-item label="组别设置：" prop="competitionDivisions" v-if="ruleForm.bizType === 5">
              <div class="mg_b_1 w-100" v-for="(item, index) in ruleForm.competitionDivisions" :key="`competitionDivisions${index}`">
                <div class="flex_align_t flex_left mg_b_1">
                  <el-tabs
                      v-model="divisionNameTab"
                      type="card"
                      class="demo-tabs"
                  >
                    <el-tab-pane label="中文" name="zh">
                      <el-input class="mg_r_1" style="width: 180px" placeholder="组别名称" v-model="item.divisionName"></el-input>
                    </el-tab-pane>
                    <el-tab-pane label="English" name="en">
                      <el-input class="mg_r_1" style="width: 180px" placeholder="Group Name" v-model="item.divisionNameEn"></el-input>
                    </el-tab-pane>
                  </el-tabs>
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="删除"
                      placement="right">
                    <v-icon class="mg_l_4 mg_t_1 cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveCompetitionDivisions(index)"></v-icon>
                  </el-tooltip>
                  </div>
                  <div class="mg_b_1">
                    <div class="flex_bt mg_b_1">
                      <div class="flex flex_warp">
                        <div class="mg_r_1">原价：</div>
                        <el-input-number class="mg_r_1" :min="0" :precision="2" placeholder="报名费" v-model="item.originalPrice">
                          <template #prefix>
                            <span>￥</span>
                          </template>
                        </el-input-number>
                      </div>
                      <div class="flex flex_warp">
                        <div class="mg_r_1">会员价：</div>
                        <el-input-number class="mg_r_1" :min="0" :precision="2" placeholder="会员报名费" v-model="item.entryFee">
                          <template #prefix>
                            <span>￥</span>
                          </template>
                        </el-input-number>
                      </div>
                      <div class="flex flex_warp">
                        <div class="mg_r_1">VIP价：</div>
                        <el-input-number class="mg_r_1" :min="0" :precision="2" placeholder="VIP报名费" v-model="item.vipEntryFee">
                          <template #prefix>
                            <span>￥</span>
                          </template>
                        </el-input-number>
                      </div>
                    </div>
                    <div class="flex_bt mg_b_1">
                      <div class="flex">
                        <div class="mg_r_1">距离：</div>
                        <el-input-number class="mg_r_1" :min="0" :precision="2" placeholder="距离（KM）" v-model="item.distance">
                          <template #suffix>
                            <span>KM</span>
                          </template>
                        </el-input-number>
                      </div>
                      <div class="flex">
                        <div class="mg_r_1">爬升：</div>
                        <el-input-number class="mg_r_1" :min="0" :precision="2" placeholder="爬升（M）" v-model="item.elevationGain">
                          <template #suffix>
                            <span>M</span>
                          </template>
                        </el-input-number>
                      </div>
                    </div>
                    <div class="flex">
                      <div class="mg_r_1">报名限制数量：</div>
                      <el-input-number class="mg_r_1" :min="0" :precision="0" placeholder="限制数量" v-model="item.quotaLimit"></el-input-number>
                    </div>
                </div>
                <div class="mg_b_1">
                  <BoxUpload :ali-oss-path="'COMPETITION_ROUTE_MAP_URL_IMG_PATH'" :ref="el => { if (el) boxUploadCompetitionDivisionsRef[index] = el }" :index="index" :width="800" :height="800" :limit="1" :file-size="1" @progress="loading = true" @success="(url) => handleCompetitionDivisionsPicSuccess(url, index)" @remove="(url) => handleCompetitionDivisionsPicRemove(url, index)"></BoxUpload>
                </div>
                <div>
                  <el-tabs
                      v-model="competitionDivisionsDescTab"
                      type="card"
                      class="demo-tabs"
                  >
                    <el-tab-pane label="中文" name="zh">
                      <YTEditor :ali-oss-path="'COMPETITION_DESCRIPTION_IMG_PATH'" :pre-path="`goods/description/images/`" ref="YTEditorCompetitionDivisionsRef" :maxPicSize="3" :isCacheMode="false" :title="'组别设置'" :maxLength="1000" :reviewTxt="item.description" @change="(txt, imgArr) => handleCompetitionDivisionsDesc(index, txt, imgArr)"></YTEditor>
                    </el-tab-pane>
                    <el-tab-pane label="English" name="en">
                      <YTEditor :ali-oss-path="'COMPETITION_DESCRIPTION_IMG_PATH'" ref="YTEditorCompetitionDivisionsEnRef" :maxPicSize="3" :isCacheMode="false" :title="'组别设置'" :maxLength="3000" :reviewTxt="item.descriptionEn" @change="(txt, imgArr) => handleCompetitionDivisionsDescEn(index, txt, imgArr)"></YTEditor>
                    </el-tab-pane>
                  </el-tabs>

                  <div><span class="tips_default">最多上传5张图片，单张图片不超过3MB</span></div>
                </div>
                <el-divider></el-divider>
              </div>
              <div>
                <v-btn @click="handleAddCompetitionDivisions">添加组别</v-btn>
                <span class="tips_default mg_l_4">赛事包含多个组别时，在这里添加。例如初级组、高级组等。</span>
              </div>
            </el-form-item>
            <el-form-item label="配套服务：" prop="groups" v-if="ruleForm.bizType === 5">
              <div class="mg_b_1 w-100" v-for="(item, index) in ruleForm.groups" :key="`group${index}`">
                <div class="flex_left flex_align_t">
                  <div class="mg_b_1 mg_r_2">
                    <el-tabs
                        v-model="groupNameTab"
                        type="card"
                        class="demo-tabs"
                    >
                      <el-tab-pane label="中文" name="zh">
                        <el-input style="width: 180px" placeholder="服务名称" v-model="item.groupName"></el-input>
                      </el-tab-pane>
                      <el-tab-pane label="English" name="en">
                        <el-input class="mg_r_1" style="width: 180px" placeholder="Service name" v-model="item.groupNameEn"></el-input>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <div class="flex_center">
                    <el-checkbox v-if="!loading" class="mg_r_2" label="必选" :checked="item.groupType === 'FIXED'" @change="(e) =>handleGroupTypeChange(e, index)"/>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除"
                        placement="right">
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveGroups(index)"></v-icon>
                    </el-tooltip>
                  </div>
                </div>
                <el-form-item label="已关联商品:">
                  <div v-if="item.items">
                    <div v-if="item.items.length > 0">
                      <div class="mg_b_1" v-for="(sonItem, sonIndex) in item.items" :key="`items${index} - ${sonIndex}`">
                        <div class="flex_left">
                          <span class="mg_r_1">{{sonItem.goodsName}}</span>
                          <el-checkbox class="mg_r_1" v-if="!loading" label="是否赠送" :checked="sonItem.isGift" @change="(e) => handleIsGiftChange(e, index, sonIndex)"/>
                          <el-tooltip
                              class="box-item"
                              effect="dark"
                              content="删除"
                              placement="right">
                            <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveGroupsItems(index, sonIndex)"></v-icon>
                          </el-tooltip>
                        </div>
                        <div class="mg_b_1" v-if="sonItem.isGift">
                          <span style="color: #f56c6c;">*&nbsp;</span>默认赠送数量：
                          <el-input-number @change="handleGiftCountChange" :min="0" class="mg_r_1" v-model="sonItem.giftCount" placeholder="默认销售数量">
                            <template #suffix>
                              <span>个</span>
                            </template>
                          </el-input-number>
                          <div>
                            <el-checkbox class="mg_r_1" v-if="!loading" label="需要物流" :checked="sonItem.needLogistics" @change="(e) => handleNeedLogistics(e, index, sonIndex)"/>
                          </div>
                          <div>
                            <el-checkbox class="mg_r_1" v-if="!loading" label="报名时会员可在赠送数量范围内更改数量" :checked="sonItem.allowModifyGift" @change="(e) => handleAllowModifyGift(e, index, sonIndex)"/>
                          </div>
                        </div>
                        <div class="mg_b_1">
                          商品截止时间：
                          <el-date-picker
                              v-model="sonItem.deadlineTime"
                              type="datetime"
                              placeholder="截止日期"
                              format="YYYY/MM/DD HH:mm"
                          />
                        </div>
                        <div>
                          退款截止时间：
                          <el-date-picker
                              v-model="sonItem.refundDeadlineTime"
                              type="datetime"
                              placeholder="截止日期"
                              format="YYYY/MM/DD HH:mm"
                          />
                        </div>
                        <el-divider/>
                      </div>
                    </div>
                    <div v-else>
                      暂无关联商品信息
                    </div>
                  </div>
                </el-form-item>
                <div>
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddGroupsItem(item, index)"></v-icon>
                  <span>关联商品</span>
                  <el-link class="mg_l_1" :underline="false" type="primary" target="_blank" href="/addItem">需要添加新商品？点击去添加</el-link>
                </div>
                <el-divider></el-divider>
              </div>
              <div>
                <v-btn @click="handleGroups">添加配套服务</v-btn>
                <span class="tips_default mg_l_4">为赛事添加配套服务时，在这里添加。例如比赛服装、号码牌等</span>
              </div>
            </el-form-item>
            <el-form-item label="报名网址：" prop="applyUrl">
              <el-input style="width:550px" v-model="ruleForm.applyUrl" placeholder="请输入报名网址"></el-input>
            </el-form-item>
          </div>
          <div v-if="ruleForm.innerCategoryType === 'COURSE'">
            <el-form-item label="课堂人数：" prop="studentLimit">
              <el-input-number :min="0" v-model="ruleForm.studentLimit" placeholder="请输入课堂人数"></el-input-number>
            </el-form-item>
            <el-form-item label="课堂时长：" prop="courseDuration">
              <el-input-number :min="0" v-model="ruleForm.courseDuration" placeholder="请输入课堂时长">
                <template #suffix>
                  <span>分钟</span>
                </template>
              </el-input-number>
            </el-form-item>
            <!-- <el-form-item label="有效期：" prop="validityType">
              <el-radio-group v-model="ruleForm.validityType">
                <el-radio :value="`PERMANENT`">长期有效</el-radio>
                <el-radio :value="`DAYS`">
                  <span class="mg_r_1">有效天</span>
                  <el-input-number :disabled="ruleForm.validityType !== 'DAYS'" :min="0" v-model="ruleForm.validityDeadlineDate" placeholder="请输入有效天数"></el-input-number>
                </el-radio>
                <el-radio :value="`END_DATE`">
                  <span class="mg_r_1">截止日期</span>
                  <el-date-picker
                      :disabled="ruleForm.validityType !== 'END_DATE'"
                      v-model="ruleForm.validityDeadlineTime"
                      type="date"
                      placeholder="请选择截止日期"
                      size="default"
                      value-format="YYYY-MM-DD"
                  />
                </el-radio>
              </el-radio-group>
            </el-form-item> -->
          </div>
          <div v-if="ruleForm.bizType === 3">
            <el-form-item label="关联类型：" prop="relationType">
              <el-radio-group v-model="ruleForm.relationType">
                <el-radio :value="'SERVICE_ITEM'" @click.prevent="handleRelationType('SERVICE_ITEM')">关联服务项目</el-radio>
                <el-radio :value="'STORE'" @click.prevent="handleRelationType('STORE')">关联门店</el-radio>
              </el-radio-group>
              <!-- <div @click="ruleForm.relationType = null">清空</div> -->
            </el-form-item>
            <div v-if="ruleForm.relationType === 'SERVICE_ITEM'">
              <el-form-item label="关联的项目服务" prop="serviceItemId" required>
                <el-select :loading="serviceLoading" v-model="cacheService.serviceItemId" placeholder="项目服务" style="width: 240px" @change="handleSelectServiceItem">
                  <el-option
                      v-for="item in serviceItemList"
                      :key="item.serviceItemId"
                      :label="item.name"
                      :value="item.serviceItemId"
                  />
                  <template v-if="!loading && cacheService.serviceItemId && !serviceItemList.some(res => res.serviceItemId === cacheService.serviceItemId)" #header>
                    当前已选：
                    <el-option
                        :label="cacheService.name"
                        :value="cacheService.serviceItemId"
                    />
                  </template>

                  <template #footer>
                    <div class="flex_center">
                      <el-pagination
                          size="small"
                          background
                          layout="prev, pager, next"
                          :total="totalServiceItem"
                          class="mt-4"
                          v-model:current-page="pageServiceItem"
                          v-model:page-size="pageSizeServiceItem"
                          @current-change="handleChangeServiceItem"
                      />
                    </div>
                  </template>
                </el-select>
              </el-form-item>
            </div>
            <div v-if="ruleForm.relationType === 'STORE'">
              <el-form-item label="关联驿站：" prop="stores">
                <div>
                  <div class="flex_left flex_warp">
                    <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in ruleForm.stores" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseStoreTags(tagIndex)">
                      {{ tag.storeName }}
                    </el-tag>
                  </div>
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddStores"></v-icon>
                  <span>关联驿站</span>
                </div>
              </el-form-item>
              <el-form-item label="关联商品：" prop="relatedGoods">
                <div>
                  <div class="flex" v-if="ruleForm.voucherInfo.relatedGoods?.goodsId !== null">
                    <div class="mg_r_2">{{ruleForm.voucherInfo.relatedGoods?.relatedGoodsName}}</div>
                    <div>
                      <el-tooltip
                          class="box-item"
                          effect="dark"
                          content="删除电子卡券关联商品"
                          placement="right">
                        <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveVoucherItem"></v-icon>
                      </el-tooltip>
                    </div>
                  </div>
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddVoucherItem"></v-icon>
                  <span>关联商品</span>
                  <el-link class="mg_l_1" :underline="false" type="primary" target="_blank" href="/addItem">需要添加新商品？点击去添加</el-link>
                </div>
              </el-form-item>
            </div>
            <div v-if="!ruleForm.relationType || ruleForm.relationType === ''">
              <el-form-item label="关联商品：" prop="relatedGoods">
                <div>
                  <div class="flex" v-if="ruleForm.voucherInfo.relatedGoods?.goodsId !== null">
                    <div class="mg_r_2">{{ruleForm.voucherInfo.relatedGoods?.relatedGoodsName}}</div>
                    <div>
                      <el-tooltip
                          class="box-item"
                          effect="dark"
                          content="删除电子卡券关联商品"
                          placement="right">
                        <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveVoucherItem"></v-icon>
                      </el-tooltip>
                    </div>
                  </div>
                  <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddVoucherItem"></v-icon>
                  <span>关联商品</span>
                  <el-link class="mg_l_1" :underline="false" type="primary" target="_blank" href="/addItem">需要添加新商品？点击去添加</el-link>
                </div>
              </el-form-item>
            </div>
            <el-form-item label="有效期：" prop="voucherInfo.validityType">
              <el-radio-group v-model="ruleForm.voucherInfo.validityType">
                <el-radio :value="`DAYS`">
                  <span class="mg_r_1">有效天</span>
                  <el-input-number :disabled="ruleForm.voucherInfo.validityType !== 'DAYS'" :min="0" v-model="ruleForm.voucherInfo.validityDeadlineDate" placeholder="请输入有效天数"></el-input-number>
                </el-radio>
                <el-radio :value="`END_DATE`">
                  <span class="mg_r_1">截止日期</span>
                  <el-date-picker
                      :disabled="ruleForm.voucherInfo.validityType !== 'END_DATE'"
                      v-model="ruleForm.voucherInfo.validityDeadlineTime"
                      type="date"
                      placeholder="请选择截止日期"
                      size="default"
                      value-format="YYYY-MM-DD"
                  />
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if="ruleForm.bizType === 4">
            <el-form-item label="订单金额：" prop="couponInfo.minimumOrderAmount">
              <el-input-number :min="0" placeholder="请输入订单金额" v-model="ruleForm.couponInfo.minimumOrderAmount"></el-input-number>
              <span class="tips_default mg_l_2">订单大于等于该金额，优惠券才可使用</span>
            </el-form-item>
            <el-form-item label="抵扣金额：" prop="couponInfo.discountAmount">
              <el-input-number :min="0" placeholder="请输入抵扣金额" v-model="ruleForm.couponInfo.discountAmount"></el-input-number>
              <span class="tips_default mg_l_2">满足订单金额时，可以减免该金额。</span>
            </el-form-item>
            <el-form-item label="关联驿站：" prop="stores">
              <div>
                <div class="flex_left flex_warp">
                  <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in ruleForm.stores" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseStoreTags(tagIndex)">
                    {{ tag.storeName }}
                  </el-tag>
                </div>
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddStores"></v-icon>
                <span>关联驿站</span>
              </div>
            </el-form-item>
            <el-form-item label="有效期：" prop="couponInfo.validityType">
              <el-radio-group v-model="ruleForm.couponInfo.validityType">
                <el-radio :value="`DAYS`">
                  <span class="mg_r_1">有效天</span>
                  <el-input-number :disabled="ruleForm.couponInfo.validityType !== 'DAYS'" :min="0" v-model="ruleForm.couponInfo.validityDeadlineDate" placeholder="请输入有效天数"></el-input-number>
                </el-radio>
                <el-radio :value="`END_DATE`">
                  <span class="mg_r_1">截止日期</span>
                  <el-date-picker
                      :disabled="ruleForm.couponInfo.validityType !== 'END_DATE'"
                      v-model="ruleForm.couponInfo.validityDeadlineTime"
                      type="date"
                      placeholder="请选择截止日期"
                      size="default"
                      value-format="YYYY-MM-DD"
                  />
                </el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div v-if="ruleForm.innerCategoryType === 'NUMBER'">
            <el-form-item label="号码范围：" prop="numberRange">
              <div class="flex">
                <el-input-number class="mg_r_1" placeholder="起始数字" :precision="0" :min="0" v-model="ruleForm.startNumber"></el-input-number>
                <div class="mg_r_1">至</div>
                <el-input-number placeholder="终止数字" :min="0" :precision="0" v-model="ruleForm.endNumber"></el-input-number>
              </div>
            </el-form-item>
          </div>
          <div v-if="ruleForm.innerCategoryType !== 'COMPETITION' && ruleForm.bizType === 5">
            <el-form-item label="分组商品" prop="groups">
              <div class="w-100">
                <div v-for="(item, index) in ruleForm.groups" :key="`groupGoods${index}`">
                  <div class="flex_left mg_b_1">
                    <el-input show-word-limit maxlength="10" class="mg_r_1" style="width: 180px" placeholder="分组名称" v-model="item.groupName"></el-input>
                    <el-input-number class="mg_r_2" :min="0" :max="item.items.length" placeholder="可选商品数量" v-model="item.optionCount"></el-input-number>
                    <el-checkbox v-if="!loading" label="必选" :checked="item.groupType === 'FIXED'" @change="(e) => handleComboGroupTypeChange(e, index)"/>
                    <el-tooltip
                        class="box-item"
                        effect="dark"
                        content="删除分组商品"
                        placement="right">
                      <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveGroupGoods(index)"></v-icon>
                    </el-tooltip>
                  </div>
                  <el-form-item label="已关联商品:">
                    <div v-if="item.items.length > 0">
                      <div class="flex_left mg_b_1" v-for="(sonItem, sonIndex) in item.items" :key="`items${index} - ${sonIndex}`">
                        <div class="mg_r_1 flex" v-if="sonItem.innerCategoryType === 'VOUCHER'">{{handleGoodsNameBindStoresStr(sonItem.goodsName, sonItem.voucherInfo.stores)}}</div>
                        <div class="mg_r_1 flex" v-else-if="sonItem.innerCategoryType === 'COUPON'">{{handleGoodsNameBindStoresStr(sonItem.goodsName, sonItem.couponInfo.stores)}}</div>
                        <div class="mg_r_1" v-else>
                          <div>{{sonItem.goodsName}}</div>
                        </div>
                        <el-input-number class="mg_r_1" :min="1" :precision="0" v-model="sonItem.fixedCount" placeholder="请输入数量" @change="sonItem.optionCount = sonItem.fixedCount"></el-input-number>
                        <el-checkbox class="mg_r_1" v-if="!loading" label="是否需要补发" :checked="sonItem.needReissue" @change="(e) => handleNeedReissueChange(e, index, sonIndex)"/>
                        <el-tooltip
                            class="box-item"
                            effect="dark"
                            content="删除关联商品"
                            placement="right">
                          <v-icon class="cursor-pointer mg_l_1" color="error" icon="mdi-close" @click="handleRemoveGroupGoodsItems(index, sonIndex)"></v-icon>
                        </el-tooltip>
                      </div>
                    </div>
                    <div v-else>暂无关联商品信息</div>
                  </el-form-item>
                  <div>
                    <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddGroupGoods(item, index)"></v-icon>
                    <span>关联商品</span>
                    <el-link class="mg_l_1" :underline="false" type="primary" target="_blank" href="/addItem">需要添加新商品？点击去添加</el-link>
                  </div>
                  <el-divider></el-divider>
                </div>
                <div>
                  <v-btn @click="handleGroupsGoods">添加分组商品</v-btn>
                </div>
              </div>
            </el-form-item>
          </div>
          <div v-if="ruleForm.innerCategoryType === 'THERAPY_SERVICE' || ruleForm.innerCategoryType === 'PHOTOGRAPHY' || ruleForm.innerCategoryType === 'BIKE_MAINTENANCE' || ruleForm.innerCategoryType === 'VENUE_COURSE' || ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE'">
            <el-form-item label="商品服务时长：" prop="" v-show="ruleForm.innerCategoryType !== 'APPOINTMENT_SERVICE'">
              <el-select v-model="ruleForm.serviceDuration" :disabled="true" class="mg_r_1" placeholder="Select" style="width: 100px">
                <el-option
                    v-for="item in servicesDurationEnum"
                    :key="`servicesDurationEnum${item.value}`"
                    :label="item.label"
                    :value="item.value"
                />
              </el-select>
              <span>小时</span>
            </el-form-item>
            <div v-if="ruleForm.innerCategoryType === 'APPOINTMENT_SERVICE'">
              <el-form-item label="购买后使用有效期：" prop="validityDays">
                <el-input-number class="mg_r_1" :min="1" :precision="1" :step="0.1" v-model="ruleForm.validityDays" style="width: 150px;" placeholder="购买后使用有效期" />
                <span>天</span>
              </el-form-item>
              <el-form-item label="是否需要预约：" prop="appointmentRequired">
                <el-radio-group v-model="ruleForm.appointmentRequired">
<!--                  <el-radio :value="true" size="large">是，需要预约</el-radio>-->
                  <el-radio :value="false" size="large">否，无需预约</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="有效期内使用次数：" prop="">
                <el-input-number class="mg_r_1" :min="1" :precision="0" :step="1" v-model="ruleForm.usageLimit" style="width: 150px;" placeholder="有效期内使用次数" />
                <span>次</span>
              </el-form-item>
            </div>
          </div>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'添加第三方保险'" v-if="ruleForm.bizType === 2 && ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT'">
      <template #container>
        <el-form-item label="保险购买（选择其中一种）：" prop="hasInsurance">
          <div class="insurance_form_content">
            <el-checkbox-group v-model="ruleForm.hasInsurance" @change="handleInsuranceTypeChange">
              <el-checkbox value="REQUIRED" label="必须购买选中的保险产品之一"></el-checkbox>
              <el-checkbox value="OPTIONAL" label="非必买选中的保险产品之一"></el-checkbox>
            </el-checkbox-group>

            <div class="insurance_table_wrap">
              <el-table
                  ref="insuranceTableRef"
                  class="insurance_table mg_b_1"
                  :data="insuranceTableData"
                  v-loading="insuranceLoading"
                  :row-key="getInsuranceId"
                  stripe
                  reserve-selection
                  @selection-change="handleInsuranceSelectionChange"
              >
                <el-table-column type="selection" width="55"/>
                <el-table-column prop="insuranceName" label="保险产品名称" min-width="160"/>
                <el-table-column prop="insuranceProductCode" label="保险产品编号" min-width="160"/>
                <el-table-column prop="insuranceCompany" label="保险公司" min-width="180"/>
                <el-table-column label="保险保障期限" min-width="140">
                  <template #default="{ row }">
                    {{ row.insuranceDuration }}{{ insuranceDurationUnitEnum.find(item => item.stateId === row.insuranceDurationUnit)?.stateName }}
                  </template>
                </el-table-column>
                <el-table-column label="保险价格" min-width="100">
                  <template #default="{ row }">
                    {{ row.insurancePrice }}
                  </template>
                </el-table-column>
                <template #empty>
                  <span>{{ insuranceTotal > 0 ? '暂无可选保险产品' : '没有更多数据了' }}</span>
                </template>
              </el-table>
            </div>
            <span>备注：选择必须购买时，小程序需要填写预约人（监护人）和游玩人信息</span>
            <span>选择非必买时，小程序需要填写预约人信息</span>
          </div>
        </el-form-item>
        <el-form-item label="保险购买注意事项：">
          <el-tabs
              v-model="insurancePurchaseNoticeTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input type="textarea" :rows="5" resize="none" maxlength="200" show-word-limit style="width:550px" placeholder="请输入保险购买注意事项" v-model="ruleForm.insurancePurchaseNotice"></el-input>
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input type="textarea" :rows="5" resize="none" maxlength="1000" show-word-limit style="width:550px" placeholder="Please enter insurance purchase notes" v-model="ruleForm.insurancePurchaseNoticeEn"></el-input>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'关联信息'" :sub-title="'备注:入场预约的加购商品默认是该场地下的服务商品'" v-if="ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT'">
      <template #container>
        <el-form-item label="商品加购上限：" prop="maxAddQty">
          <el-input-number class="no-validate-icon" :precision="0" :min="0" :max="100" v-model="ruleForm.maxAddQty"></el-input-number>
        </el-form-item>
        <el-form-item label="商品购买规则：" prop="">
          <el-tabs
              v-model="purchaseRuleContentTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input type="textarea" :rows="5" resize="none" maxlength="300" show-word-limit style="width:550px" placeholder="请输入商品购买规则" v-model="ruleForm.purchaseRuleContent"></el-input>
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input type="textarea" :rows="5" resize="none" maxlength="900" show-word-limit style="width:550px" placeholder="Please enter the purchase ruleContent" v-model="ruleForm.purchaseRuleContentEn"></el-input>
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'周边商品'" v-if="ruleForm.innerCategoryType === 'COMPETITION'">
      <template #container>
        <el-form-item label="周边列表：" prop="relatedGoodsList">
          <div>
            <div class="mg_b_1" v-for="(item, index) in ruleForm.relatedGoodsList" :key="`relatedGoodsList${index}`">
              <div class="flex_center flex_left mg_b_1">
                <div class="mg_r_1">{{item.goodsName}}</div>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="删除"
                    placement="right">
                  <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRelatedGoodsListItems(index)"></v-icon>
                </el-tooltip>
              </div>
              <div>
                <div class="mg_r_1 mg_b_1">
                  商品截止时间：
                  <el-date-picker
                      v-model="item.deadlineTime"
                      type="datetime"
                      placeholder="截止日期"
                      format="YYYY/MM/DD HH:mm"
                  />
                </div>
                <div class="mg_r_1 mg_b_1">
                  每位用户可购买数量：
                  <el-input-number class="mg_r_1" v-model="item.maxQuantityPerUser" :max="99" :min="0" placholder="请输入可购买数量"/>
                  <span class="tips_default">不填写数字表示不限制</span>
                </div>
                <div>
                  退款截止时间：
                  <el-date-picker
                      v-model="item.refundDeadlineTime"
                      type="datetime"
                      placeholder="截止日期"
                      format="YYYY/MM/DD HH:mm"
                  />
                </div>
                <el-checkbox class="mg_r_1" v-if="!loading" label="需要物流" :checked="item.needLogistics" @change="(e) => handleRelatedGoodsListNeedLogistics(e, index, sonIndex)"/>
              </div>
              <el-divider/>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddRelatedGoodsList()"></v-icon>
              <span>添加商品</span>
            </div>
          </div>
        </el-form-item>
      </template>
    </YTCard>
    <YTCard :title="'配置商城商品信息'" v-if="ruleForm.bizType === 6 && ruleForm.innerCategoryType === 'MALL'">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="商品类型（前端展示）：" prop="mallGoodsCategoryTagList">
            <div>
              <el-check-tag :disabled="ruleForm.mallGoodsCategoryTagList?.length >= 1 && !tag.checked" class="mg_r_1" v-for="(tag, index) in itemTypeSkillTags" :key="`itemTypeSkillTags${index}`" :checked="tag.checked" type="primary" @change="handleItemTypeSkillTagsChange(tag)">
                {{tag.tagName}}
              </el-check-tag>
            </div>
          </el-form-item>
          <el-form-item label="发货时间：" prop="shipWithinHours">
            <el-input-number class="no-validate-icon mg_r_1" :precision="2" :min="0" v-model="ruleForm.mallGoods.shipWithinHours" placeholder="请输入内容"></el-input-number>
            <div>小时</div>
          </el-form-item>
          <el-form-item label="物流设置：" prop="needLogistics">
            <div class="flex_left mg_r_2">
              <div style="margin-right: 13px">
                <YTRadio
                    :show="ruleForm.needLogistics"
                    @click="handleNeedLogisticsChange(true)"
                ></YTRadio>
              </div>
              <div style="font-size: 16px" class="tips">是，需要物流</div>
            </div>
            <div class="flex_left mg_r_2">
              <div style="margin-right: 13px">
                <YTRadio
                    :show="!ruleForm.needLogistics"
                    @click="handleNeedLogisticsChange(false)"
                ></YTRadio>
              </div>
              <div style="font-size: 16px" class="tips">否，不需要物流</div>
            </div>
          </el-form-item>
          <el-form-item label="快递费：" prop="expressPaymentType" v-if="ruleForm.needLogistics">
            <div class="flex_left mg_r_2">
              <div style="margin-right: 13px">
                <YTRadio
                    :show="ruleForm.mallGoods.expressPaymentType === 'MERCHANT'"
                    @click="ruleForm.mallGoods.expressPaymentType = 'MERCHANT'"
                ></YTRadio>
              </div>
              <div style="font-size: 16px" class="tips">品牌方/卖家承担</div>
            </div>
            <div class="flex_left mg_r_2">
              <div style="margin-right: 13px">
                <YTRadio
                    :show="ruleForm.mallGoods.expressPaymentType === 'CASH_ON_DELIVERY'"
                    @click="ruleForm.mallGoods.expressPaymentType = 'CASH_ON_DELIVERY'"
                ></YTRadio>
              </div>
              <div style="font-size: 16px" class="tips">买家承担</div>
            </div>
          </el-form-item>
          <el-form-item label="商品服务信息：" prop="mallServiceInfoTagList">
            <div>
              <el-check-tag :disabled="ruleForm.mallServiceInfoTagList?.length >= 5 && !tag.checked" class="mg_r_1" v-for="(tag, index) in itemServiceSkillTags" :key="`itemServiceSkillTags${index}`" :checked="tag.checked" type="primary" @change="handleItemServiceSkillTagsChange(tag)">
                {{tag.tagName}}
              </el-check-tag>
            </div>
          </el-form-item>
          <el-form-item label="退货规则（发货后）：" prop="">
            <div class="flex_left mg_r_2">
              <div style="margin-right: 13px">
                <YTRadio
                    :show="ruleForm.mallGoods.refundSupported"
                    @click="ruleForm.mallGoods.refundSupported = true"
                ></YTRadio>
              </div>
              <div style="font-size: 16px" class="tips">是，可退款</div>
            </div>
            <div class="flex_left mg_r_2">
              <div style="margin-right: 13px">
                <YTRadio
                    :show="!ruleForm.mallGoods.refundSupported"
                    @click="ruleForm.mallGoods.refundSupported = false"
                ></YTRadio>
              </div>
              <div style="font-size: 16px" class="tips">否，不可退款</div>
            </div>
          </el-form-item>
          <el-form-item label="退货须知：" prop="mallReturnPolicyTagList">
            <div>
              <el-check-tag :disabled="ruleForm.mallReturnPolicyTagList?.length >= 1 && !tag.checked" class="mg_r_1" v-for="(tag, index) in itemReturnSkillTags" :key="`itemReturnSkillTags${index}`" :checked="tag.checked" type="primary" @change="handleItemReturnSkillTagsChange(tag)">
                {{tag.tagName}}
              </el-check-tag>
            </div>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'销售渠道'" v-show="ruleForm.bizType !== 4">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="" prop="salesChannel">
            <el-checkbox-group size="large" v-model="ruleForm.salesChannel" @change="handleSalesChannelChange">
              <el-checkbox :disabled="ruleForm.innerCategoryType === 'COMPETITION' && item.key !== 'COMPETITION'" v-for="(item, index) in channelEnum" :key="`changeChannelBox${item.salesChannelName}${index}`" :label="`${item.description}渠道`" :value="item.key" />
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="俱乐部：" v-if="handleSalesChannelShow('CLUB')">
            <div class="flex_left flex_warp">
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.clubList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelClubTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('CLUB')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="驿站：" v-if="handleSalesChannelShow('STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.storeList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('STORE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="网店：" v-if="handleSalesChannelShow('ONLINE_STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.onlineStoreList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelOnlineStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('ONLINE_STORE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="场地：" v-if="handleSalesChannelShow('VENUE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.venueList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelVenueTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('VENUE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="车店：" v-if="handleSalesChannelShow('BIKE_STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.bikeStoreList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelBikeStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('BIKE_STORE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="理疗服务商：" v-if="handleSalesChannelShow('THERAPIST_STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.therapistStoreList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelTherapistStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('THERAPIST_STORE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="摄影服务商：" v-if="handleSalesChannelShow('PHOTOGRAPHY_STORE')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.photographyStoreList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelPhotographyStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('PHOTOGRAPHY_STORE')"></v-icon>
            </div>
          </el-form-item>
          <el-form-item label="品牌方：" v-if="handleSalesChannelShow('BRAND')">
            <div>
              <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in cacheSalesChannelList.brandStoreList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseSalesChannelBrandStoreTags(tagIndex)">
                {{ tag.storeName }}
              </el-tag>
            </div>
            <div>
              <v-icon class="cursor-pointer mg_r_1" icon="mdi-plus-circle-outline" color="success" size="32" @click="handleAddSalesChannel('BRAND')"></v-icon>
            </div>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'价格库存'" :is-show-divider="ruleForm.bizType !== 3">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="原价：" prop="originalPrice" v-if="ruleForm.innerCategoryType !== 'MALL'">
            <el-input-number class="no-validate-icon" :precision="2" :min="0" v-model="ruleForm.originalPrice"></el-input-number>
            <span class="tips_default mg_l_1">商品原本的售价</span>
          </el-form-item>
          <el-form-item label="会员价：" prop="retailPrice">
            <el-input-number class="no-validate-icon" :precision="2" :min="0" v-model="ruleForm.retailPrice"></el-input-number>
            <span class="tips_default mg_l_1">注册平台普通会员时购买的价格</span>
          </el-form-item>
          <el-form-item label="成本价格：" prop="costDetails" v-if="ruleForm.innerCategoryType !== 'MALL'">
            <div class="mg_b_3" v-for="(item, index) in ruleForm.costDetails" :key="`costDetails${item}${index}`" style="width: 100%">
              <div class="flex flex_left">
                <div style="padding-right: 12px;text-align: right" v-text="`${item.costName}:`"></div>
                <div class="mg_r_2" v-text="`￥${item.costPrice}`"></div>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="删除"
                    placement="right"
                    @click.stop>
                  <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveCostPrice(index)"></v-icon>
                </el-tooltip>
              </div>
            </div>
            <v-btn @click="handleAddCostPrice">添加成本价格</v-btn>
          </el-form-item>
          <el-form-item label="使用次数：" prop="usageCount" v-if="(ruleForm.bizType === 2 || ruleForm.bizType === 3 || ruleForm.bizType === 4) && (ruleForm.innerCategoryType === 'COURSE' || ruleForm.innerCategoryType === 'VOUCHER' || ruleForm.innerCategoryType === 'COUPON')">
            <el-input-number :min="0" v-model="ruleForm.usageCount" :disabled="ruleForm.bizType === 3"></el-input-number>
          </el-form-item>
          <el-form-item label="积分价格：" prop="pointsPrice" v-if="ruleForm.bizType === 3 || ruleForm.bizType === 4">
            <el-input-number :min="0" v-model="ruleForm.pointsPrice" placeholder="请输入积分价格"></el-input-number>
          </el-form-item>
          <el-form-item label="VIP价：" prop="vipPrice">
            <el-input-number :min="0" :precision="2" v-model="ruleForm.vipPrice" placeholder="请输入VIP价"></el-input-number>
            <span class="tips_default mg_l_1">平台VIP及以上等级购买的价格</span>
          </el-form-item>
        </div>
      </template>
    </YTCard>
    <YTCard :title="'商品属性'" :is-show-divider="false" v-if="ruleForm.bizType !== 3 && ruleForm.bizType !== 4">
      <template #container>
        <div v-loading="loading">
          <el-form-item label="商品属性：" prop="propertyGroupList" v-if="ruleForm.bizType !== 6">
            <div v-show="ruleForm.bizType === 1" style="width: 100%">
              <div v-for="(item, index) in itemProp" :key="`itemProp${item.groupName}${index}`">
                <el-select
                    @change="handleSelectProp(item, index)"
                    v-model="item.propertyGroupId"
                    placeholder="请选择商品属性"
                    size="large"
                    style="width: 240px"
                    class="mg_r_1"
                    :loading="selectLoading"
                    :disabled="!item.unDisabled"
                >
                  <el-option
                      v-for="opt in options"
                      :key="opt.propertyGroupId"
                      :label="opt.groupName"
                      :value="opt.propertyGroupId"
                  />
                  <template #footer>
                    <div class="flex_center">
                      <el-pagination
                          size="small"
                          background
                          layout="prev, pager, next"
                          :total="total"
                          class="mt-4"
                          v-model:current-page="page"
                          v-model:page-size="pageSize"
                          @current-change="handleChangePage"
                      />
                    </div>
                  </template>
                </el-select>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="删除"
                    placement="right"
                    @click.stop>
                  <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveProp(index)"></v-icon>
                </el-tooltip>
                <div v-if="item.unDisabled">
                  <el-tag class="mg_r_1" v-for="(son, sonIndex) in item.propertyGroupItemList" :key="`itemPropTag${item.name}${sonIndex}`" :type="handleTagType(sonIndex)">{{handleFindPropLabel(son, item.propertyGroupId)}}</el-tag>
                </div>
                <div v-else>
                  <el-tag class="mg_r_1" v-for="(son, sonIndex) in item.propertyGroupItemList" :key="`itemPropTag${item.name}${sonIndex}`" :type="handleTagType(sonIndex)">{{son.propertyName}}</el-tag>
                </div>
                <v-divider style="margin: 20px 0"/>
              </div>
            </div>
            <div v-show="ruleForm.bizType === 2 || ruleForm.bizType === 5" style="width: 100%">
              <el-form-item
                  class="mg_b_3"
                  label="报名时间："
                  prop="applyTime"
                  label-width="120"
                  v-if="ruleForm.innerCategoryType === 'COMPETITION'">
                <div class="flex" style="width: 550px">
                  <el-date-picker
                      v-model="ruleForm.applyStartTime"
                      type="datetime"
                      placeholder="开始时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="(val) => handleApplyStartTimeChange(val, ruleForm.applyEndTime)"
                  />
                  <div class="mg_r_2 mg_l_2">至</div>
                  <el-date-picker
                      v-model="ruleForm.applyEndTime"
                      type="datetime"
                      placeholder="结束时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      :disabled-date="(time) => disabledEndDate(time, ruleForm.applyStartTime)"
                  />
                </div>
              </el-form-item>
              <el-form-item
                  class="mg_b_3"
                  :label="ruleForm.innerCategoryType === 'COMPETITION' || ruleForm.innerCategoryType === 'COMPETITION' ? '比赛时间：' :'有效时间：'"
                  prop="virTime"
                  label-width="120"
                  v-if="ruleForm.innerCategoryType === 'COMPETITION'">
                <div class="flex" style="width: 550px">
                  <el-date-picker
                      v-model="ruleForm.startTime"
                      type="datetime"
                      placeholder="开始时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      @change="(val) => handleStartTimeChange(val, ruleForm.endTime)"
                  />
                  <div class="mg_r_2 mg_l_2">至</div>
                  <el-date-picker
                      v-model="ruleForm.endTime"
                      type="datetime"
                      placeholder="结束时间"
                      format="YYYY-MM-DD HH:mm:ss"
                      :disabled-date="(time) => disabledEndDate(time, ruleForm.startTime)"
                  />
                </div>
              </el-form-item>
              <el-form-item class="mg_b_3" label="城市：" prop="address" label-width="120" v-if="ruleForm.innerCategoryType === 'COURSE' || ruleForm.innerCategoryType === 'COMPETITION'">
                <div style="width: 350px">
                  <YTAddress v-if="!loading" :addressCode="ruleForm.addressCode" :is-return-str="true" @select="handleSelectAddress"></YTAddress>
                </div>
              </el-form-item>
              <el-form-item class="mg_b_3" label="地点：" prop="addressDetail" label-width="120" v-if="ruleForm.innerCategoryType === 'COMPETITION'">
                <el-tabs
                    v-model="addressDetailTab"
                    type="card"
                    class="demo-tabs"
                >
                  <el-tab-pane label="中文" name="zh">
                    <el-input style="width: 300px;" v-model="ruleForm.addressDetail" placeholder="请输入地点"></el-input>
                  </el-tab-pane>
                  <el-tab-pane label="English" name="en">
                    <el-input style="width: 300px;" v-model="ruleForm.addressDetailEn" placeholder="Please enter the location."></el-input>
                  </el-tab-pane>
                </el-tabs>
              </el-form-item>
              <div class="mg_b_3" v-for="(item, index) in ruleForm.goodsVirtualItemList" :key="`goodsVirtualItemList${item}${index}`" style="width: 100%">
                <div class="flex flex_left">
                  <div style="width: 120px;padding-right: 12px;text-align: right" v-text="`${item.name}:`"></div>
                  <div class="mg_r_2" v-text="item.content"></div>
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="删除"
                      placement="right"
                      @click.stop>
                    <v-icon class="cursor-pointer" color="error" icon="mdi-close" @click="handleRemoveVirProp(index)"></v-icon>
                  </el-tooltip>
                </div>
              </div>
            </div>
            <div v-if="ruleForm.innerCategoryType !== 'NUMBER'">
              <v-btn @click="handleAddProp">添加属性项</v-btn>
              <span class="tips_default mg_l_4">收银开单时选择诸如甜度、口味、加料等商品属性。若需编辑属性信息，可进入属性库进行操作。</span>
            </div>
            <div v-if="ruleForm.innerCategoryType === 'NUMBER'">
              <el-form-item class="mg_b_2" label="号码前缀：" prop="numberPrefix">
                <div class="flex">
                  <el-input class="mg_r_1" style="width: 150px" v-model="ruleForm.numberPrefix" placeholder="请输入号码前缀" />
                  <div class="tips_default">添加在号码前的文案，例如号码前缀是M，号码显示M99。</div>
                </div>
              </el-form-item>
              <el-form-item label="号码后缀：" prop="numberSuffix">
                <div class="flex">
                  <el-input class="mg_r_1" style="width: 150px" v-model="ruleForm.numberSuffix" placeholder="请输入号码后缀" />
                  <div class="tips_default">添加在号码后的文案，例如号码后缀是M，号码显示99M。</div>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
          <div v-if="ruleForm.bizType === 6">
            <el-form-item label="属性设置：" prop="">
              <v-btn color="primary" class="mg_r_2" @click="handleClickCommonProps">选择通用属性</v-btn>
              <v-btn color="primary" @click="drawer = true">新建商品属性</v-btn>
            </el-form-item>
            <el-form-item :label="`属性项名称：`" prop="" v-for="(item, index) in ruleForm.propertyGroupList" :key="`drawerRuleForm.propertyGroupItemList${index}`">
              <div class="flex_bt w-100 mg_b_1">
                <div class="flex">
                  <div class="mg_r_2">{{item.groupName}}（{{item.isCommonProperty ? "通用属性" : "新建专用属性"}}）</div>
                  <div class="flex">
                    <el-checkbox v-model="item.useGroupImage" label="选用该套属性图片"/>
                  </div>
                </div>
                <div class="flex_center">
                  <v-btn class="mg_r_2" @click="handleAddNewProperty(item, index)">{{item.isCommonProperty ? '增加' : '编辑'}}属性值</v-btn>
                  <el-tooltip
                      class="box-item"
                      effect="dark"
                      content="删除"
                      placement="top">
                    <v-icon color="error" class="cursor-pointer" icon="mdi-close" @click="handleDeletePropertyGroupList(index)"></v-icon>
                  </el-tooltip>
                </div>
              </div>
              <el-table :data="item.propertyGroupItemList" stripe style="width: 100%">
                <el-table-column prop="propertyName" label="属性值（中文）" />
                <el-table-column prop="propertyNameEn" label="属性值（英文）" />
                <el-table-column prop="addPrice" label="加价（元）" />
                <el-table-column prop="image" label="商品属性图片">
                  <template #default="scoped">
                    <div v-if="scoped.row.image" class="flex_left">
                      <el-avatar shape="square" :size="80" fit="contain" :src="scoped.row.image" />
                    </div>
                    <div v-else>
                      -
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="" label="操作">
                  <template #default="scoped">
                    <el-popconfirm
                        width="288"
                        @confirm="handlePropertyStateChange('OFF_SHELF', index, scoped.$index)"
                        :title="`确认下架该属性值？`"
                    >
                      <template #reference>
                        <el-text class="mx-1 cursor-pointer" type="primary" v-show="scoped.row.state === 'ON_SHELF'">下架</el-text>
                      </template>
                      <template #actions="{ confirm, cancel }">
                        <div class="flex_right">
                          <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                          <v-btn size="small" color="#796CB4" @click="confirm">确定</v-btn>
                        </div>
                      </template>
                    </el-popconfirm>
                    <el-popconfirm
                        width="288"
                        @confirm="handlePropertyStateChange('ON_SHELF', index, scoped.$index)"
                        :title="`确认重新上架该属性值？`"
                    >
                      <template #reference>
                        <el-text class="mx-1 cursor-pointer" type="primary" v-show="scoped.row.state === 'OFF_SHELF'">重新上架</el-text>
                      </template>
                      <template #actions="{ confirm, cancel }">
                        <div class="flex_right">
                          <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                          <v-btn size="small" color="#796CB4" @click="confirm">确定</v-btn>
                        </div>
                      </template>
                    </el-popconfirm>

                    <el-popconfirm
                        width="288"
                        @confirm="handleDeletePropertyGroupItemList(index, scoped.$index)"
                        :title="`确认删除该属性值？`"
                    >
                      <template #reference>
                        <el-text class="mx-1 cursor-pointer" type="primary">删除</el-text>
                      </template>
                      <template #actions="{ confirm, cancel }">
                        <div class="flex_right">
                          <v-btn class="mg_r_2" size="small" @click="cancel">取消</v-btn>
                          <v-btn size="small" color="#796CB4" @click="confirm">确定</v-btn>
                        </div>
                      </template>
                    </el-popconfirm>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>
          </div>
        </div>
      </template>
    </YTCard>
    <v-row>
      <v-col cols="4">
        <v-row>
          <v-col cols="6">
            <v-btn @click="cancelAdd">取消</v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn color="primary" @click="submit" :disabled="loading">保存</v-btn>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </el-form>
  <YTFormDialog id="YTFormDialog" v-if="open" :title="ruleForm.bizType === 1 ? cacheProp.groupName : '添加商品属性'" :open="open">
    <template v-slot:content>
      <div v-if="ruleForm.bizType === 1">
        <el-checkbox-group v-model="cacheSelect">
          <div v-for="(item, index) in cacheProp.propertyGroupItemList">
            <el-checkbox @change="handleCheckAll" :key="`sonItemProp${item.propertyName}${index}`" :label="item.propertyName" :value="item.propertyGroupItemId"/>
          </div>
          <v-divider style="margin: 20px 0;"></v-divider>
        </el-checkbox-group>
      </div>
      <div v-else-if="ruleForm.bizType === 2 || ruleForm.bizType === 5">
        <el-form
          ref="virFormRef"
          :model="virForm"
          :rules="virRules"
          label-width="auto"
          class="demo-ruleForm mg_b_3"
          size="large"
          v-loading="loading">
          <el-form-item label="属性名称：" prop="name">
            <el-input show-word-limit maxlength="20" v-model="virForm.name" placeholder="请输入属性名称"></el-input>
          </el-form-item>
          <el-form-item label="属性值：" prop="content">
            <el-input type="textarea" :rows="3" resize="none" show-word-limit maxlength="50" v-model="virForm.content" placeholder="请输入属性值"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </template>
    <template v-slot:actions>
      <div v-if="ruleForm.bizType === 1" style="width: 100%" class="flex_bt">
        <el-checkbox
            v-model="checkAll"
            @change="handleCheckAllProp"
        >
          全选
        </el-checkbox>
        <div>
          <v-btn variant="elevated" class="mg_r_1" @click="handleCancelProp">取消</v-btn>
          <v-btn variant="elevated" color="primary" @click="handleConfirmProp">确定</v-btn>
        </div>
      </div>
      <div v-else-if="ruleForm.bizType === 2 || ruleForm.bizType === 5" style="width: 100%" class="flex_right">
        <div>
          <v-btn variant="elevated" class="mg_r_1" @click="handleCancelVir">取消</v-btn>
          <v-btn variant="elevated" color="primary" @click="handleConfirmVir">确定</v-btn>
        </div>
      </div>
    </template>
  </YTFormDialog>
  <YTFormDialog id="YTFormDialogCostPrice" v-if="openCostPrice" title="添加成本价格" :open="openCostPrice">
    <template v-slot:content>
      <el-form
          ref="costPriceFormRef"
          :model="costPriceForm"
          :rules="costPriceRules"
          label-width="auto"
          class="demo-ruleForm mg_b_3"
          size="large"
          v-loading="loading">
        <el-form-item label="成本名称：" prop="costName">
          <el-input show-word-limit maxlength="20" v-model="costPriceForm.costName" placeholder="请输入成本名称"></el-input>
        </el-form-item>
        <el-form-item label="成本价格：" prop="costPrice">
          <el-input-number :precision="2" :min="0" v-model="costPriceForm.costPrice" placeholder="请输入成本价格">
            <template #prefix>￥</template>
          </el-input-number>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:actions>
      <div>
        <v-btn variant="elevated" class="mg_r_1" @click="handleCancelCostPrice">取消</v-btn>
        <v-btn variant="elevated" color="primary" @click="handleConfirmCostPrice">确定</v-btn>
      </div>
    </template>
  </YTFormDialog>
  <YTCheckPanel
      ref="YTCheckPanelRef"
      v-if="openGroupGoodsList"
      :open="openGroupGoodsList"
      :title="`关联商品`"
      :list="goodsList"
      :hasAll="false"
      :checkedLimit="1"
      :itemPre="ruleForm.bizType === 3"
      @cancel="handlePanelGroupGoodsListClose"
      @confirm="handlePanelGroupGoodsListConfirm"
      @select="handlePanelSelectItem"
      :maxWidth="600"
  >
    <template #top>
      <div>
        <v-select
            ref="tenantListRef"
            v-model="cacheTenant.name"
            :items="tenantListArr"
            item-title="name"
            item-value="tenantId"
            label="商家"
            variant="outlined"
            :no-data-text="'没有更多数据了~'"
            @update:modelValue="handleSelectTenant"
            :loading="tenantLoading"
            placeholder="请选择商家"
            :menu-props="{maxHeight: '550px'}"
            @update:menu="handleClickSelect"
            v-if="ruleForm.innerCategoryType === 'ENTRY_APPOINTMENT'"
            clearable
        >
          <template v-slot:prepend-item>
            <div class="pd_l_1 pd_r_1 pd_t_1" style="width: 300px">
              <v-text-field
                  v-model="tenantSelectKey"
                  placeholder="请输入商家名称"
                  label="商家名称"
                  variant="outlined"
                  clearable
                  append-inner-icon="mdi-magnify"
                  @click:append-inner="handleGetTenant('search')"
                  @keydown.enter="handleGetTenant('search')"
                  :disabled="tenantLoading"
              ></v-text-field>
            </div>
            <v-divider class="mb-2"></v-divider>
          </template>
          <template v-slot:append-item>
            <v-divider class="mb-2" v-if="memberTotal > 0"></v-divider>
            <YTTablePagination v-show="memberTotal > 0" ref="YTTablePaginationMemberRef" :pageSize="5" :total="memberTotal" @page-change="handleChangeMemberPage"></YTTablePagination>
          </template>
        </v-select>
        <v-text-field
          :disabled="goodsLoading"
          append-inner-icon="mdi-magnify"
          label="商品名称"
          placeholder="请输入商品名称"
          variant="outlined"
          v-model="cacheKeyword"
          @click:append-inner="handlePanelSearchGoods"
          @keyup.enter.native="handlePanelSearchGoods"
        ></v-text-field>
      </div>
    </template>
    <template v-slot:pagination>
      <div class="flex_right text-right pt-2" style="width: 100%;">
        <v-pagination
            v-model="groupGoodsPage"
            :length="Math.ceil(totalGroupGoods / groupGoodsPageSize)"
            :total-visible="6"
            @update:modelValue="handleChangeGroupGoodsPage"
            v-if="totalGroupGoods > 0"
        ></v-pagination>
      </div>
      <div v-if="ruleForm.bizType === 3 && cachePanelItem?.propertyGroupList.length > 0">
        <v-divider style="margin: 20px 0;"></v-divider>
        <div v-for="(item, index) in cachePanelItem.propertyGroupList" :key="`cachePanelItem.propertyGroupList${index}`">
          <el-form-item :label="`${item.groupName}：`">
            <el-checkbox-group class="flex_left" :max="1" v-model="cachePanelItemPropSelect[index]">
              <div class="mg_r_2" v-for="(sonItem, sonIndex) in item.propertyGroupItemList">
                <el-checkbox
                    :key="`${item.groupName}-${sonIndex}-${sonItem.propertyGroupItemId}`"
                    :label="sonItem.propertyName"
                    :value="sonItem.propertyGroupItemId"
                />
              </div>
            </el-checkbox-group>
          </el-form-item>
        </div>
      </div>
    </template>
  </YTCheckPanel>
  <el-dialog
      v-model="openStoreIdsList"
      title="关联驿站"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">关联驿站</div>
    </template>
    <el-form
        ref="YTCheckPanelStoreIdsRef"
        style="max-width: 100%;"
        :model="dialogForm"
        :rules="dialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="storeIdsLoading"
        id="dialogForm"
    >
      <el-form-item label="搜索：">
        <div class="flex">
          <el-select
              style="width: 350px"
              v-model="dialogForm.cacheStore"
              filterable
              remote
              reserve-keyword
              placeholder="选择驿站"
              remote-show-suffix
              :remote-method="(keyword) => handleGetStoreList(keyword, 'search')"
              :loading="storeIdsStoreLoading"
              @change="handlePanelSelectStoreIds"
              class="mg_r_1"
          >
            <el-option
                v-for="item in storeIdsList"
                :key="item.storeId"
                :label="`${item.name}`"
                :value="item.storeId"
            />
            <template #footer>
              <YTTablePagination ref="YTTablePaginationDialogStoreRef" :totalVisible="5" :pageSize="5" :total="dialogStoreTotal" @page-change="handleChangeDialogStorePage"></YTTablePagination>
            </template>
          </el-select>
          <v-btn color="success" @click="handleAddStore2List">添加</v-btn>
        </div>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item label="驿站：">
        <div class="flex_left flex_warp">
          <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in dialogForm.storeIds" :key="`storeIds${tag.name}-${tagIndex}`" closable type="success" @close="handleCloseDialogStoreTags(tagIndex)">
            {{ tag.name }}
          </el-tag>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="handlePanelStoreIdsListClose">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handlePanelStoreIdsListConfirm">确定</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
  <el-dialog
      v-model="openSalesChannel"
      width="600"
      style="padding: 20px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div v-if="openSalesChannelType === 'CLUB'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售俱乐部</div>
      <div v-else-if="openSalesChannelType === 'STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售门店</div>
      <div v-else-if="openSalesChannelType === 'ONLINE_STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售网店</div>
      <div v-else-if="openSalesChannelType === 'VENUE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售场地</div>
      <div v-else-if="openSalesChannelType === 'BIKE_STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售车店</div>
      <div v-else-if="openSalesChannelType === 'THERAPIST_STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售理疗服务商</div>
      <div v-else-if="openSalesChannelType === 'PHOTOGRAPHY_STORE'" style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择销售摄影服务商</div>
    </template>
    <el-form
        ref="YTCheckPanelSalesChannelRef"
        style="max-width: 100%;"
        :model="channelDialogForm"
        :rules="channelDialogRules"
        label-width="auto"
        class="demo-ruleForm"
        size="large"
        status-icon
        v-loading="salesChannelLoading"
        id="dialogForm"
    >
      <el-form-item label="搜索：">
        <div class="flex">
          <el-select
              style="width: 350px"
              v-model="channelDialogForm.cacheSalesChannel"
              filterable
              remote
              reserve-keyword
              placeholder="选择"
              remote-show-suffix
              :remote-method="(keyword) => handleGetSalesChannel(keyword, 'search')"
              :loading="salesChannelLoading"
              @change="handleSalesChannel"
              class="mg_r_1"
          >
            <el-option
                v-for="item in salesChannelList"
                :key="item.storeId"
                :label="`${item.name}`"
                :value="item.storeId"
            />
            <template #footer>
              <YTTablePagination ref="YTTablePaginationDialogSalesChannelRef" :totalVisible="5" :pageSize="5" :total="dialogSalesChannelTotal" @page-change="handleChangeDialogSalesChannelPage"></YTTablePagination>
            </template>
          </el-select>
          <v-btn color="success" @click="handleAddSalesChannel2List">添加</v-btn>
        </div>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item label="已选择：">
        <div class="flex_left flex_warp">
          <el-tag class="mg_r_1 mg_b_1" v-for="(tag, tagIndex) in channelDialogForm.cacheSalesChannelList" :key="`storeIds${tag.storeName}-${tagIndex}`" closable type="success" @close="handleCloseDialogStoreTags(tagIndex)">
            {{ tag.name }}
          </el-tag>
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="handleSalesChannelClose">取消</v-btn>
              <v-btn class="mg_l_1" color="primary" variant="elevated" @click="handlePanelSalesChannelConfirm">确定</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
  <el-drawer
      :title="``"
      v-model="drawer"
      direction="rtl"
      :close="handleCloseDrawer"
      style="text-align: left"
      :size="'100%'"
  >
    <h2 class="mg_b_3" style="text-align: center;font-size: 32px;">新建商品属性</h2>
    <el-form
        ref="drawerRuleFormRef"
        :model="drawerRuleForm"
        :rules="drawerRules"
        label-width="auto"
        class="demo-ruleForm mg_b_3"
        size="large"
        v-loading="drawerLoading">
      <el-form-item label="属性项名称：" prop="groupName">
        <el-tabs
            v-model="groupNameTab"
            type="card"
            class="demo-tabs"
        >
          <el-tab-pane label="中文" name="zh">
            <el-input maxlength="60" show-word-limit size="large" style="width: 350px" v-model="drawerRuleForm.groupName" placeholder="请输入商品属性项名称" />
          </el-tab-pane>
          <el-tab-pane label="English" name="en">
            <el-input maxlength="150" show-word-limit size="large" style="width: 350px" v-model="drawerRuleForm.groupNameEn" placeholder="Please enter the name of the commodity attribute item" />
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
    </el-form>
    <v-data-table
        class="mg_b_1"
        :headers="drawerHeaders"
        :items="drawerTableData"
        :loading="drawerLoading"
        :no-data-text="'没有更多数据了~'"
        no-filter
        hover
    >
      <template v-slot:loading>
        <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
      </template>

      <template v-slot:item.number="{ index }">
        {{index + 1}}
      </template>

      <template v-slot:item.image="{ item }">
        <div v-if="item.image" class="flex_left">
          <el-avatar shape="square" :size="80" fit="contain" :src="item.image" />
        </div>
        <div v-else>
          -
        </div>
      </template>

      <template v-slot:item.orderBy="{ index }">
        <div class="flex_left">
          <v-row>
            <v-col cols="6">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="上移"
                  placement="left">
                <v-icon class="cursor-pointer" @click="handlePropUp(index)" icon="mdi-arrow-up-bold"></v-icon>
              </el-tooltip>
            </v-col>
            <v-col cols="6">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="下移"
                  placement="right">
                <v-icon class="cursor-pointer" @click="handlePropDown(index)" icon="mdi-arrow-down-bold"></v-icon>
              </el-tooltip>
            </v-col>
          </v-row>
        </div>
      </template>

      <template v-slot:item.controls="{ item, index }">
        <div class="flex_center">
<!--          <el-tooltip-->
<!--              class="box-item"-->
<!--              effect="dark"-->
<!--              content="编辑"-->
<!--              placement="left">-->
<!--            <v-icon icon="mdi-file-edit-outline" color="primary" size="small" @click="editPropValue(item)"></v-icon>-->
<!--          </el-tooltip>-->
          <el-popconfirm @confirm="handleRemove(index)" :title="`删除后，收银开单商品将无法选择该属性值`">
            <template #reference>
              <div>
                <el-tooltip
                    class="box-item"
                    effect="dark"
                    content="删除"
                    placement="right">
                  <v-icon color="error" class="cursor-pointer" icon="mdi-close" v-if="drawerRuleForm.goodsCount === 0"></v-icon>
                </el-tooltip>
              </div>
            </template>
            <template #actions="{ confirm, cancel }">
              <div class="flex_bt">
                <v-btn size="small" @click="cancel">取消</v-btn>
                <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
              </div>
            </template>
          </el-popconfirm>
        </div>
      </template>
      <template v-slot:bottom>

      </template>
    </v-data-table>
    <div class="flex_center">
      <v-btn class="mg_b_2" color="success" @click="handleDrawerDialogAddProp">新增属性值</v-btn>
    </div>
    <template #footer>
      <v-row>
        <v-col cols="12">
          <v-row>
            <v-col cols="4">
              <v-btn @click="handleDrawerClose">取消</v-btn>
            </v-col>
            <v-col cols="4">
              <v-btn color="primary" @click="handleDrawerSubmit">保存</v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </template>
  </el-drawer>
  <YTFormDialog :open="drawerOpen" title="新增属性值" :max-width="800">
    <template v-slot:content="{form}">
      <el-form
          ref="drawerDialogRuleFormRef"
          :model="drawerDialogRuleForm"
          :rules="drawerDialogRules"
          label-width="auto"
          class="demo-ruleForm"
          size="large"
          v-loading="loading">
        <el-form-item label="属性值名称：" prop="propertyName">
          <el-tabs
              v-model="propertyNameTab"
              type="card"
              class="demo-tabs"
          >
            <el-tab-pane label="中文" name="zh">
              <el-input style="width: 250px" v-model="drawerDialogRuleForm.propertyName" placeholder="请输入商品属性值名称" />
            </el-tab-pane>
            <el-tab-pane label="English" name="en">
              <el-input style="width: 250px" v-model="drawerDialogRuleForm.propertyNameEn" placeholder="Please enter the name of the commodity attribute value" />
            </el-tab-pane>
          </el-tabs>
        </el-form-item>
        <el-form-item label="加价：" prop="addPrice">
          <el-input-number :precision="2" :min="0" style="width: 250px" v-model="drawerDialogRuleForm.addPrice" placeholder="请输入加价金额" />
        </el-form-item>
        <el-form-item label="商品属性图片：" prop="image">
          <BoxUpload v-if="isShowUpload" ref="drawerDialogBoxUploadRef" :ali-oss-path="'PROPERTY_ITEM'" :width="800" :height="800" :limit="1" :file-size="1" @progress="drawerDialogLoading = true" @remove="handleDrawerDialogRemove" @success="handleDrawerDialogSuccess"></BoxUpload>
        </el-form-item>
      </el-form>
    </template>
    <template v-slot:actions="{form}">
      <v-row>
        <v-col cols="5" offset="7">
          <v-btn class="mg_r_2" color="primary" variant="elevated" @click="submitDialog(1)">确定</v-btn>
          <v-btn class="mg_r_2" color="success" variant="elevated" @click="submitDialog(2)">确定并继续新增</v-btn>
          <v-btn variant="elevated" @click="closeDialog">取消</v-btn>
        </v-col>
      </v-row>
    </template>
  </YTFormDialog>
  <YTCheckPanel
      ref="YTPropertyGroupItemCheckPanelRef"
      v-if="openPropertyGroupList"
      :open="openPropertyGroupList"
      :title="`选择商品属性`"
      :list="propertyGroupItemList"
      :hasAll="false"
      :checkedLimit="1"
      @cancel="handlePanelPropertyGroupItemListClose"
      @confirm="handlePanelPropertyGroupItemListConfirm"
      @select="handlePanelPropertyGroupItemSelectItem"
      :maxWidth="600"
      labelKey="groupName"
      valueKey="propertyGroupId"
  >
    <template #top>
      <div>
        <v-text-field
            :disabled="propertyGroupItemLoading"
            append-inner-icon="mdi-magnify"
            label="属性项名称"
            placeholder="请输入属性项"
            variant="outlined"
            v-model="cacheKeyword"
            @click:append-inner="handleSearchPropertyGroup"
            @keyup.enter.native="handleSearchPropertyGroup"
        ></v-text-field>
      </div>
    </template>
    <template v-slot:pagination>
      <div class="flex_right text-right pt-2" style="width: 100%;">
        <v-pagination
            v-model="propertyGroupItemPage"
            :length="Math.ceil(totalPropertyGroupItem / propertyGroupItemPageSize)"
            :total-visible="6"
            @update:modelValue="handleChangePropertyGroupItemPage"
            v-if="totalPropertyGroupItem > 0"
        ></v-pagination>
      </div>
    </template>
  </YTCheckPanel>
  <YTFormDialog v-if="openPropertyGroupItemList" :title="drawerRuleForm.groupName" :open="openPropertyGroupItemList">
    <template v-slot:content>
      <div>
        <el-checkbox-group v-model="cacheSelect">
          <div v-for="(item, index) in cacheProp.propertyGroupItemList">
            <el-checkbox @change="handleCheckAll" :key="`sonItemProp${item.propertyName}${index}`" :label="item.propertyName" :value="item.propertyGroupItemId"/>
          </div>
          <v-divider style="margin: 20px 0;"></v-divider>
        </el-checkbox-group>
      </div>
    </template>
    <template v-slot:actions>
      <div style="width: 100%" class="flex_bt">
        <el-checkbox
            v-model="checkAll"
            @change="handleCheckAllProp"
        >
          全选
        </el-checkbox>
        <div>
          <v-btn variant="elevated" class="mg_r_1" @click="handleCancelPropertyGroupItemList">取消</v-btn>
          <v-btn variant="elevated" color="primary" @click="handleConfirmPropertyGroupItemList">确定</v-btn>
        </div>
      </div>
    </template>
  </YTFormDialog>
</template>

<style lang="scss" scoped>
.btn_check {
  width: 28px;
  height: 28px;
  border-radius: 36px;
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  z-index: 100;
  background-color:#4caf50;
  display: flex;
  justify-content: center;
  align-items: center;
}

::marker {
  content: none;
}
.yt_tag_select_box {
  min-width: 240px;
  height: 36px;
  .yt_tag_select_suffix {
    .yt_tag_select_suffix_icon {
      transition: transform 0.2s ease;
    }
    .reverse {
      transform: rotate(180deg);
    }

  }
  .yt_tag_select_placeholder {
    color: #a8abb2;
  }
  .yt_tag_select_tag {
    width: 108px;
    background: #F4F4F5;
    border-radius: 6px;
    box-sizing: border-box;
    padding: 4px 10px;
    font-weight: 400;
    font-size: 13px;
    color: #989BA1;
    margin-right: 5px;
  }
  .yt_tag_select_tag:last-child {
    margin-right: 0;
  }
}

.insurance_form_content {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  display: flex;
  flex-direction: column;
}

.insurance_table_wrap {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  overflow-x: auto;
}

.insurance_table {
  width: 100%;
  max-width: 100%;
}
</style>
